(function(){ try {var elementStyle = document.createElement('style'); elementStyle.appendChild(document.createTextNode(".rg-icon{width:19px;height:19px;vertical-align:0px;fill:currentColor;overflow:hidden}.el-icon-remove,.el-icon-circle-plus{cursor:pointer}.rel-node-peel{clear:both;padding:8px;position:absolute;font-size:14px}.rel-node{text-align:center}.rel-node-shape-1{border-radius:5px}.c-node-text{height:100%;width:100%;display:flex;align-items:center;justify-content:center}.rel-node-shape-1 .c-node-text{padding-left:5px;padding-right:5px}.rel-node-shape-0{width:80px;height:80px;border-radius:50%}.rel-node-type-button{border-radius:25px;color:#00f;cursor:pointer}.rel-node-checked,.rel-node-selected{box-shadow:0 0 10px #fd8b37;animation-timing-function:linear;animation:ACTRGNodeInit 2s}.rel-node-vtree-2{transform-origin:0 0;transform:rotate(30deg) translate(0)}.rel-node-vtree{width:130px;height:45px;text-align:left}.c-btn-open-close{position:absolute;height:100%;width:19px;display:flex;align-items:center;justify-content:center;user-select:none;pointer-events:none}.c-btn-open-close span{width:19px;height:19px;display:inline-block;text-align:center;border-radius:15px;color:#fff;cursor:pointer;font-size:19px;line-height:16px;background-size:100% 100%;pointer-events:all}.c-expanded{background-image:url(data:image/svg+xml;%20charset=utf8,%3Csvg%20t=%221606310217820%22%20viewBox=%220%200%201024%201024%22%20version=%221.1%22%20xmlns=%22http://www.w3.org/2000/svg%22%20p-id=%223373%22%20width=%2232%22%20height=%2232%22%3E%3Cpath%20d=%22M853.333333%20480H544V170.666667c0-17.066667-14.933333-32-32-32s-32%2014.933333-32%2032v309.333333H170.666667c-17.066667%200-32%2014.933333-32%2032s14.933333%2032%2032%2032h309.333333V853.333333c0%2017.066667%2014.933333%2032%2032%2032s32-14.933333%2032-32V544H853.333333c17.066667%200%2032-14.933333%2032-32s-14.933333-32-32-32z%22%20p-id=%223374%22%20fill=%22white%22%3E%3C/path%3E%3C/svg%3E)}.c-collapsed{background-image:url(data:image/svg+xml;%20charset=utf8,%3Csvg%20t=%221606310454619%22%20class=%22icon%22%20viewBox=%220%200%201024%201024%22%20version=%221.1%22%20xmlns=%22http://www.w3.org/2000/svg%22%20p-id=%223662%22%20width=%22128%22%20height=%22128%22%3E%3Cpath%20d=%22M853.333333%20554.666667H170.666667c-23.466667%200-42.666667-19.2-42.666667-42.666667s19.2-42.666667%2042.666667-42.666667h682.666666c23.466667%200%2042.666667%2019.2%2042.666667%2042.666667s-19.2%2042.666667-42.666667%2042.666667z%22%20p-id=%223663%22%20fill=%22white%22%3E%3C/path%3E%3C/svg%3E)}.c-expand-positon-left{margin-top:-8px;margin-left:-25px}.c-expand-positon-right{height:100%;width:100%;justify-content:center}.c-expand-positon-right span{margin-top:-18px;margin-right:-18px;margin-left:100%}.c-expand-positon-bottom{height:100%;width:100%;margin-top:7px;margin-left:-8px;align-items:flex-end;justify-content:center}.c-expand-positon-top{height:18px;width:100%;margin-top:-20px;margin-left:-6px;align-items:flex-end;justify-content:center}@keyframes ACTRGNodeInit{0%{box-shadow:0 0 15px #fd8b37}15%{box-shadow:0 0 1px #2e4e8f}30%{box-shadow:0 0 15px #fd8b37}45%{box-shadow:0 0 1px #2e4e8f}60%{box-shadow:0 0 15px #fd8b37}to{box-shadow:0 0 1px #2e4e8f}}.rel-diy-node{padding:0}.c-rg-line-text[data-v-502a344c]{fill:#888;font-size:12px}.c-rg-line[data-v-502a344c]{z-index:1000;fill-rule:nonzero}.c-rg-line-tool[data-v-502a344c]{stroke-dasharray:5,5,5}.c-rg-line-flash[data-v-502a344c]{-moz-transform:rotate(-89deg) translateX(-190px);animation-timing-function:linear;animation:ACTRGLineChecked-data-v-502a344c 10s}@keyframes ACTRGLineInit-data-v-502a344c{0%{stroke-dashoffset:10px;stroke-dasharray:20,20,20}to{stroke-dashoffset:0;stroke-dasharray:0,0,0}}@keyframes ACTRGLineChecked-data-v-502a344c{0%{stroke-dashoffset:352px}to{stroke-dashoffset:0}}.c-rg-line-checked[data-v-502a344c]{stroke-width:2px;stroke-dasharray:5,5,5;stroke-dashoffset:3px;stroke-linecap:butt;stroke-linejoin:bevel;animation-timing-function:linear;animation:ACTRGLineChecked-data-v-502a344c 10s}.c-rg-line-text[data-v-5924ca84]{fill:#888;font-size:12px}.c-rg-line[data-v-5924ca84]{z-index:1000;fill-rule:nonzero}.c-rg-line-tool[data-v-5924ca84]{stroke-dasharray:5,5,5}.c-rg-line-flash[data-v-5924ca84]{-moz-transform:rotate(-89deg) translateX(-190px);animation-timing-function:linear;animation:ACTRGLineChecked-data-v-5924ca84 10s}@keyframes ACTRGLineInit-data-v-5924ca84{0%{stroke-dashoffset:10px;stroke-dasharray:20,20,20}to{stroke-dashoffset:0;stroke-dasharray:0,0,0}}@keyframes ACTRGLineChecked-data-v-5924ca84{0%{stroke-dashoffset:352px}to{stroke-dashoffset:0}}.rel-map[data-v-6e119aea]{background-color:#fff;overflow:hidden;cursor:default;user-select:none}.rel-map-background-norepeat[data-v-6e119aea]{background-repeat:no-repeat;background-position:right bottom}.rel-nodediv-for-webkit[data-v-6e119aea]{position:absolute;width:100%;top:0;left:0;z-index:1000}.rel-map-canvas[data-v-6e119aea]{position:relative;top:0;left:0;border:0px;z-index:3}svg[data-v-6e119aea]{height:100%;width:100%}.rel-linediv[data-v-6e119aea]{position:absolute;z-index:900;width:100%;top:0;left:0;--stroke:url(#lineStyle);--markerEnd:url(#arrow-default);--markerStart:url(#start-arrow-default);--markerEndChecked:url(#arrow-checked);--markerStartChecked:url(#start-arrow-checked)}.rel-linediv svg[data-v-6e119aea]{overflow:visible}.rel-map[data-v-6e119aea] img{-webkit-user-drag:none;-webkit-user-select:none}.c-setting-panel[data-v-f2fe86d4]{--height:300px;--width:200px;width:300px;height:200px;position:absolute;margin-left:10px;margin-top:5px;font-size:12px;color:#3a5bb2;padding:60px 10px 10px;overflow:hidden;box-shadow:0 0 5px #999;border-radius:5px;z-index:1000;background-color:#fff;border:#999999 solid 1px}.c-setting-panel-button[data-v-f2fe86d4]{height:35px;width:35px;font-size:8px;line-height:35px;text-align:center;border-radius:50%;position:absolute;margin-left:25px;margin-top:20px;background-color:#3a5bb2;color:#fff;cursor:pointer;z-index:1001;box-shadow:0 0 8px #999}.c-setting-panel-button[data-v-f2fe86d4]:hover{box-shadow:0 0 20px #ffa20a;border:#ffffff solid 1px;color:#ffa20a;-moz-transform:rotate(-89deg) translateX(-190px);animation-timing-function:linear;animation:flashButton-data-v-f2fe86d4 2s infinite}.c-fixedLayout[data-v-f2fe86d4]{position:fixed;top:125px}@keyframes flashButton-data-v-f2fe86d4{0%{box-shadow:0 0 8px #2e4e8f}30%{box-shadow:0 0 20px #ffa20a}to{box-shadow:0 0 8px #2e4e8f}}.c-debug-tools-row[data-v-f2fe86d4]{text-align:left}.c-mini-graph[data-v-4c48557a]{height:100px;width:100px;position:absolute;margin-left:60px;margin-top:100px;z-index:999}.c-fixedLayout[data-v-4c48557a]{position:fixed;top:100px}.c-mini-canvas[data-v-4c48557a]{background-color:#aacbff;border:#7BA8FF solid 1px;opacity:.8;position:relative}.c-mini-view[data-v-4c48557a]{background-color:#f5a565;border:#C03639 solid 1px;opacity:.5;color:#fff;font-size:14px;text-align:center;display:flex;align-items:center;justify-content:center;position:absolute}.c-mini-node[data-v-4c48557a]{position:absolute;width:2px;height:2px;background-color:#000;border-radius:1px}.rg-icon[data-v-0e337616]{width:16px;height:16px;vertical-align:-3px;fill:currentColor;overflow:hidden}.c-mini-toolbar[data-v-0e337616]{width:44px;position:absolute;margin-top:170px;margin-right:10px;z-index:999;border:#bbbbbb solid 1px;background-color:#fff;box-shadow:0 0 8px #ccc;box-sizing:border-box}.c-fixedLayout[data-v-0e337616]{position:fixed;top:100px}.c-mb-button[data-v-0e337616]{height:44px;width:42px;margin-top:0;background-color:#fff;border-top:#efefef solid 1px;opacity:1;text-align:center;padding-top:3px;cursor:pointer;color:#999;font-size:18px;float:left;box-sizing:border-box;line-height:21px}.c-mb-button .c-mb-text[data-v-0e337616]{display:inline-block;height:14px;width:42px;font-size:12px;line-height:12px;margin-top:24px;margin-left:-28px;position:absolute;color:#262626}.c-mb-button-on[data-v-0e337616]{background-color:#2e74b5;border-top:#2E4E8F solid 1px;color:#fff}.c-mb-button[data-v-0e337616]:hover{background-color:#2e4e8f;border-top:#2E4E8F solid 1px;color:#fff}.c-mb-button:hover .c-mb-text[data-v-0e337616],.c-mb-button-on .c-mb-text[data-v-0e337616]{color:#fff}.c-mb-button .c-mb-child-panel[data-v-0e337616]{height:46px;position:absolute;margin-top:-26px;background-color:#fff;display:none;border:#bbbbbb solid 1px;box-shadow:0 0 8px #ccc;box-sizing:border-box}.c-mb-button:hover .c-mb-child-panel[data-v-0e337616]{display:block}.c-mb-button .c-mb-button[data-v-0e337616]{height:44px;width:42px;margin:0;border:none}.c-mb-button-c .c-mb-text[data-v-0e337616]{color:#262626!important}.c-mb-button-c:hover .c-mb-text[data-v-0e337616],.c-mb-button-on .c-mb-text[data-v-0e337616]{color:#fff!important}.c-loading-icon[data-v-0e337616]{animation:turn-data-v-0e337616 1s linear infinite}@keyframes turn-data-v-0e337616{0%{-webkit-transform:rotate(0deg)}25%{-webkit-transform:rotate(90deg)}50%{-webkit-transform:rotate(180deg)}75%{-webkit-transform:rotate(270deg)}to{-webkit-transform:rotate(360deg)}}")); document.head.appendChild(elementStyle);} catch(e) {console.error('vite-plugin-css-injected-by-js', e);} })();var Pe = Object.defineProperty, Ne = Object.defineProperties;
var Le = Object.getOwnPropertyDescriptors;
var te = Object.getOwnPropertySymbols;
var ze = Object.prototype.hasOwnProperty, $e = Object.prototype.propertyIsEnumerable;
var j = (e, o, t) => o in e ? Pe(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, oe = (e, o) => {
  for (var t in o || (o = {}))
    ze.call(o, t) && j(e, t, o[t]);
  if (te)
    for (var t of te(o))
      $e.call(o, t) && j(e, t, o[t]);
  return e;
}, ne = (e, o) => Ne(e, Le(o));
var p = (e, o, t) => (j(e, typeof o != "symbol" ? o + "" : o, t), t);
import I from "vue";
import D from "screenfull";
import me from "html2canvas";
const ge = "2.0.26";
(function(e) {
  var o, t, n, i, s, a, l = '<svg><symbol id="icon-iconset0444" viewBox="0 0 1024 1024"><path d="M960 682.666667l-106.666667 0C844.8 569.6 763.733333 42.666667 64 42.666667 51.2 42.666667 42.666667 51.2 42.666667 64c0 12.8 8.533333 21.333333 21.333333 21.333333 219.733333 0 377.6 106.666667 465.066667 315.733333 51.2 123.733333 64 236.8 66.133333 281.6L490.666667 682.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333 0 6.4 2.133333 10.666667 6.4 14.933333l234.666667 256c4.266667 4.266667 8.533333 6.4 14.933333 6.4 6.4 0 10.666667-2.133333 14.933333-6.4l234.666667-256c4.266667-4.266667 6.4-8.533333 6.4-14.933333C981.333333 691.2 972.8 682.666667 960 682.666667zM725.333333 928 539.733333 725.333333 618.666667 725.333333c12.8 0 21.333333-8.533333 21.333333-21.333333l0-21.333333c-4.266667-87.466667-38.4-396.8-273.066667-554.666667C755.2 251.733333 804.266667 588.8 810.666667 682.666667l0 21.333333c0 12.8 8.533333 21.333333 21.333333 21.333333l78.933333 0L725.333333 928z"  ></path></symbol><symbol id="icon-iconset0445" viewBox="0 0 1024 1024"><path d="M974.933333 305.066667l-234.666667-256C736 44.8 731.733333 42.666667 725.333333 42.666667c-6.4 0-10.666667 2.133333-14.933333 6.4l-234.666667 256C471.466667 309.333333 469.333333 313.6 469.333333 320c0 12.8 8.533333 21.333333 21.333333 21.333333l104.533333 0c-2.133333 44.8-14.933333 157.866667-66.133333 281.6C441.6 832 283.733333 938.666667 64 938.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333 0 12.8 8.533333 21.333333 21.333333 21.333333 699.733333 0 780.8-526.933333 789.333333-640l106.666667 0c12.8 0 21.333333-8.533333 21.333333-21.333333C981.333333 313.6 979.2 309.333333 974.933333 305.066667zM832 298.666667c-12.8 0-21.333333 8.533333-21.333333 21.333333l0 21.333333c-6.4 93.866667-55.466667 430.933333-443.733333 554.666667 234.666667-157.866667 268.8-467.2 273.066667-554.666667l0-21.333333c0-12.8-8.533333-21.333333-21.333333-21.333333l-78.933333 0L725.333333 96l185.6 202.666667L832 298.666667z"  ></path></symbol><symbol id="icon-yuanquanfenxiang" viewBox="0 0 1024 1024"><path d="M751.148705 578.773799c-61.987796 0-117.066229 30.121018-151.388942 76.488045L398.287145 536.382317c1.991354-10.171664 3.046383-20.673855 3.046383-31.419594 0-18.776645-3.196809-36.817534-9.058306-53.621245l193.486736-107.492176c31.949666 58.566884 94.104261 98.391914 165.386748 98.391914 103.803157 0 188.254571-84.450391 188.254571-188.254571S854.951863 65.73105 751.148705 65.73105c-103.804181 0-188.255595 84.450391-188.255595 188.254571 0 14.246469 1.600451 28.125571 4.613064 41.4746L368.032074 406.279167c-29.841655-39.193651-76.976162-64.544015-129.927141-64.544015-90.004897 0-163.228595 73.223698-163.228595 163.228595 0 90.003873 73.223698 163.228595 163.228595 163.228595 60.882626 0 114.078175-33.510208 142.134161-83.049484L575.173808 700.16452c-7.925507 20.788465-12.280698 43.325761-12.280698 66.86385 0 103.803157 84.450391 188.254571 188.255595 188.254571 103.803157 0 188.254571-84.450391 188.254571-188.254571S854.951863 578.773799 751.148705 578.773799zM751.148705 116.89636c75.590606 0 137.089261 61.498656 137.089261 137.089261s-61.498656 137.089261-137.089261 137.089261c-75.591629 0-137.090285-61.498656-137.090285-137.089261S675.557076 116.89636 751.148705 116.89636zM238.105956 617.026008c-61.791321 0-112.063285-50.27094-112.063285-112.063285 0-61.791321 50.27094-112.063285 112.063285-112.063285s112.063285 50.27094 112.063285 112.063285C350.168218 566.755068 299.897278 617.026008 238.105956 617.026008zM751.148705 904.117632c-75.591629 0-137.090285-61.498656-137.090285-137.089261s61.498656-137.089261 137.090285-137.089261c75.590606 0 137.089261 61.498656 137.089261 137.089261S826.739311 904.117632 751.148705 904.117632z"  ></path></symbol><symbol id="icon-hj2" viewBox="0 0 1024 1024"><path d="M963.66 256.607c0-0.244 0-0.607-0.126-0.851 0-0.369 0-0.614-0.119-0.978 0-0.369-0.119-0.733-0.119-1.104 0-0.244 0-0.487-0.126-0.725 0-0.369-0.119-0.859-0.244-1.222 0-0.244-0.119-0.369-0.119-0.613-0.126-0.365-0.126-0.852-0.245-1.216 0-0.244-0.126-0.369-0.126-0.613-0.119-0.365-0.244-0.734-0.364-1.222-0.126-0.244-0.126-0.49-0.244-0.609l-0.369-1.095c-0.119-0.245-0.119-0.49-0.244-0.734-0.121-0.369-0.245-0.613-0.365-0.978-0.126-0.244-0.244-0.613-0.369-0.851-0.119-0.244-0.238-0.613-0.364-0.859-0.119-0.364-0.244-0.607-0.364-0.977l-0.371-0.734c-0.119-0.364-0.364-0.725-0.487-0.971-0.119-0.245-0.244-0.371-0.364-0.614-0.244-0.364-0.369-0.733-0.614-1.097-0.119-0.126-0.244-0.369-0.364-0.487l-0.733-1.097c-0.119-0.126-0.244-0.369-0.365-0.487-0.244-0.369-0.487-0.733-0.733-0.978-0.126-0.244-0.244-0.369-0.487-0.613-0.245-0.238-0.49-0.607-0.734-0.851-0.244-0.245-0.487-0.49-0.607-0.734-0.244-0.244-0.369-0.487-0.614-0.733-0.851-0.972-1.829-1.83-2.681-2.682-0.245-0.244-0.49-0.369-0.734-0.614-0.244-0.244-0.487-0.487-0.733-0.607-0.245-0.244-0.614-0.487-0.859-0.733-0.238-0.121-0.364-0.365-0.607-0.49-0.365-0.244-0.734-0.487-0.978-0.733-0.119-0.119-0.364-0.244-0.487-0.365l-1.097-0.733c-0.119-0.119-0.364-0.244-0.487-0.364-0.365-0.244-0.734-0.369-1.097-0.614-0.244-0.119-0.369-0.244-0.613-0.364-0.365-0.126-0.734-0.369-0.972-0.487l-0.734-0.369c-0.369-0.121-0.613-0.245-0.977-0.365-0.244-0.126-0.614-0.244-0.859-0.369-0.244-0.119-0.607-0.238-0.851-0.364-0.365-0.119-0.609-0.244-0.978-0.364-0.244-0.126-0.487-0.126-0.733-0.245l-1.097-0.369c-0.244-0.119-0.487-0.119-0.609-0.244-0.369-0.119-0.733-0.244-1.22-0.364-0.245 0-0.371-0.126-0.614-0.126-0.364-0.119-0.851-0.244-1.216-0.244-0.244 0-0.487-0.121-0.613-0.121-0.364-0.126-0.852-0.126-1.222-0.244-0.244 0-0.482-0.126-0.725-0.126-0.369 0-0.734-0.119-1.104-0.119-0.364 0-0.607 0-0.978-0.126-0.244 0-0.607 0-0.851-0.119h-242.407c-21.604 0-39.062 17.456-39.062 39.062 0 21.604 17.458 39.055 39.062 39.055h146.102l-3.171 3.177-217.27 217.265 0.369 0.369-49.676 49.676-155.87-155.87c-7.694-7.689-17.827-11.472-27.953-11.472-10.13-0.126-20.263 3.659-27.952 11.472l-282.446 282.322c-15.258 15.258-15.258 40.041 0 55.298 15.258 15.258 40.033 15.258 55.291 0l255.108-255.11 155.746 155.751c7.813 7.815 17.945 11.593 28.076 11.474 10.126 0.119 20.382-3.659 28.070-11.474l182.964-182.969c0.734-0.734 1.347-1.342 1.956-2.075l111.564-111.564v146.109c0 21.604 17.451 39.060 39.055 39.060s39.062-17.456 39.062-39.060v-235.085c0-0.244 0.126-0.49 0.126-0.614 0-0.244 0.119-0.487 0.119-0.733 0-0.364 0.119-0.734 0.119-1.097s0-0.607 0.126-0.977c0-0.245 0-0.609 0.119-0.852-0.122-1.466-0.122-2.807-0.122-4.030v0zM963.66 256.607z"  ></path></symbol><symbol id="icon-circleyuanquan" viewBox="0 0 1024 1024"><path d="M150.1184 150.1184C250.2656 50.0736 370.8928 0 512 0c141.1072 0 261.7344 50.0736 361.8816 150.1184C973.9264 250.2656 1024 370.8928 1024 512c0 141.2096-50.0736 261.8368-150.1184 361.8816C773.7344 973.9264 653.1072 1024 512 1024c-141.1072 0-261.7344-50.0736-361.8816-150.1184C50.0736 773.8368 0 653.2096 0 512 0 370.8928 50.0736 250.2656 150.1184 150.1184zM512 41.8816c-85.2992 0-164.1472 20.8896-236.3392 62.7712C203.4688 146.432 146.432 203.4688 104.6528 275.6608 62.7712 347.9552 41.8816 426.7008 41.8816 512c0 129.6384 45.9776 240.4352 137.8304 332.288C271.5648 936.2432 382.3616 982.1184 512 982.1184c129.6384 0 240.4352-45.8752 332.288-137.8304C936.2432 752.4352 982.1184 641.6384 982.1184 512c0-129.6384-45.9776-240.3328-137.8304-332.288C752.4352 87.7568 641.6384 41.8816 512 41.8816zM512 256c-36.1472 0-70.144 7.0656-102.1952 20.8896C377.856 290.9184 349.4912 309.3504 324.9152 332.288c-22.9376 24.576-41.472 52.9408-55.3984 84.8896S248.6272 483.328 248.6272 519.3728c0 36.1472 6.9632 70.144 20.8896 102.1952s32.4608 60.3136 55.3984 84.8896C349.4912 729.4976 377.856 747.9296 409.8048 761.856 441.856 775.7824 475.8528 782.7456 512 782.7456c36.1472 0 70.144-6.9632 102.1952-20.8896C646.144 747.9296 674.5088 729.4976 699.0848 706.4576c22.9376-24.576 41.472-52.9408 55.3984-84.8896s20.8896-66.048 20.8896-102.1952c0-36.0448-6.9632-70.144-20.8896-102.1952S722.0224 356.9664 699.0848 332.288C674.5088 309.3504 646.144 290.9184 614.1952 276.8896 582.144 263.0656 548.1472 256 512 256z"  ></path></symbol><symbol id="icon-bhjlink" viewBox="0 0 1024 1024"><path d="M901.920618 465.785468c-50.993571 0-94.522533 32.698367-110.688942 78.273953L702.244627 544.059421c1.764013-10.590222 2.890616-21.423121 2.890616-32.694527 0-72.177856-40.480145-134.923579-99.898281-166.857822l34.099901-112.776268c8.829281 2.126492 18.1347 3.327588 27.724265 3.327588 64.833817 0 117.472367-52.597848 117.472367-117.589097C784.532727 52.594008 731.894177 0 667.06036 0c-64.911381 0-117.509229 52.594008-117.509229 117.470063 0 49.305587 30.248562 91.349307 73.177745 108.842756l-33.419485 110.692013c-22.548956-9.588797-47.462473-14.807112-73.540224-14.807112-49.18732 0-93.841349 18.658451-127.540374 49.309426L213.348053 196.583401l-1.886119 2.008226c19.940183-21.103648 32.256788-49.588197 32.256788-81.003297 0-64.872983-52.517212-117.470063-117.470063-117.470063-64.913685 0-117.511533 52.59708-117.511533 117.470063 0 65.034255 52.59708 117.592169 117.511533 117.592169 31.412796 0 59.898881-12.358075 80.921125-32.335888l-6.179038 6.056931 174.960609 174.879973c-30.729308 33.66293-49.506025 78.47516-49.506025 127.661712 0 43.008283 14.401627 82.685138 38.593258 114.501114l-149.845117 120.999625c-21.503757-28.044506-55.285722-46.218372-93.357532-46.218372-64.874519 0-117.430897 52.719186-117.430897 117.592169 0 64.833049 52.556378 117.470063 117.430897 117.470063 64.872983 0 117.549163-52.637014 117.549163-117.470063 0-20.541499-5.335813-39.878062-14.602834-56.68956l151.369526-122.203792c34.584487 37.633303 84.29095 61.384123 139.618142 61.384123 28.082136 0 54.602234-6.057699 78.553492-17.091805l52.716114 119.514383c-35.585143 20.222026-59.497236 58.335306-59.497236 102.106945 0 64.912149 52.637014 117.549163 117.592169 117.549163 64.872983 0 117.388659-52.637014 117.388659-117.549163 0-64.833049-52.516444-117.513069-117.388659-117.513069-15.047485 0-29.248673 2.929782-42.446133 7.903885l-52.798286-120.034294c42.807844-24.554878 75.182898-65.518073 88.46253-114.221576l88.222926 0c-1.405374 7.018422-1.96522 14.241123-1.96522 21.743362 0 64.872983 52.557914 117.509997 117.387123 117.509997 64.995089 0 117.596009-52.637014 117.596009-117.509997C1019.508947 518.383316 966.994039 465.785468 901.920618 465.785468L901.920618 465.785468zM901.920618 465.785468"  ></path></symbol><symbol id="icon-lianjie_connecting5" viewBox="0 0 1024 1024"><path d="M801.25952 251.74016l-28.9792-28.99968-150.79424 150.8352-35.1232-35.10272-99.14368 99.16416 99.14368 99.16416 99.16416-99.16416-35.10272-35.1232zM487.19872 476.8768l-29.94176 29.94176-19.61984-19.61984-99.16416 99.16416 35.10272 35.1232-150.8352 150.79424 28.95872 28.95872 150.8352-150.79424 35.10272 35.10272 99.14368-99.14368-19.61984-19.64032 29.96224-29.96224-59.92448-59.92448z m-15.48288 44.4416l15.4624-15.4624 30.98624 30.98624-15.4624 15.44192-30.98624-30.96576z" fill="" ></path></symbol><symbol id="icon-xiazai" viewBox="0 0 1024 1024"><path d="M840.5 900.3h-657c-16.5 0-29.9 13.4-29.9 29.9s13.4 29.9 29.9 29.9h657.1c16.5 0 29.9-13.4 29.9-29.9-0.1-16.6-13.5-29.9-30-29.9zM631.5 123.7V541.8H763.1L512 769.9l-251.2-228h131.7V123.7h239m0-59.7h-239c-33 0-59.7 26.7-59.7 59.7v358.4H183.5c-26.6 0-39.9 32.2-21.1 51l328.5 298.2c5.8 5.8 13.5 8.7 21.1 8.7s15.3-2.9 21.1-8.7l328.5-298.2c18.8-18.8 5.5-51-21.1-51H691.2V123.7c0-33-26.7-59.7-59.7-59.7z"  ></path></symbol><symbol id="icon-ico_reset" viewBox="0 0 1024 1024"><path d="M925.97087933 277.33133334a479.997 479.997 0 1 0 54.33566 255.9984H916.05094133a415.9974 415.9974 0 1 1-64.191599-255.9984h74.047537z"  ></path><path d="M978.64255033 61.01268534L725.33213333 371.09074734h297.59814z"  ></path></symbol><symbol id="icon-fangda" viewBox="0 0 1024 1024"><path d="M768 448a320 320 0 1 0-320 320 320 320 0 0 0 320-320z m64 0A384 384 0 1 1 448 64a384 384 0 0 1 384 384z"  ></path><path d="M681.28 726.72a32 32 0 0 1 45.44-45.44l160 160a32 32 0 0 1-45.44 45.44zM320 480a32 32 0 0 1 0-64h256a32 32 0 0 1 0 64z"  ></path><path d="M480 576a32 32 0 0 1-64 0V320a32 32 0 0 1 64 0z"  ></path></symbol><symbol id="icon-zidong" viewBox="0 0 1024 1024"><path d="M131.3 363.3c-19.2 47.3-28.9 97.3-28.9 148.7 0 51.3 9.7 101.3 28.9 148.7 7 17.2 15.1 33.8 24.3 49.7l15.8-49.1 42.8 13.8-39.8 123.8-42.8-13.9-80.9-26 13.8-42.8 52.3 16.8c-98-168.4-74.8-387.9 69.4-532.1C342.4 44.7 586.9 30.5 759.1 158.3l-32.2 32.2c-25.1-18-52.1-32.9-80.9-44.6-47.3-19.2-97.3-28.9-148.7-28.9-51.3 0-101.3 9.7-148.7 28.9-49 19.9-92.9 49.1-130.6 86.8s-66.9 81.7-86.7 130.6z m828.3-60.2l13.8-42.8-80.9-26-42.8-13.8-39.8 123.8 42.8 13.8 15-46.7c9.8 16.6 18.4 34 25.8 52.1 19.2 47.3 28.9 97.3 28.9 148.7 0 51.3-9.7 101.3-28.9 148.7-19.9 49-49.1 92.9-86.8 130.6C768.9 829 725 858.2 676 878.1c-47.3 19.2-97.3 28.9-148.7 28.9-51.3 0-101.3-9.7-148.7-28.9-28.8-11.7-55.9-26.6-80.9-44.6l-32.2 32.2c126.3 93.7 382.6 147.7 572.9-42.6 145.8-145.8 167.9-368.6 66.1-537.7l55.1 17.7zM474 241.2L295 730.4h64.8l50.5-148.2h195.3l54 148.2h70.3L539.6 241.2H474z m-45.9 288.3L479.8 386c11-30.9 19.4-62.1 25.4-93.4 6.9 26 17.9 59.9 32.8 101.5l48.2 135.5H428.1z" fill="" ></path></symbol><symbol id="icon-quanping" viewBox="0 0 1024 1024"><path d="M795.5 192H581c-19.6 0-35.6 15.7-36 35.3-0.4 20.3 16.4 36.7 36.7 36.7h128.4L581 393.1c-14 14-14 36.9 0 50.9s36.9 14 50.9 0L760 315.9v129c0 19.6 15.8 35.6 35.3 36 20.2 0.4 36.7-16.4 36.7-36.7V228.5c0-20.1-16.3-36.5-36.5-36.5zM442.2 760H313.8L443 630.9c14-14 14-36.9 0-50.9s-36.9-14-50.9 0L264 708.1V579c0-19.6-15.8-35.6-35.3-36-20.2-0.4-36.7 16.4-36.7 36.7v215.6c0 20.3 16.4 36.7 36.7 36.7H443c19.6 0 35.6-15.7 36-35.3 0.3-20.3-16.5-36.7-36.8-36.7z"  ></path><path d="M838 136c27.6 0 50 22.4 50 50v652c0 27.6-22.4 50-50 50H186c-27.6 0-50-22.4-50-50V186c0-27.6 22.4-50 50-50h652m0-72H186c-16.4 0-32.4 3.2-47.5 9.6-14.5 6.1-27.6 14.9-38.8 26.1-11.2 11.2-20 24.2-26.1 38.8-6.4 15.1-9.6 31.1-9.6 47.5v652c0 16.4 3.2 32.4 9.6 47.5 6.1 14.5 14.9 27.6 26.1 38.8 11.2 11.2 24.2 20 38.8 26.1 15.1 6.4 31.1 9.6 47.5 9.6h652c16.4 0 32.4-3.2 47.5-9.6 14.5-6.1 27.6-14.9 38.8-26.1 11.2-11.2 20-24.2 26.1-38.8 6.4-15.1 9.6-31.1 9.6-47.5V186c0-16.4-3.2-32.4-9.6-47.5-6.1-14.5-14.9-27.6-26.1-38.8-11.2-11.2-24.2-20-38.8-26.1-15.1-6.4-31.1-9.6-47.5-9.6z"  ></path></symbol><symbol id="icon-lianjieliu" viewBox="0 0 1024 1024"><path d="M280.224 425.856h348.608a29.536 29.536 0 1 0 0-59.072H280.224c-52.448 0-93.152-34.304-93.152-73.856s40.704-73.856 93.152-73.856h140.128C432.096 258.816 468.448 288 512 288s79.904-29.184 91.648-68.928h178.08a29.536 29.536 0 1 0 0-59.072h-179.584C588.896 122.784 553.728 96 512 96s-76.896 26.784-90.112 64H280.224C197.184 160 128 218.272 128 292.928s69.184 132.928 152.224 132.928z"  ></path><path d="M895.936 415.2A96 96 0 1 0 800 512c30.656 0 57.632-14.624 75.2-36.992 10.56 12.064 16.832 26.56 16.832 41.92 0 39.552-40.704 73.856-93.152 73.856H306.016A95.584 95.584 0 0 0 224 544a95.68 95.68 0 0 0-95.232 88.352C89.888 656.224 64 695.424 64 740.928c0 74.656 69.184 132.928 152.224 132.928h241.728A95.808 95.808 0 0 0 544 928a96 96 0 1 0 0-192 95.904 95.904 0 0 0-94.272 78.752H216.224c-52.448 0-93.152-34.304-93.152-73.856 0-17.504 8.32-33.792 21.76-46.72A95.808 95.808 0 0 0 224 736a95.68 95.68 0 0 0 95.008-86.144h479.84c83.072 0 152.224-58.272 152.224-132.928 0.032-41.536-21.824-77.568-55.136-101.728z"  ></path></symbol><symbol id="icon-shuaxin" viewBox="0 0 1024 1024"><path d="M512 919.552c-224.768 0-407.552-182.784-407.552-407.552 0-8.704 0.512-17.408 1.024-26.112l71.68 4.608c-0.512 7.168-0.512 14.336-0.512 21.504 0 185.344 150.528 335.872 335.872 335.872 86.528 0 168.448-32.768 230.912-92.16l49.152 52.224C716.288 880.128 616.96 919.552 512 919.552zM919.552 512h-71.68c0-11.776-0.512-23.552-2.048-35.328-17.92-171.52-161.28-300.544-334.336-300.544-67.584 0-132.096 19.968-187.904 57.344L284.16 174.08c67.072-45.568 145.92-69.632 227.84-69.632 209.408 0 384 156.672 405.504 365.056 1.536 13.824 2.048 28.16 2.048 42.496z" fill="#707070" ></path><path d="M140.288 290.816L28.16 491.52c-3.072 5.12 1.024 11.776 6.656 11.776H258.56c6.144 0 9.728-6.144 6.656-11.776L153.6 290.816c-3.072-5.632-10.752-5.632-13.312 0zM870.4 675.84L758.272 475.136c-3.072-5.12 1.024-11.776 6.656-11.776h223.744c6.144 0 9.728 6.144 6.656 11.776L883.712 675.84c-2.56 5.12-10.24 5.12-13.312 0zM270.336 202.24a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0zM728.576 784.896a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0z" fill="#707070" ></path></symbol><symbol id="icon-resize-" viewBox="0 0 1024 1024"><path d="M410.816 673.514667L230.997333 853.333333H384v85.333334H85.333333V640h85.333334v153.002667l179.818666-179.84 60.330667 60.373333z m-53.632-256L170.666667 230.997333V384H85.333333V85.333333h298.666667v85.333334h-153.002667l186.517334 186.517333-60.330667 60.330667z m234.666667-45.696L793.002667 170.666667H640V85.333333h298.666667v298.666667h-85.333334v-153.002667l-201.152 201.173334-60.330666-60.373334z m67.029333 226.709333L853.333333 793.002667V640h85.333334v298.666667H640v-85.333334h153.002667l-194.474667-194.453333 60.352-60.352z"  ></path></symbol><symbol id="icon-guanxitu" viewBox="0 0 1024 1024"><path d="M209.003789 401.084632l29.749895-44.948211 107.843369 71.464421-29.749895 44.894316zM682.469053 546.600421l-14.551579-51.846737 124.496842-35.031579 14.551579 51.846737zM315.068632 812.840421l-40.367158-35.678316 85.692631-96.902737 40.421053 35.732211zM597.962105 390.251789l-46.672842-26.947368 43.11579-74.64421 46.672842 26.947368zM615.639579 728.764632l41.121684-34.816 83.536842 98.735157-41.121684 34.816z" fill="#444A5C" ></path><path d="M501.221053 765.305263c-118.568421 0-215.578947-97.010526-215.578948-215.578947s97.010526-215.578947 215.578948-215.578948 215.578947 97.010526 215.578947 215.578948-97.010526 215.578947-215.578947 215.578947z m0-377.263158c-91.621053 0-161.684211 70.063158-161.684211 161.684211s70.063158 161.684211 161.684211 161.68421 161.684211-70.063158 161.68421-161.68421-75.452632-161.684211-161.68421-161.684211zM167.073684 452.715789c-59.284211 0-107.789474-48.505263-107.789473-107.789473s48.505263-107.789474 107.789473-107.789474 107.789474 48.505263 107.789474 107.789474-48.505263 107.789474-107.789474 107.789473z m0-161.68421c-32.336842 0-53.894737 21.557895-53.894737 53.894737s21.557895 53.894737 53.894737 53.894737 53.894737-21.557895 53.894737-53.894737-26.947368-53.894737-53.894737-53.894737zM253.305263 948.547368c-59.284211 0-107.789474-48.505263-107.789474-107.789473s48.505263-107.789474 107.789474-107.789474 107.789474 48.505263 107.789474 107.789474-48.505263 107.789474-107.789474 107.789473z m0-161.68421c-32.336842 0-53.894737 21.557895-53.894737 53.894737s21.557895 53.894737 53.894737 53.894737 53.894737-21.557895 53.894737-53.894737-21.557895-53.894737-53.894737-53.894737zM856.926316 576.673684c-59.284211 0-107.789474-48.505263-107.789474-107.789473s48.505263-107.789474 107.789474-107.789474 107.789474 48.505263 107.789473 107.789474-48.505263 107.789474-107.789473 107.789473z m0-161.68421c-32.336842 0-53.894737 21.557895-53.894737 53.894737s21.557895 53.894737 53.894737 53.894736 53.894737-21.557895 53.894737-53.894736-21.557895-53.894737-53.894737-53.894737zM662.905263 350.315789C592.842105 350.315789 528.168421 291.031579 528.168421 215.578947s59.284211-134.736842 134.736842-134.736842 134.736842 59.284211 134.736842 134.736842-59.284211 134.736842-134.736842 134.736842z m0-215.578947c-43.115789 0-80.842105 37.726316-80.842105 80.842105s37.726316 80.842105 80.842105 80.842106 80.842105-37.726316 80.842105-80.842106-32.336842-80.842105-80.842105-80.842105zM749.136842 921.6c-43.115789 0-80.842105-37.726316-80.842105-80.842105s37.726316-80.842105 80.842105-80.842106 80.842105 37.726316 80.842105 80.842106-37.726316 80.842105-80.842105 80.842105z m0-107.789474c-16.168421 0-26.947368 10.778947-26.947368 26.947369s10.778947 26.947368 26.947368 26.947368 26.947368-10.778947 26.947369-26.947368-10.778947-26.947368-26.947369-26.947369z" fill="#444A5C" ></path></symbol><symbol id="icon-tupian" viewBox="0 0 1024 1024"><path d="M938.666667 553.92V768c0 64.8-52.533333 117.333333-117.333334 117.333333H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V256c0-64.8 52.533333-117.333333 117.333334-117.333333h618.666666c64.8 0 117.333333 52.533333 117.333334 117.333333v297.92z m-64-74.624V256a53.333333 53.333333 0 0 0-53.333334-53.333333H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333333v344.48A290.090667 290.090667 0 0 1 192 597.333333a286.88 286.88 0 0 1 183.296 65.845334C427.029333 528.384 556.906667 437.333333 704 437.333333c65.706667 0 126.997333 16.778667 170.666667 41.962667z m0 82.24c-5.333333-8.32-21.130667-21.653333-43.648-32.917333C796.768 511.488 753.045333 501.333333 704 501.333333c-121.770667 0-229.130667 76.266667-270.432 188.693334-2.730667 7.445333-7.402667 20.32-13.994667 38.581333-7.68 21.301333-34.453333 28.106667-51.370666 13.056-16.437333-14.634667-28.554667-25.066667-36.138667-31.146667A222.890667 222.890667 0 0 0 192 661.333333c-14.464 0-28.725333 1.365333-42.666667 4.053334V768a53.333333 53.333333 0 0 0 53.333334 53.333333h618.666666a53.333333 53.333333 0 0 0 53.333334-53.333333V561.525333zM320 480a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0-64a32 32 0 1 0 0-64 32 32 0 0 0 0 64z"  ></path></symbol><symbol id="icon-juhejiedian" viewBox="0 0 1024 1024"><path d="M533.333333 725.333333a64 64 0 1 1-64 64 64 64 0 0 1 64-64m0-85.333333a149.333333 149.333333 0 1 0 149.333334 149.333333 149.333333 149.333333 0 0 0-149.333334-149.333333z" fill="#666666" ></path><path d="M533.333333 277.333333m-106.666666 0a106.666667 106.666667 0 1 0 213.333333 0 106.666667 106.666667 0 1 0-213.333333 0Z" fill="#666666" ></path><path d="M277.333333 320m-106.666666 0a106.666667 106.666667 0 1 0 213.333333 0 106.666667 106.666667 0 1 0-213.333333 0Z" fill="#666666" ></path><path d="M789.333333 320m-106.666666 0a106.666667 106.666667 0 1 0 213.333333 0 106.666667 106.666667 0 1 0-213.333333 0Z" fill="#666666" ></path><path d="M512 341.333333h42.666667v384h-42.666667z" fill="#666666" ></path><path d="M741.290667 357.504l30.165333 30.165333-225.066667 225.066667-30.165333-30.165333z" fill="#666666" ></path><path d="M558.08 582.016l-30.165333 30.165333-228.693334-228.693333 30.165334-30.165333z" fill="#666666" ></path></symbol><symbol id="icon-ziyuan" viewBox="0 0 1024 1024"><path d="M236.615854 752.86913h-0.484162A241.500139 241.500139 0 0 1 0.538332 527.733676a238.78883 238.78883 0 0 1 64.684079-180.011531 242.081134 242.081134 0 0 1 149.025146-74.367324 298.534454 298.534454 0 0 1 596.003751 25.951097V300.95207a221.262156 221.262156 0 0 1 213.031398 233.075715 222.714643 222.714643 0 0 1-221.262156 209.1581h-3.098639a27.500417 27.500417 0 0 1 0-54.904001h2.711309A167.520145 167.520145 0 0 0 968.378705 531.219644a166.261323 166.261323 0 0 0-166.16449-175.363573 151.058627 151.058627 0 0 0-18.204502 1.065157 27.500417 27.500417 0 0 1-30.211725-30.308558 240.822312 240.822312 0 0 0 1.549319-27.306752 243.727285 243.727285 0 0 0-487.357738 0 27.500417 27.500417 0 0 1-27.403584 27.500417 185.627813 185.627813 0 0 0-185.240484 197.538205A186.30564 186.30564 0 0 0 237.100016 697.965129a27.500417 27.500417 0 0 1-0.484162 54.904001z"  ></path><path d="M513.266174 1021.869686a27.500417 27.500417 0 0 1-27.500417-27.403584v-484.162268a27.500417 27.500417 0 1 1 54.904001 0v484.162268a27.403584 27.403584 0 0 1-27.403584 27.403584z"  ></path><path d="M513.266174 1024a27.500417 27.500417 0 0 1-19.366491-8.037094L342.260061 864.129619a27.500417 27.500417 0 1 1 38.732981-38.732981L513.266174 957.766602l130.530147-130.336483a27.500417 27.500417 0 0 1 38.732981 38.732982L532.632664 1015.962906a27.403584 27.403584 0 0 1-19.36649 8.037094z"  ></path></symbol><symbol id="icon-add-select" viewBox="0 0 1024 1024"><path d="M544 213.333333v266.666667H810.666667v64H544V810.666667h-64V544H213.333333v-64h266.666667V213.333333z"  ></path></symbol><symbol id="icon-sami-select" viewBox="0 0 1024 1024"><path d="M810.666667 480v64H213.333333v-64z"  ></path></symbol><symbol id="icon-icon_shuaxin" viewBox="0 0 1024 1024"><path d="M512 938.666667c-55.371852 0-109.226667-10.903704-159.857778-32.237037-48.924444-20.66963-92.823704-50.251852-130.465185-87.988149-37.736296-37.736296-67.318519-81.635556-87.988148-130.465185-21.428148-50.631111-32.237037-104.391111-32.237037-159.857777s10.903704-109.226667 32.237037-159.857778c20.66963-48.924444 50.251852-92.823704 87.988148-130.465185 37.736296-37.736296 81.635556-67.318519 130.465185-87.988149 50.631111-21.428148 104.391111-32.237037 159.857778-32.237037 63.81037 0 125.060741 14.222222 181.854815 42.382223 54.139259 26.832593 102.684444 66.085926 140.325926 113.682963 7.300741 9.197037 5.783704 22.660741-3.508148 29.961481-9.197037 7.300741-22.660741 5.783704-29.961482-3.508148-70.257778-88.936296-175.502222-139.946667-288.711111-139.946667-202.808889 0-367.881481 165.072593-367.881481 367.881482s165.072593 367.881481 367.881481 367.881481 367.881481-165.072593 367.881481-367.881481c0-11.757037 9.576296-21.333333 21.333334-21.333334S922.548148 516.361481 922.548148 528.118519c0 55.371852-10.903704 109.226667-32.237037 159.857777-20.66963 48.924444-50.251852 92.823704-87.988148 130.465185-37.736296 37.736296-81.635556 67.318519-130.465185 87.988149-50.631111 21.428148-104.485926 32.237037-159.857778 32.237037z"  ></path><path d="M817.398519 308.242963c-11.757037 0-21.333333-9.576296-21.333334-21.333333V106.666667c0-11.757037 9.576296-21.333333 21.333334-21.333334s21.333333 9.576296 21.333333 21.333334v180.242963c0 11.757037-9.481481 21.333333-21.333333 21.333333z"  ></path><path d="M817.398519 308.242963H637.155556c-11.757037 0-21.333333-9.576296-21.333334-21.333333s9.576296-21.333333 21.333334-21.333334h180.242963c11.757037 0 21.333333 9.576296 21.333333 21.333334s-9.481481 21.333333-21.333333 21.333333z"  ></path></symbol><symbol id="icon-lianjiezhong" viewBox="0 0 1024 1024"><path d="M883.396923 298.141538a99.721846 99.721846 0 0 1-142.414769 0 103.187692 103.187692 0 0 1 0-144.423384 99.721846 99.721846 0 0 1 142.414769 0 103.187692 103.187692 0 0 1 0 144.423384zM285.144615 760.438154a87.276308 87.276308 0 0 0-124.652307 0 90.269538 90.269538 0 0 0 0 126.385231c34.422154 34.894769 90.230154 34.894769 124.652307 0a90.269538 90.269538 0 0 0 0-126.424616z m482.579693 108.307692a64.472615 64.472615 0 0 1 0-90.269538 62.345846 62.345846 0 0 1 89.00923 0c24.576 24.930462 24.576 65.378462 0 90.269538a62.345846 62.345846 0 0 1-89.00923 0zM294.006154 298.141538a103.187692 103.187692 0 0 0 0-144.423384 99.721846 99.721846 0 0 0-142.454154 0 103.187692 103.187692 0 0 0 0 144.423384 99.721846 99.721846 0 0 0 142.454154 0z m324.214154-196.01723c0 56.438154-45.095385 102.163692-100.745846 102.163692-55.611077 0-100.706462-45.725538-100.706462-102.163692C416.768 45.725538 461.863385 0 517.474462 0c55.650462 0 100.745846 45.725538 100.745846 102.124308zM517.474462 870.793846c-41.747692 0-75.539692 34.264615-75.539693 76.603077 0 42.299077 33.831385 76.603077 75.539693 76.603077 41.747692 0 75.539692-34.264615 75.539692-76.603077 0-42.299077-33.792-76.603077-75.539692-76.603077z m416.768-294.990769c-27.805538 0-50.333538-22.843077-50.333539-51.042462 0-28.199385 22.528-51.042462 50.333539-51.042461 27.844923 0 50.412308 22.843077 50.372923 51.042461 0 28.199385-22.567385 51.081846-50.372923 51.081847zM201.452308 524.8c0-56.398769-45.095385-102.124308-100.745846-102.124308C45.095385 422.596923 0 468.283077 0 524.760615c0 56.398769 45.095385 102.124308 100.706462 102.124308 55.650462 0 100.745846-45.686154 100.745846-102.124308z"  ></path></symbol><symbol id="icon-loading" viewBox="0 0 1024 1024"><path d="M563.2 819.2a102.4 102.4 0 1 1 0 204.8 102.4 102.4 0 0 1 0-204.8z m-320.4608-153.6a128 128 0 1 1 0 256 128 128 0 0 1 0-256z m592.7936 25.6a102.4 102.4 0 1 1 0 204.8 102.4 102.4 0 0 1 0-204.8zM947.2 477.1328a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6zM128 307.2a128 128 0 1 1 0 256 128 128 0 0 1 0-256z m782.6432-40.6016a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4zM409.6 0a153.6 153.6 0 1 1 0 307.2 153.6 153.6 0 0 1 0-307.2z m384 153.6a25.6 25.6 0 1 1 0 51.2 25.6 25.6 0 0 1 0-51.2z" fill="#555555" ></path></symbol><symbol id="icon-tupushujuyuan" viewBox="0 0 1024 1024"><path d="M851.456 588.288c-13.312 0-25.6 2.048-37.888 5.12l-90.112-155.648 55.296-31.744c18.944 17.92 44.032 29.184 72.192 29.184 57.344 0 103.936-46.592 103.936-103.936s-46.592-103.936-103.936-103.936c-57.344 0-103.936 46.592-103.936 103.936 0 5.12 0.512 10.24 1.536 15.36l-58.368 33.792-82.944-143.872c26.112-25.088 41.984-59.904 41.984-98.816 0-75.776-61.44-137.216-137.216-137.216s-137.216 61.44-137.216 137.216c0 38.912 15.872 73.728 41.984 98.816l-84.992 146.944-56.832-32.768c1.024-6.144 2.048-12.8 2.048-19.456 0-57.344-46.592-103.936-103.936-103.936-57.344 0-103.936 46.592-103.936 103.936s46.592 103.936 103.936 103.936c26.624 0 51.2-10.24 69.12-26.624l56.32 32.768-88.064 152.576c-11.776-3.584-24.576-5.12-37.888-5.12-75.776 0-137.216 61.44-137.216 137.216s61.44 137.216 137.216 137.216c64.512 0 118.272-44.544 133.12-103.936h173.056v61.44c-40.96 13.824-70.656 52.736-70.656 98.816 0 57.344 46.592 103.936 103.936 103.936s103.936-46.592 103.936-103.936c0-46.08-29.696-84.48-70.656-98.816v-61.44h173.056c14.848 59.904 69.12 103.936 133.12 103.936 75.776 0 137.216-61.44 137.216-137.216s-61.44-137.728-137.216-137.728z m-410.112-450.048c0-38.912 31.744-70.656 70.656-70.656s70.656 31.744 70.656 70.656c0 13.824-4.096 26.624-10.752 37.376-12.288 19.456-33.28 32.256-57.856 33.28h-5.12c-24.576-1.024-45.568-13.824-57.856-33.28-6.144-10.752-9.728-24.064-9.728-37.376z m32.768 132.096c11.776 3.584 24.576 5.12 37.888 5.12s25.6-2.048 37.888-5.12l82.944 143.872-124.416 72.192-118.784-68.608 84.48-147.456z m-301.568 526.336c-38.912 0-70.656-31.744-70.656-70.656 0-38.912 31.744-70.656 70.656-70.656h2.56c24.576 1.024 45.568 13.824 57.856 33.28 1.024 1.536 1.536 2.56 2.56 4.096 5.12 9.728 8.192 20.992 8.192 33.28 0 11.776-3.072 23.552-8.192 33.28-12.288 22.016-35.84 37.376-62.976 37.376z m133.12-103.936c-6.144-25.6-19.456-48.128-37.888-65.536l88.064-152.576 122.88 70.656v146.944h-173.056z m239.616-151.552l120.832-69.632 90.112 155.648c-18.432 17.408-31.744 39.936-37.888 65.536h-173.056v-151.552z m306.176 255.488c-27.136 0-50.688-15.36-62.464-37.376-5.12-9.728-8.192-21.504-8.192-33.28 0-12.288 3.072-23.552 8.192-33.28 0.512-1.536 1.536-3.072 2.56-4.096 12.288-19.456 33.28-32.768 57.856-33.28h2.56c38.912 0 70.656 31.744 70.656 70.656-0.512 38.912-32.256 70.656-71.168 70.656z"  ></path></symbol><symbol id="icon-jiedian" viewBox="0 0 1024 1024"><path d="M882.1914 744.849921c-60.501005 0-112.097749 38.645092-131.425292 92.560342H244.912146c-80.468136 0-145.955927-62.61964-145.955926-139.570043 0-77.000371 65.487791-139.570043 145.955926-139.570043h136.312143c19.497433 53.585462 70.934281 91.950735 131.205434 91.950735 60.241173 0 111.688014-38.375266 131.205434-91.950735h136.452052C914.210763 558.280171 1023.340425 453.92743 1023.340425 325.660102S914.210763 93.040033 780.077216 93.040033H273.093982c-19.197627-54.165089-70.944274-93.040033-131.595182-93.040033C64.508422 0 1.928757 62.569672 1.928757 139.560049c0 76.950403 62.579665 139.570043 139.570043 139.570043 60.640915 0 112.377569-38.894931 131.585189-93.040033h506.993227c80.468136 0 145.955927 62.61964 145.955927 139.570043 0 77.000371-65.487791 139.570043-145.955927 139.570043H644.414655c-18.887826-54.734722-70.924287-94.139324-131.974938-94.139325-61.090625 0-113.097105 39.394609-131.974938 94.139325H244.912146c-134.133547 0-243.263209 104.352741-243.263209 232.620069 0 128.267328 109.129663 232.620069 243.263209 232.620069h505.524174c19.057717 54.394941 70.9043 93.529717 131.75508 93.529717 76.950403 0 139.570043-62.61964 139.570043-139.570043 0.009994-77.000371-62.61964-139.580036-139.570043-139.580036zM141.428845 207.036558c-37.166045 0-67.376574-30.230515-67.376574-67.376573 0-37.166045 30.210528-67.376574 67.376574-67.376574 37.146058 0 67.376574 30.210528 67.376573 67.376574 0 37.146058-30.230515 67.376574-67.376573 67.376573z m371.000878 236.257725c37.146058 0 67.376574 30.210528 67.376574 67.376574 0 37.146058-30.230515 67.376574-67.376574 67.376573-37.166045 0-67.376574-30.230515-67.376574-67.376573 0.009994-37.176039 30.210528-67.376574 67.376574-67.376574z m369.761677 508.502254c-37.166045 0-67.376574-30.230515-67.376574-67.376573 0-37.166045 30.210528-67.376574 67.376574-67.376574 37.146058 0 67.376574 30.210528 67.376574 67.376574 0 37.146058-30.230515 67.376574-67.376574 67.376573z"  ></path></symbol><symbol id="icon-shitujiedianxianshi" viewBox="0 0 1367 1024"><path d="M1235.403267 512.03593a130.596433 130.596433 0 0 0-42.68749 7.796802l-193.295715-290.430872A149.113837 149.113837 0 1 0 724.647767 149.48464a151.777744 151.777744 0 0 0 37.229729 97.849864l-194.920048 357.873209a220.519548 220.519548 0 0 0-55.162374-8.511508 207.914718 207.914718 0 0 0-114.807909 34.046035L240.401393 443.683967a126.763005 126.763005 0 0 0-75.564005-182.380192 127.737605 127.737605 0 1 0 12.99467 239.816633l157.625345 188.422713A213.307506 213.307506 0 1 0 643.23616 643.282096l190.956674-350.856087a164.187654 164.187654 0 0 0 39.56877 6.172468 143.591102 143.591102 0 0 0 60.555162-12.99467l192.516034 288.026859a121.760057 121.760057 0 0 0-18.582377 64.973349 128.127445 128.127445 0 1 0 127.152844-126.568085zM129.621832 448.362048a68.157044 68.157044 0 1 1 68.157044-68.092071A68.157044 68.157044 0 0 1 129.621832 448.362048z m528.948039 365.670011a145.86517 145.86517 0 1 1-145.86517-145.86517 145.86517 145.86517 0 0 1 145.86517 145.86517z m215.12676-577.937944a87.389155 87.389155 0 1 1 87.389155-87.389155 87.389155 87.389155 0 0 1-87.389155 87.389155z m365.085251 474.305451a68.157044 68.157044 0 1 1 68.222017-68.416937 68.157044 68.157044 0 0 1-68.222017 68.157044z"  ></path></symbol><symbol id="icon-shituxianshiquanbujiedian" viewBox="0 0 1367 1024"><path d="M1235.403267 512.03593a130.596433 130.596433 0 0 0-42.68749 7.796802l-193.295715-290.430872A149.113837 149.113837 0 1 0 724.647767 149.48464a151.777744 151.777744 0 0 0 37.229729 97.849864l-194.920048 357.873209a220.519548 220.519548 0 0 0-55.162374-8.511508 207.914718 207.914718 0 0 0-114.807909 34.046035L240.401393 443.683967a126.763005 126.763005 0 0 0-75.564005-182.380192 127.737605 127.737605 0 1 0 12.99467 239.816633l157.625345 188.422713A213.307506 213.307506 0 1 0 643.23616 643.282096l190.956674-350.856087a164.187654 164.187654 0 0 0 39.56877 6.172468 143.591102 143.591102 0 0 0 60.555162-12.99467l192.516034 288.026859a121.760057 121.760057 0 0 0-18.582377 64.973349 128.127445 128.127445 0 1 0 127.152844-126.568085zM129.621832 448.362048a68.157044 68.157044 0 1 1 68.157044-68.092071A68.157044 68.157044 0 0 1 129.621832 448.362048z m528.948039 365.670011a145.86517 145.86517 0 1 1-145.86517-145.86517 145.86517 145.86517 0 0 1 145.86517 145.86517z m215.12676-577.937944a87.389155 87.389155 0 1 1 87.389155-87.389155 87.389155 87.389155 0 0 1-87.389155 87.389155z m365.085251 474.305451a68.157044 68.157044 0 1 1 68.222017-68.416937 68.157044 68.157044 0 0 1-68.222017 68.157044z"  ></path></symbol><symbol id="icon-suoxiao" viewBox="0 0 1024 1024"><path d="M768 448a320 320 0 1 0-320 320 320 320 0 0 0 320-320z m64 0A384 384 0 1 1 448 64a384 384 0 0 1 384 384z"  ></path><path d="M681.28 726.72a32 32 0 0 1 45.44-45.44l160 160a32 32 0 0 1-45.44 45.44zM288 480a32 32 0 0 1 0-64h320a32 32 0 0 1 0 64z"  ></path></symbol><symbol id="icon-lianjie" viewBox="0 0 1024 1024"><path d="M922.243 97.755c11.49 11.489 11.673 30.002 0.547 41.713l-0.547 0.562-109.119 109.1c57.22 78.348 42.673 195.388-35.778 273.839l-92.83 92.585c-11.572 11.54-30.264 11.653-41.97 0.253l-45.746-44.55-18.089 18.086a29.891 29.891 0 0 1-7.171 5.3l48.764 47.489c11.947 11.638 12.06 30.804 0.248 42.585l-95.875 95.629c-77.416 77.417-192.412 92.603-270.72 38.004L144.04 928.245c-11.676 11.673-30.606 11.673-42.282 0-11.49-11.489-11.673-30.002-0.547-41.713l0.547-0.562 109.677-109.657c-55.981-78.335-41.131-194.413 36.833-272.377l92.831-92.585c11.571-11.54 30.263-11.653 41.969-0.254l42.587 41.474a29.935 29.935 0 0 1 3.678-4.741l0.548-0.562 19.54-19.538-44.11-42.957c-11.828-11.522-12.057-30.422-0.6-42.23l0.351-0.355 95.875-95.63c76.927-76.926 190.96-92.408 269.23-39.03L879.961 97.755c11.676-11.673 30.606-11.673 42.282 0zM362.451 474.49l-71.916 71.727-1.884 1.911c-61.822 63.545-67.916 156.289-16.185 208.02C324.72 808.4 418.82 801.655 482.43 738.044l74.422-74.234-194.401-189.32z m129.807-5.04l-20.096 20.094a30.035 30.035 0 0 1-4.643 3.8l63.25 61.595a29.82 29.82 0 0 1 5.113-7.308l0.547-0.561 17.532-17.531-61.703-60.089z m260.889-198.691c-52.254-52.254-146.353-45.509-209.964 18.102l-74.422 74.234 194.4 189.322 71.939-71.75 1.862-1.888c61.822-63.545 67.916-156.29 16.185-208.02z" fill="#333333" ></path></symbol><symbol id="icon-xiantiao" viewBox="0 0 1024 1024"><path d="M827.076923 157.538462a39.384615 39.384615 0 1 1-14.375385 76.051692L233.590154 812.701538a39.384615 39.384615 0 1 1-22.291692-22.291692L790.409846 211.298462A39.384615 39.384615 0 0 1 827.076923 157.538462z" fill="#333333" ></path></symbol></svg>', r = (r = document.getElementsByTagName("script"))[r.length - 1].getAttribute("data-injectcss");
  if (r && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (d) {
      console && console.log(d);
    }
  }
  function c() {
    s || (s = !0, n());
  }
  o = function() {
    var d, f, h, g;
    (g = document.createElement("div")).innerHTML = l, l = null, (h = g.getElementsByTagName("svg")[0]) && (h.setAttribute("aria-hidden", "true"), h.style.position = "absolute", h.style.width = 0, h.style.height = 0, h.style.overflow = "hidden", d = h, (f = document.body).firstChild ? (g = d, (h = f.firstChild).parentNode.insertBefore(g, h)) : f.appendChild(d));
  }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(o, 0) : (t = function() {
    document.removeEventListener("DOMContentLoaded", t, !1), o();
  }, document.addEventListener("DOMContentLoaded", t, !1)) : document.attachEvent && (n = o, i = e.document, s = !1, (a = function() {
    try {
      i.documentElement.doScroll("left");
    } catch (d) {
      return void setTimeout(a, 50);
    }
    c();
  })(), i.onreadystatechange = function() {
    i.readyState == "complete" && (i.onreadystatechange = null, c());
  });
})(window);
const Ee = () => window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width, Ae = () => window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height, Ie = (e) => {
  let o = 0;
  for (const t of e) {
    const n = t.charCodeAt(0);
    n < 0 || n > 255 ? o += 2 : o++;
  }
  return o;
};
let H = !1;
const Re = () => {
  try {
    document.createEvent("TouchEvent"), H = !0;
  } catch (e) {
  }
};
Re();
const u = (...e) => {
  typeof window != "undefined" && window.relationGraphDebug && console.log("[relation-graph:debug]", ...e);
}, ie = 0, x = {
  getRectPoint(e, o, t, n, i, s, a, l) {
    const r = e + i / 2, c = o + s / 2, d = t + a / 2, f = n + l / 2, h = r < d ? 1 : -1, g = c < f ? 1 : -1;
    if (f === c)
      return { x: r + h * i / 2, y: c };
    const _ = Math.abs((d - r) / (f - c)), w = i / s;
    let C = 0, G = 0;
    return _ < w ? (C = h * s / 2 * _, G = g * s / 2) : (C = h * i / 2, G = g * i / 2 / _), { x: r + C, y: c + G };
  },
  getRectPointBasic(e, o, t, n, i, s, a, l) {
    const r = e + i / 2, c = o + s / 2, d = t + a / 2, f = n + l / 2;
    let h = f === c ? 0 : (d - r) / (f - c);
    h === 0 && (h = (d - r) / (f - c + 1));
    const g = i / l;
    let _ = 0, w = 0, C = "1";
    return -1 * g < h && h < g ? (C = "2", c < f ? (_ = s / 2 * h, w = s / 2) : (_ = -1 * s / 2 * h, w = -1 * s / 2)) : (r < d ? (_ = 1 * i / 2, w = 1 * i / 2 / h) : (_ = -1 * i / 2, w = -1 * i / 2 / h), C = "3"), { x: r + _, y: c + w, _case: C };
  },
  getRectJoinPoint(e, o, t, n, i, s, a, l) {
    const r = e + i / 2, c = o + s / 2, d = t + a / 2, f = n + l / 2, h = Math.round(Math.atan2(f - c, d - r) * 180 / 3.14) + 135;
    return h >= 0 && h < 90 ? { x: e + i / 2, y: o - 5 } : h >= 90 && h < 180 ? { x: e + i + 5, y: o + s / 2 } : h >= 180 && h < 270 ? { x: e + i / 2, y: o + s + 5 } : { x: e - 5, y: o + s / 2 };
  },
  getRectHJoinPoint(e, o, t, n, i, s, a) {
    const l = s / 2;
    return e + i < t ? { x: e + i + 5, y: o + l } : e + i < t + a ? { x: e - 5, y: o + l } : { x: e - 5, y: o + l };
  },
  getRectVJoinPoint(e, o, t, n, i, s, a, l) {
    const r = i / 2;
    return o + s < n ? { y: o + s + 5, x: e + r } : o + s < n + l ? { y: o - 5, x: e + r } : { y: o - 5, x: e + r };
  },
  getBorderPoint(e, o, t, n, i, s, a, l, r) {
    return r === 0 ? this.getCirclePoint(e, o, t, n, i, s, a, l) : this.getRectPoint(e, o, t, n, i, s, a, l);
  },
  getBorderPoint4MultiLine(e, o, t, n, i, s, a, l, r, c, d, f) {
    return r === 0 ? this.getCirclePoint4MultiLine(e, o, t, n, i, s, a, l, c, d, f) : this.getRectPoint(e, o, t, n, i, s, a, l);
  },
  getCirclePoint(e, o, t, n, i, s, a, l) {
    const r = t + a / 2, c = n + l / 2, d = e + i / 2, f = o + s / 2, h = r - d;
    if (h === 0)
      return { x: d, y: f - s / 2 * (c < f ? 1 : -1) };
    const _ = (c - f) / h, w = Math.sqrt(1 / (1 / (i / 2) ** 2 + _ ** 2 / (s / 2) ** 2)) * (r < d ? 1 : -1), C = _ * w;
    return { x: d - w, y: f - C };
  },
  getCirclePoint4MultiLine(e, o, t, n, i, s, a, l, r, c, d) {
    r && (d = c - d - 1);
    const f = t + a / 2, h = n + l / 2, g = e + i / 2, _ = o + s / 2, w = f - g;
    if (w === 0)
      return { x: g, y: _ - s / 2 * (h < _ ? 1 : -1) };
    const C = 40 / (c + 1) * (d + 1) - 20, G = h - _, N = Math.sqrt(w ** 2 + G ** 2) * C / w, M = G / w, y = i / 2, L = s / 2, m = f < g ? 1 : -1, k = (-1 * y ** 2 * M * N + y * L * Math.sqrt(L ** 2 + M ** 2 * y ** 2 - N ** 2, 2) / m) / (L ** 2 + y ** 2 * M ** 2), W = M * k + N;
    return { x: g - k, y: _ - W };
  },
  getCirclePointBasic(e, o, t, n, i, s, a, l, r) {
    const c = e + i / 2, d = o + s / 2, f = t + a / 2, h = n + l / 2;
    return this.h = f - c, this.s = h - d, this.c = Math.sqrt(this.h * this.h + this.s * this.s), this.l = this.c - r, this.v = this.l * this.h / this.c * -1, this.t = this.l * this.s / this.c * -1, { x: f + this.v, y: h + this.t };
  },
  getCirclePointPlus(e, o, t, n, i, s, a, l) {
    const r = e + i / 2, c = o + s / 2, d = t + a / 2, f = n + l / 2;
    return this.h = d - r, this.s = f - c, this.c = Math.sqrt(this.h * this.h + this.s * this.s), this.v = (this.c - i / 2) * this.h / this.c * -1, this.t = (this.c - s / 2) * this.s / this.c * -1, { x: d + this.v, y: f + this.t };
  },
  getOvalPoint(e, o, t, n, i) {
    return {
      x: e + t * Math.sin((ie + n * (360 / i) + 0) * Math.PI / 180),
      y: o + t * Math.cos((ie + n * (360 / i) + 0) * Math.PI / 180) * -1
    };
  },
  getAngleType(e, o) {
    if (e >= 0 && o >= 0)
      return 1;
    if (e < 0 && o >= 0)
      return 2;
    if (e < 0 && o < 0)
      return 3;
    if (e >= 0 && o < 0)
      return 4;
  },
  getTextAngle(e, o, t, n) {
    let i = Math.atan(Math.abs((n - o) / (t - e))) * 180 / Math.PI;
    return t > e && n > o || (t > e && n < o ? i = -i : t < e && n > o ? i = 180 - i : i = i - 180), Math.abs(i) > 90 && (i = i + 180), Math.round(i);
  },
  getTreePointFromTop(e, o, t, n, i, s) {
    return e ? {
      x: e - 300 + Math.max(600 / ((i === 1 ? 2 : i) - 1), 80) * n,
      y: o + t
    } : {
      x: (s.canvas_width - s.node_width) / 2,
      y: (s.canvas_height - s.node_height) / 2 - 200
    };
  },
  getTreePointFromRight(e, o, t, n, i, s) {
    return e ? {
      x: e - t,
      y: o - 200 + Math.max(400 / ((i === 1 ? 2 : i) - 1), 80) * n
    } : {
      x: (s.canvas_width - s.node_width) / 2 + 300,
      y: (s.canvas_height - s.node_height) / 2
    };
  },
  getTreePointFromBottom(e, o, t, n, i, s) {
    return e ? {
      x: e - 300 + Math.max(600 / ((i === 1 ? 2 : i) - 1), 80) * n,
      y: o - t
    } : {
      x: (s.canvas_width - s.node_width) / 2,
      y: (s.canvas_height - s.node_height) / 2 + 200
    };
  },
  getTreePointFromLeft(e, o, t, n, i, s) {
    return e ? {
      x: e + t,
      y: o - 200 + Math.max(400 / ((i === 1 ? 2 : i) - 1), 80) * n
    } : {
      x: (s.canvas_width - s.node_width) / 2 - 300,
      y: (s.canvas_height - s.node_height) / 2
    };
  },
  analysisNodes(e, o, t, n, i) {
    o.length > n.max_length && (n.max_length = o.length), t > n.max_deep && (n.max_deep = t);
    const s = {
      level: t,
      all_size: o.length,
      all_strength: 0
    }, a = [];
    o.forEach((r) => {
      r.lot || (r.lot = {}), r.lot.eached = !0, r.lot.subling = s, r.lot.level = t, e.push(r);
    });
    let l = 0;
    o.forEach((r) => {
      let c = 0;
      if (r.targetNodes) {
        let d = 0;
        r.targetNodes.forEach((f) => {
          f.lot || (f.lot = { eached: !1 }), f.lot.eached || (x.isAllowShowNode(f) ? (f.lot.eached = !0, f.lot.parent = r, f.lot.index_of_parent = d++, r.lot.childs.push(f), a.push(f), c++) : r.lot.childs.push(f));
        });
      }
      r.lot.strength = c > 0 ? c : 1, s.all_strength += r.lot.strength, r.lot.strength_plus = s.all_strength, r.lot.index_of_level = l, r.lot.childs_size = c, l++;
    }), s.all_strength > n.max_strength && (n.max_strength = s.all_strength), a.length > 0 ? this.analysisNodes(e, a, t + 1, n, i) : (e.forEach((r) => {
      r.lot.childs_size > 0 && (r.lot.strengthWithChilds = 0);
    }), e.forEach((r) => {
      r.lot.childs_size === 0 && (r.lot.strengthWithChilds = 1, this.conductStrengthToParents(r));
    }), this.analysisDataTree([e[0]], 0));
  },
  analysisNodes4Didirectional(e, o, t, n, i) {
    o.length > n.max_length && (n.max_length = o.length), t > n.max_deep && (n.max_deep = t);
    const s = {
      level: t,
      all_size: o.length,
      all_strength: 0
    }, a = [];
    o.forEach((r) => {
      r.lot || (r.lot = {}), r.lot.eached = !0, r.lot.subling = s, r.lot.level = t, e.push(r);
    });
    let l = 0;
    o.forEach((r) => {
      let c = 0;
      if (i === 0) {
        let d = 0;
        r.targetNodes.forEach((f) => {
          f.lot || (f.lot = { eached: !1 }), f.lot.eached || (x.isAllowShowNode(f) ? (f.lot.eached = !0, f.lot.parent = r, f.lot.index_of_parent = d++, r.lot.childs.push(f), a.push(f), c++) : r.lot.childs.push(f));
        });
      } else if (i === -1) {
        let d = 0;
        r.targetFrom.forEach((f) => {
          f.lot || (f.lot = { eached: !1 }), f.lot.eached || (x.isAllowShowNode(f) ? (f.lot.eached = !0, f.lot.parent = r, f.lot.index_of_parent = d++, r.lot.childs.push(f), a.push(f), c++) : r.lot.childs.push(f));
        });
      } else {
        let d = 0;
        r.targetTo.forEach((f) => {
          f.lot || (f.lot = { eached: !1 }), f.lot.eached || (x.isAllowShowNode(f) ? (f.lot.eached = !0, f.lot.parent = r, f.lot.index_of_parent = d++, r.lot.childs.push(f), a.push(f), c++) : r.lot.childs.push(f));
        });
      }
      r.lot.strength = c > 0 ? c : 1, s.all_strength += r.lot.strength, r.lot.strength_plus = s.all_strength, r.lot.index_of_level = l, r.lot.childs_size = c, l++;
    }), s.all_strength > n.max_strength && (n.max_strength = s.all_strength), a.length > 0 ? x.analysisNodes4Didirectional(e, a, t + (i === -1 ? -1 : 1), n, i) : (e.forEach((r) => {
      r.lot.childs_size > 0 && (r.lot.strengthWithChilds = 0);
    }), e.forEach((r) => {
      r.lot.childs_size === 0 && (r.lot.strengthWithChilds = 1, x.conductStrengthToParents(r));
    }), x.analysisDataTree([e[0]], 0, i));
  },
  conductStrengthToParents(e) {
    e.lot.parent && (e.lot.parent.lot.strengthWithChilds += 1, this.conductStrengthToParents(e.lot.parent));
  },
  analysisDataTree(e, o, t) {
    t === void 0 && (t = 1);
    const n = [];
    let i = 0;
    e.forEach((s) => {
      (s.lot.level === 0 || t === (s.lot.level < 0 ? -1 : 1)) && (s.lot.childs_size > 0 && s.lot.childs.forEach((a) => {
        n.push(a);
      }), s.lot.parent && i < s.lot.parent.lot.strengthWithChilds_from && (i = s.lot.parent.lot.strengthWithChilds_from), s.lot.strengthWithChilds_from = i, i += s.lot.strengthWithChilds);
    }), n.length > 0 && this.analysisDataTree(n, o + t, t);
  },
  isAllowShowNode(e) {
    return e.isShow !== !1 && e.isHide !== !0 && (!e.lot.parent || this.isAllowShowNode(e.lot.parent, !1) === !0);
  }
}, Be = (e, o, t, n) => {
  const i = e - t, s = o - n, a = i ** 2, l = s ** 2, r = a + l;
  return Math.sqrt(r);
}, Y = (e) => {
  if (e.from === void 0)
    throw new Error("error,line must has option[from]:", e);
  if (e.to === void 0)
    throw new Error("error,line must has option[to]:", e);
  if (typeof e.from != "string")
    throw new TypeError("error line from, must be string:", e);
  if (typeof e.to != "string")
    throw new TypeError("error line to, must be string:", e);
  const o = {
    from: e.from,
    to: e.to,
    text: e.text !== void 0 ? e.text : "",
    color: e.color !== void 0 ? e.color : void 0,
    opacity: e.opacity !== void 0 ? e.opacity : 1,
    fontColor: e.fontColor !== void 0 ? e.fontColor : void 0,
    lineWidth: e.lineWidth !== void 0 ? e.lineWidth : void 0,
    lineShape: e.lineShape !== void 0 ? e.lineShape : void 0,
    styleClass: e.styleClass !== void 0 ? e.styleClass : void 0,
    isHide: e.isHide !== void 0 ? e.isHide : !1,
    arrow: e.arrow !== void 0 ? e.arrow : void 0,
    disableDefaultClickEffect: e.disableDefaultClickEffect !== void 0 ? e.disableDefaultClickEffect : !1,
    showStartArrow: e.showStartArrow !== void 0 ? e.showStartArrow : !1,
    showEndArrow: e.showEndArrow !== void 0 ? e.showEndArrow : !0,
    useTextPath: e.useTextPath !== void 0 ? e.useTextPath : !1,
    isHideArrow: e.isHideArrow !== void 0 ? e.isHideArrow : void 0,
    hidden: e.hidden !== void 0 ? e.hidden : !1,
    lineDirection: e.lineDirection !== void 0 ? e.lineDirection : void 0,
    reverseText: e.reverseText !== void 0 ? e.reverseText : void 0,
    data: e.data !== void 0 ? e.data : {}
  };
  return o.isHideArrow && (o.showEndArrow = !1, o.isHideArrow = !1), o;
}, Oe = ["arrow", "id", "reverseText", "isReverse"], X = (e, o) => {
  !e || e.relations.forEach((t) => {
    const n = {};
    Object.keys(t).forEach((i) => {
      Oe.includes(i) || t[i] !== void 0 && (n[i] = t[i]);
    }), o.push(n);
  });
}, F = {
  border: "border",
  ltrb: "ltrb",
  tb: "tb",
  lr: "lr"
}, Fe = {
  json2Line: Y,
  transLinkToJson: X
}, He = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json2Line: Y,
  transLinkToJson: X,
  JUNCTION_POINT_STYLE: F,
  default: Fe
}, Symbol.toStringTag, { value: "Module" })), ye = (e) => {
  const o = {
    instanceId: "SeeksGraph",
    debug: !0,
    showDebugPanel: !1,
    backgrounImage: "",
    downloadImageFileName: "",
    disableZoom: !1,
    disableDragNode: !1,
    moveToCenterWhenRefresh: !0,
    zoomToFitWhenRefresh: !0,
    useAnimationWhenRefresh: !0,
    defaultFocusRootNode: !0,
    disableNodeClickEffect: !1,
    disableLineClickEffect: !1,
    allowShowZoomMenu: !0,
    allowAutoLayoutIfSupport: !0,
    allowShowRefreshButton: !0,
    allowShowDownloadButton: !0,
    backgrounImageNoRepeat: !1,
    allowShowMiniToolBar: !0,
    allowSwitchLineShape: !1,
    allowSwitchJunctionPoint: !1,
    isMoveByParentNode: !1,
    defaultExpandHolderPosition: "hide",
    defaultNodeColor: "#67C23A",
    checkedLineColor: "#FD8B37",
    defaultNodeFontColor: "#ffffff",
    defaultNodeBorderColor: "#90EE90",
    defaultNodeBorderWidth: 5,
    defaultLineColor: "#dddddd",
    defaultLineWidth: 1,
    defaultLineShape: 1,
    defaultNodeShape: 0,
    defaultNodeWidth: void 0,
    defaultNodeHeight: void 0,
    defaultShowLineLabel: !0,
    hideNodeContentByZoom: !1,
    defaultJunctionPoint: "border",
    disableDragCanvas: !1,
    placeSingleNode: !0,
    lineUseTextPath: !1,
    viewSize: { width: 300, height: 300 },
    viewELSize: { width: 1300, height: 800, left: 0, top: 100 },
    viewNVInfo: { width: 1300, height: 800, x: 0, y: 100 },
    canvasNVInfo: { width: 1300, height: 800, x: 0, y: 100 },
    defaultLineMarker: {
      markerWidth: 12,
      markerHeight: 12,
      refX: 6,
      refY: 6,
      color: void 0,
      data: "M2,2 L10,6 L2,10 L6,6 L2,2"
    },
    allowShowMiniView: !1,
    allowShowSettingPanel: !1,
    allowShowMiniNameFilter: !0,
    fullscreen: !1,
    checkedNodeId: "",
    checkedLineId: "",
    layouts: [],
    layoutLabel: "",
    layoutName: "tree",
    layoutClassName: "",
    layoutDirection: "h",
    autoLayouting: !1,
    layouter: void 0,
    isNeedShowAutoLayoutButton: !1,
    canvasZoom: 100,
    showSingleNode: !0,
    showNodeLabel: !0,
    showNodeShortLabel: !0,
    canvasSize: {
      width: 2e3,
      height: 2e3
    },
    canvasOffset: {
      x: 25,
      y: 27,
      zoom_buff_x: 0,
      zoom_buff_y: 0
    }
  }, t = e.debug === !0;
  return t && u("RGOptions:user instance graphSetting:", e), window && (window.relationGraphDebug = t), e && Object.keys(e).forEach((n) => {
    const i = e[n];
    if (typeof i == "object") {
      u("RGOptions:user setting object:", n, i);
      const s = o[n];
      if (s)
        if (s && !Array.isArray(s) && i)
          Object.keys(s).forEach((a) => {
            s[a] = i[a];
          });
        else if (Array.isArray(s)) {
          const a = [];
          i.forEach((l) => {
            l && typeof l == "object" ? a.push(JSON.parse(JSON.stringify(l))) : a.push(l);
          }), o[n] = a;
        } else
          o[n] = i;
      else
        u("ignore option:", n);
    } else
      o[n] = i;
  }), (!o.layouts || o.layouts.length === 0) && (o.layouts = [{
    label: "\u4E2D\u5FC3",
    layoutName: "center",
    layoutDirection: "v",
    defaultExpandHolderPosition: "hide",
    defaultNodeShape: 0,
    defaultLineShape: 1,
    defaultJunctionPoint: "border"
  }]), Array.isArray(o.layouts) || (o.layouts = [o.layouts]), o.layouts.forEach((n) => {
    xe(n, o);
  }), o.disableNodeClickEffect && (o.defaultFocusRootNode = !1), o;
}, xe = (e, o) => {
  e.useLayoutStyleOptions === void 0 && (e.useLayoutStyleOptions = !1), e.defaultNodeColor === void 0 && (e.defaultNodeColor = "#FFC5A6"), e.defaultNodeFontColor === void 0 && (e.defaultNodeFontColor = "#000000"), e.defaultNodeBorderColor === void 0 && (e.defaultNodeBorderColor = "#efefef"), e.defaultNodeBorderWidth === void 0 && (e.defaultNodeBorderWidth = 1), e.defaultLineColor === void 0 && (e.defaultLineColor = "#FD8B37"), e.defaultLineWidth === void 0 && (e.defaultLineWidth = 1), e.defaultNodeWidth === void 0 && (e.defaultNodeWidth = void 0), e.defaultNodeHeight === void 0 && (e.defaultNodeHeight = void 0), e.defaultShowLineLabel === void 0 && (e.defaultShowLineLabel = !0), e.defaultExpandHolderPosition === void 0 && (e.defaultExpandHolderPosition = void 0), e.defaultJunctionPoint === void 0 && (e.defaultJunctionPoint = void 0), e.defaultLineMarker === void 0 && (e.defaultLineMarker = {
    markerWidth: 12,
    markerHeight: 12,
    refX: 6,
    refY: 6,
    color: void 0,
    data: "M2,2 L10,6 L2,10 L6,6 L2,2"
  }), e.layoutName === "SeeksCenterLayouter" || e.layoutName === "center" ? (e.label === void 0 && (e.label = "\u4E2D\u5FC3"), e.layoutClassName === void 0 && (e.layoutClassName = `seeks-layout-${e.layoutName}`), e.defaultNodeShape === void 0 && (e.defaultNodeShape = 0), e.defaultLineShape === void 0 && (e.defaultLineShape = 1), e.defaultExpandHolderPosition === void 0 && (e.defaultExpandHolderPosition = "hide"), e.defaultJunctionPoint === void 0 && (e.defaultJunctionPoint = "border"), e.layoutDirection === void 0 && (e.layoutDirection = "h"), e.centerOffset_x === void 0 && (e.centerOffset_x = 0), e.centerOffset_y === void 0 && (e.centerOffset_y = 0), e.levelDistance === void 0 && (e.levelDistance = ""), e.min_per_width === void 0 && (e.min_per_width = 30), e.max_per_width === void 0 && (e.max_per_width = 200), e.min_per_height === void 0 && (e.min_per_height = 100), e.max_per_height === void 0 && (e.max_per_height = 500)) : e.layoutName === "SeeksBidirectionalTreeLayouter" || e.layoutName === "tree" ? (e.label === void 0 && (e.label = "\u6811\u72B6"), e.layoutClassName === void 0 && (e.layoutClassName = `seeks-layout-${e.layoutName}`), e.defaultNodeShape === void 0 && (e.defaultNodeShape = 1), e.defaultLineShape === void 0 && (o.defaultLineShape = 4), e.defaultExpandHolderPosition === void 0 && (e.defaultExpandHolderPosition = "hide"), e.defaultJunctionPoint === void 0 && (e.defaultJunctionPoint = "ltrb"), e.layoutDirection === void 0 && (e.layoutDirection = "h"), e.centerOffset_x === void 0 && (e.centerOffset_x = 0), e.centerOffset_y === void 0 && (e.centerOffset_y = 0), e.from === void 0 && (e.from = "top"), e.levelDistance === void 0 && (e.levelDistance = ""), e.min_per_width === void 0 && (e.min_per_width = 30), e.max_per_width === void 0 && (e.max_per_width = 200), e.min_per_height === void 0 && (e.min_per_height = 100), e.max_per_height === void 0 && (e.max_per_height = 500), (e.from === "top" || e.from === "bottom") && (e.layoutDirection = "v", o.defaultJunctionPoint = "tb", u("set layoutDirection=v"), u("set defaultJunctionPoint=tb")), (e.from === "left" || e.from === "right") && (o.defaultJunctionPoint = "lr", u("set defaultJunctionPoint=lr"))) : (e.layoutName === "fixed" || e.layoutName === "force") && (o.moveToCenterWhenRefresh = !1, o.zoomToFitWhenRefresh = !1);
};
let We = 0;
class q {
  constructor(o) {
    const t = ye(o);
    u("RGOptions:new RGOptions:by:", o), u("RGOptions:new RGOptions:by:", this), Object.assign(this, t), this.instanceId = `RGIns-${We++}`;
  }
}
const De = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createDefaultConfig: ye,
  appendDefaultOptions4Layout: xe,
  default: q
}, Symbol.toStringTag, { value: "Module" })), K = (e) => {
  if (e.id === void 0)
    throw new Error("node must has option[id]:", e);
  e.text = e.text || e.name;
  const o = {
    id: e.id,
    text: e.text !== void 0 ? e.text : "",
    type: e.type !== void 0 ? e.type : "node",
    isShow: e.isShow !== void 0 ? e.isShow : !0,
    isHide: e.isHide !== void 0 ? e.isHide : !1,
    expanded: e.expanded !== void 0 ? e.expanded : !0,
    junctionPoint: e.junctionPoint !== void 0 ? e.junctionPoint : void 0,
    selected: e.selected !== void 0 ? e.selected : !1,
    styleClass: e.styleClass !== void 0 ? e.styleClass : "",
    targetNodes: e.targetNodes !== void 0 ? e.targetNodes : [],
    targetFrom: e.targetFrom !== void 0 ? e.targetFrom : [],
    targetTo: e.targetTo !== void 0 ? e.targetTo : [],
    nodeShape: e.nodeShape !== void 0 ? e.nodeShape : void 0,
    borderWidth: e.borderWidth !== void 0 ? e.borderWidth : void 0,
    borderColor: e.borderColor !== void 0 ? e.borderColor : void 0,
    fontColor: e.fontColor !== void 0 ? e.fontColor : void 0,
    color: e.color !== void 0 ? e.color : void 0,
    opacity: e.opacity !== void 0 ? e.opacity : 1,
    fixed: e.fixed !== void 0 ? e.fixed : !1,
    width: e.width !== void 0 ? e.width : void 0,
    height: e.height !== void 0 ? e.height : void 0,
    x: e.x !== void 0 ? e.x : 0,
    y: e.y !== void 0 ? e.y : 0,
    Fx: e.Fx !== void 0 ? e.Fx : 0,
    Fy: e.Fy !== void 0 ? e.Fy : 0,
    offset_x: e.offset_x !== void 0 ? e.offset_x : 0,
    offset_y: e.offset_y !== void 0 ? e.offset_y : 0,
    expandHolderPosition: e.expandHolderPosition !== void 0 ? e.expandHolderPosition : void 0,
    innerHTML: e.innerHTML !== void 0 ? e.innerHTML : void 0,
    html: e.html !== void 0 ? e.html : void 0,
    disableDefaultClickEffect: e.disableDefaultClickEffect !== void 0 ? e.disableDefaultClickEffect : void 0,
    disableDrag: e.disableDrag !== void 0 ? e.disableDrag : !1,
    singleNode: !1,
    data: e.data !== void 0 ? e.data : {}
  };
  return o.lot === void 0 && (o.lot = {
    childs: [],
    parent: void 0,
    eached: !1,
    strength: 0
  }), o.lot.childs === void 0 && (o.lot.childs = []), o.lot.parent === void 0 && (o.lot.parent = void 0), o.lot.eached === void 0 && (o.lot.eached = !1), o.lot.strength === void 0 && (o.lot.strength = 0), o.el === void 0 && (o.el = { offsetWidth: 50, offsetHeight: 50 }), o.width !== void 0 && (o.el.offsetWidth = o.width), o.height !== void 0 && (o.el.offsetHeight = o.height), o;
}, Ve = [
  "Fx",
  "Fy",
  "appended",
  "el",
  "targetFrom",
  "targetNodes",
  "targetTo",
  "type",
  "lot",
  "seeks_id"
], Q = (e) => {
  if (!e)
    return;
  const o = {};
  return Object.keys(e).forEach((t) => {
    Ve.includes(t) || e[t] !== void 0 && (o[t] = e[t]);
  }), o;
}, Te = {
  json2Node: K,
  transNodeToJson: Q
}, je = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  json2Node: K,
  transNodeToJson: Q,
  default: Te
}, Symbol.toStringTag, { value: "Module" }));
class ve {
  constructor(o, t) {
    p(this, "graphSetting");
    p(this, "config");
    p(this, "rootNode", null);
    p(this, "allNodes", []);
    p(this, "__origin_nodes", []);
    this.config = o, this.graphSetting = t, u("new SeeksBidirectionalTreeLayouter:", this.config), this.config.from || (this.config.from = "left"), this.config.levelDistance && typeof this.config.levelDistance == "string" && (this.config.levelDistanceArr = this.config.levelDistance.split(",").map((n) => Number.parseInt(n)));
  }
  refresh() {
    u("SeeksBidirectionalTreeLayouter:refresh:nodes:", this.__origin_nodes.length), this.placeNodes(this.__origin_nodes, this.rootNode);
  }
  analysisNodes4Didirectional(o, t, n, i, s) {
    t.length > i.max_length && (i.max_length = t.length), n > i.max_deep && (i.max_deep = n);
    const a = {
      level: n,
      all_size: t.length,
      all_strength: 0
    }, l = [];
    t.forEach((c) => {
      c.lot || (c.lot = {}), c.lot.eached = !0, c.lot.subling = a, c.lot.level = n, o.push(c);
    });
    let r = 0;
    t.forEach((c) => {
      let d = 0;
      if (s === -1) {
        let f = 0;
        c.targetFrom.forEach((h) => {
          h.lot || (h.lot = { eached: !1 }), h.lot.eached || (x.isAllowShowNode(h) ? (h.lot.eached = !0, h.lot.parent = c, h.lot.index_of_parent = f++, c.lot.childs.push(h), l.push(h), d++) : c.lot.childs.push(h));
        });
      } else {
        let f = 0;
        c.targetTo.forEach((h) => {
          h.lot || (h.lot = { eached: !1 }), h.lot.eached || (x.isAllowShowNode(h) ? (h.lot.eached = !0, h.lot.parent = c, h.lot.index_of_parent = f++, c.lot.childs.push(h), l.push(h), d++) : c.lot.childs.push(h));
        });
      }
      c.lot.strength = d > 0 ? d : 1, a.all_strength += c.lot.strength, c.lot.strength_plus = a.all_strength, c.lot.index_of_level = r, c.lot.childs_size = d, r++;
    }), a.all_strength > i.max_strength && (i.max_strength = a.all_strength), l.length > 0 ? this.analysisNodes4Didirectional(o, l, n + s, i, s) : (o.forEach((c) => {
      c.lot.childs_size > 0 && (c.lot.strengthWithChilds = 0);
    }), o.forEach((c) => {
      c.lot.childs_size === 0 && (c.lot.strengthWithChilds = 1, x.conductStrengthToParents(c));
    }), x.analysisDataTree([o[0]], 0, s));
  }
  placeNodes(o, t) {
    if (u("SeeksBidirectionalTreeLayouter:placeNodes"), t)
      u("layout by root:", t);
    else {
      console.error("root is null");
      return;
    }
    this.__origin_nodes = o, this.rootNode = t, o.forEach((i) => {
      i.lot.eached = !1, i.lot.notLeafNode = !1, i.lot.childs = [], i.lot.index_of_parent = 0, i.lot.strength = 0, i.lot.strengthWithChilds_from = 0, i.lot.strengthWithChilds = 0, i.lot.prevNode = void 0, i.lot.nextNode = void 0, i.lot.placed = !1;
    }), this.allNodes = [];
    let n = {
      max_deep: 1,
      max_length: 1,
      max_strength: 1
    };
    this.analysisNodes4Didirectional(this.allNodes, [this.rootNode], 0, n, -1), this.placeNodesPosition(this.rootNode, this.allNodes, n), this.allNodes = [], n = {
      max_deep: 1,
      max_length: 1,
      max_strength: 1
    }, this.analysisNodes4Didirectional(this.allNodes, [this.rootNode], 0, n, 1), this.placeNodesPosition(this.rootNode, this.allNodes, n);
  }
  placeNodesPosition(o, t, n) {
    const i = this.graphSetting.viewSize.width, s = this.graphSetting.viewSize.height, a = 0, l = 0;
    if (o.fixed !== !0) {
      const c = Number.parseInt(this.config.centerOffset_x) || 0, d = Number.parseInt(this.config.centerOffset_y) || 0;
      o.lot.x = -(o.el.offsetWidth || o.width) / 2 + c, o.lot.y = -(o.el.offsetHeight || o.height) / 2 + d, this.config.from === "top" ? o.lot.y -= this.graphSetting.viewSize.height / 2 - (o.el.offsetHeight || o.height) - 100 : this.config.from === "bottom" ? o.lot.y += this.graphSetting.viewSize.height / 2 - (o.el.offsetHeight || o.height) - 200 : this.config.from === "right" ? o.lot.x += this.graphSetting.viewSize.width / 2 - (o.el.offsetWidth || o.width) - 100 : o.lot.x -= this.graphSetting.viewSize.width / 2 - (o.el.offsetWidth || o.width) - 100, u("graph offset:", c, d), u("create rootNode coordinates:", o.lot.x, o.lot.y), o.x = o.lot.x + a, o.y = o.lot.y + l;
    } else
      u("\u56FA\u5B9A\u4F4D\u7F6E\u7684rootNode:", o.text, o.x, o.y), o.origin_x === void 0 && (o.origin_x = o.x, o.origin_y = o.y), o.lot.x = o.origin_x, o.lot.y = o.origin_y, o.x = o.lot.x + a, o.y = o.lot.y + l, u("\u56FA\u5B9A\u4F4D\u7F6E\u7684rootNode:", o.text, o.x, o.y);
    o.lot.placed = !0;
    const r = {
      __mapWidth: i,
      __mapHeight: s
    };
    this.placeRelativePosition(o, n, r), t.forEach((c) => {
      if (c.fixed === !0) {
        c.lot.placed = !0;
        return;
      }
      if (!x.isAllowShowNode(c))
        return;
      const d = c.offset_x || 0, f = c.offset_y || 0;
      c.x = c.offset_x + c.lot.x + d, c.y = c.offset_y + c.lot.y + f, c.lot.placed = !0;
    });
  }
  placeRelativePosition(o, t, n) {
    if (this.config.from === "left" || this.config.from === "right") {
      const i = this.config.min_per_height || 80, s = this.config.max_per_height || 400, a = this.config.min_per_width || 430, l = this.config.max_per_width || 650;
      let r = Math.round((n.__mapWidth - 10) / (t.max_deep + 2));
      r < a && (r = a), r > l && (r = l);
      let c = Math.round(n.__mapHeight / (t.max_strength + 1));
      c < i && (c = i), c > s && (c = s), this.allNodes.forEach((d) => {
        d.fixed !== !0 && d.lot.placed !== !0 && d !== o && (this.config.from === "right" ? d.lot.x = o.lot.x - this.getLevelDistance(d, d.lot.subling.level, r) : d.lot.x = o.lot.x + this.getLevelDistance(d, d.lot.subling.level, r));
      }), this.allNodes.forEach((d) => {
        d.fixed !== !0 && d.lot.level !== 0 && (d.lot.y = o.lot.y + c * (t.max_strength / -2 + d.lot.strengthWithChilds_from + d.lot.strengthWithChilds / 2));
      });
    } else {
      const i = this.config.min_per_height || 250, s = this.config.max_per_height || 400, a = this.config.min_per_width || 250, l = this.config.max_per_width || 500;
      let r = Math.round((n.__mapWidth - 10) / (t.max_strength + 2));
      r < a && (r = a), r > l && (r = l);
      let c = Math.round((n.__mapHeight - 10) / (t.max_deep + 2));
      c < i && (c = i), c > s && (c = s), this.allNodes.forEach((d) => {
        d.fixed !== !0 && d.lot.placed !== !0 && d !== o && (this.config.from === "bottom" ? d.lot.y = o.lot.y - this.getLevelDistance(d, d.lot.subling.level, c) : d.lot.y = o.lot.y + this.getLevelDistance(d, d.lot.subling.level, c));
      }), this.allNodes.forEach((d) => {
        d.fixed !== !0 && d.lot.level !== 0 && (d.lot.x = o.lot.x + r * (t.max_strength / -2 + d.lot.strengthWithChilds_from + d.lot.strengthWithChilds / 2));
      });
    }
  }
  getLevelDistance(o, t, n) {
    const i = Math.abs(t);
    if (this.config.levelDistanceArr && this.config.levelDistanceArr.length > 0) {
      let s = 0;
      for (let a = 0; a < i; a++) {
        const l = this.config.levelDistanceArr[a] || 100;
        s += l;
      }
      return t > 0 ? s : s * -1;
    } else
      return t * n;
  }
}
class we {
  constructor(o, t) {
    p(this, "graphSetting");
    p(this, "config");
    p(this, "rootNode", null);
    p(this, "allNodes", []);
    p(this, "__origin_nodes", []);
    p(this, "layoutTimes", 0);
    this.config = o, this.graphSetting = t;
  }
  refresh() {
    u("SeeksCenterLayouter:refresh"), this.placeNodes(this.__origin_nodes, this.rootNode);
  }
  placeNodes(o, t) {
    if (u("SeeksCenterLayouter:placeNodes"), !t) {
      u("root is null:", t);
      return;
    }
    u("layout by root:", t), this.__origin_nodes = o, this.rootNode = t, o.forEach((i) => {
      i.lot.eached = !1, i.lot.notLeafNode = !1, i.lot.childs = [], i.lot.index_of_parent = 0, i.lot.strength = 0, i.lot.prevNode = void 0, i.lot.nextNode = void 0, i.lot.placed = !1;
    }), this.allNodes = [];
    const n = {
      max_deep: 1,
      max_length: 1
    };
    x.analysisNodes4Didirectional(this.allNodes, [this.rootNode], 0, n, 0), t.lot.x = -(t.el.offsetWidth || t.width) / 2, t.lot.y = -(t.el.offsetHeight || t.height) / 2, u("root position:", t.lot.x, t.lot.y), this.placeRelativePosition(this.rootNode, n), this.allNodes.forEach((i) => {
      if (i.fixed === !0 || !x.isAllowShowNode(i))
        return;
      const s = i.offset_x || 0, a = i.offset_y || 0;
      i.x = i.lot.x + s, i.y = i.lot.y + a, i.lot.placed = !0;
    }), u("Start Auto Layout.....");
  }
  placeRelativePosition(o, t) {
    const n = this.config.distance_coefficient === void 0 ? 1 : this.config.distance_coefficient;
    let i = Math.round((this.graphSetting.viewSize.height + this.graphSetting.viewSize.width) / t.max_deep * 0.2) * n;
    u("analyticResult:", t, i, this.config.distance_coefficient), i < 150 * n && (i = 150 * n);
    let s = 0;
    this.allNodes.forEach((l) => {
      if (l.lot.subling.level === 1) {
        s = Math.round(l.lot.subling.all_size * 50 / Math.PI / 2), s < i && (s = i);
        const r = x.getOvalPoint(o.lot.x, o.lot.y, l.lot.subling.level * s, l.lot.strength_plus - l.lot.strength / 2, l.lot.subling.all_strength);
        l.lot.x = r.x, l.lot.y = r.y;
      }
    });
    const a = Math.round(300 * n);
    this.allNodes.forEach((l) => {
      if (l.lot.subling.level > 1) {
        const r = l.lot.parent.lot.strength_plus - l.lot.parent.lot.strength, d = (l.lot.parent.lot.strength_plus - r) / (l.lot.parent.lot.childs_size + 1) * (l.lot.index_of_parent + 1), f = x.getOvalPoint(o.lot.x, o.lot.y, (l.lot.subling.level - 1) * a + s, r + d, l.lot.parent.lot.subling.all_strength);
        l.lot.x = f.x, l.lot.y = f.y;
      }
    });
  }
  autoLayout(o) {
    if (o && (this.layoutTimes = 0), u("this.layoutTimes:", this.layoutTimes), this.layoutTimes > 300) {
      this.graphSetting.autoLayouting = !1;
      return;
    }
    this.layoutTimes++, this.__origin_nodes.forEach((t) => {
      t.Fx = 0, t.Fy = 0;
    });
    for (const t in this.__origin_nodes) {
      const n = this.__origin_nodes[t];
      if (n.lot.placed === !0)
        for (const i in this.__origin_nodes) {
          const s = this.__origin_nodes[i];
          s.lot.placed === !0 && t !== i && this.addGravityByNode(n, s);
        }
    }
    for (const t in this.__origin_nodes)
      this.__origin_nodes[t].lot.parent && this.addElasticByLine(this.__origin_nodes[t].lot.parent, this.__origin_nodes[t]);
    for (const t in this.__origin_nodes)
      this.applyToNodePosition(this.__origin_nodes[t]);
    window.setTimeout(() => {
      this.autoLayout();
    }, 30);
  }
  stop() {
    this.layoutTimes = 1e3;
  }
  addElasticByLine(o, t) {
    let n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2);
    n > 1e3 && (n = 1e3);
    const i = n < 30 ? 0 : (n - 30) * 0.05, s = i, a = i, l = (o.x - t.x) / n, r = (o.y - t.y) / n;
    this.addFtoNode(o, l * s * -1, r * s * -1, 1), this.addFtoNode(t, l * a, r * a, 1);
  }
  addGravityByNode(o, t) {
    const n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2), i = 300;
    let s = n > i ? 0 : (i - n) * 0.03;
    const a = (o.x - t.x) / n, l = (o.y - t.y) / n;
    this.addFtoNode(o, a * s, l * s, 0), this.addFtoNode(t, a * s * -1, l * s * -1, 0);
  }
  getNodeFWeight(o) {
    let t = o.lot.level;
    return t > 7 && (t = 7), t < 0 && (t = 0), (8 - t) / 8;
  }
  addFtoNode(o, t, n) {
    isNaN(t) || isNaN(n) || (t = t / o.lot.strength, n = n / o.lot.strength, t > 50 && (t = 50), n > 50 && (n = 50), t < -50 && (t = -50), n < -50 && (n = -50), o.Fx += t, o.Fy += n);
  }
  applyToNodePosition(o) {
    const t = Math.round(o.Fx), n = Math.round(o.Fy);
    o.x = o.x + t, o.y = o.y + n, o.Fx = 0, o.Fy = 0;
  }
}
class be {
  constructor(o, t) {
    p(this, "setting");
    p(this, "config");
    p(this, "rootNode", null);
    p(this, "allNodes", []);
    p(this, "__origin_nodes", []);
    p(this, "__max_deep", 1);
    p(this, "__max_length", 1);
    p(this, "layoutTimes", 0);
    this.config = o, this.setting = t;
  }
  checkMaxDeepAndLength(o, t) {
    o.length > this.__max_length && (this.__max_length = o.length), t > this.__max_deep && (this.__max_deep = t);
    const n = {
      level: t,
      all_size: o.length,
      all_strength: 0
    }, i = [];
    o.forEach((l) => {
      l.lot || (l.lot = {}), l.lot.eached = !0, l.lot.subling = n, this.allNodes.push(l);
    });
    let s = 0, a;
    o.forEach((l) => {
      let r = 0;
      l.targetNodes && (l.targetNodes.forEach((c) => {
        u("child node::", c.type, c.lot.eached), c.lot || (c.lot = { eached: !1 }), c.type === "node" && c.targetNodes.length <= 1 ? c.lot.eached || (c.lot.parent = l, c.lot.index_of_p_childs = r, c.lot.prevNode = a, a && (a.lot.nextNode = c), a = c, l.lot.childs.push(c), l.lot.eached = !0, i.push(c), r++) : c.lot.notLeafNode = !0;
      }), l.targetNodes.forEach((c) => {
        c.lot.notLeafNode && (c.lot || (c.lot = { eached: !1 }), c.lot.eached || (c.lot.parent = l, c.lot.index_of_p_childs = r, c.lot.prevNode = a, a && (a.lot.nextNode = c), a = c, l.lot.childs.push(c), l.lot.eached = !0, i.push(c), r++));
      })), l.lot.strength = r > 0 ? r : 1, n.all_strength += l.lot.strength, l.lot.strength_plus = n.all_strength, l.lot.level_index = s, l.lot.childs_size = r, s++;
    }), i.length > 0 && this.checkMaxDeepAndLength(i, t + 1);
  }
  refresh() {
    this.placeNodes(this.__origin_nodes, this.rootNode);
  }
  placeNodes(o, t) {
    if (t)
      u("layout by root:", t);
    else {
      u("root is null:", t);
      return;
    }
    this.__origin_nodes = o, this.rootNode = t, o.forEach((a) => {
      a.lot.eached = !1, a.lot.notLeafNode = !1, a.lot.childs = [], a.lot.parent = void 0, a.lot.index_of_p_childs = 0, a.lot.strength = 0, a.lot.prevNode = void 0, a.lot.nextNode = void 0;
    }), this.allNodes = o, u("max before:", this.__max_deep, this.__max_length), u("max after:", this.__max_deep, this.__max_length);
    const n = {
      x: 0,
      y: 0
    }, i = this.allNodes.length;
    let s = i * 90 / Math.PI / 2;
    s < 200 && (s = 200), s > 800 && (s = 800), this.allNodes.forEach((a, l) => {
      const r = x.getOvalPoint(n.x, n.y, s, l, i);
      a.x = r.x, a.y = r.y;
    }), u("Start Auto Layout.....");
  }
  adjustLevel2Y(o) {
    for (let t = 0; t < this.allNodes.length; t++) {
      const n = this.allNodes[t];
      if (n.lot.subling.level === 1 && n.lot.childs_size === 0) {
        let i = Math.round(o / (n.lot.subling.all_size + 1));
        i > 70 && (i = 70), u(i, o, n.lot.subling.all_size, n.lot.subling.all_strength, n.lot.strength);
        for (let s = 0; s < this.allNodes.length; s++) {
          const a = this.allNodes[s];
          if (a.lot.subling.level === 1 && a !== n) {
            const l = Math.abs(n.y - a.y);
            if (l < i - 2) {
              u("__y_diff", n.name, a.name, l), n.y = a.y + i, t--;
              break;
            }
          }
        }
      }
    }
  }
  autoLayout(o) {
    if (o && (this.layoutTimes = 0), u("this.layoutTimes:", this.layoutTimes), this.layoutTimes > 300) {
      this.setting.autoLayouting = !1;
      return;
    }
    this.layoutTimes++, this.allNodes.forEach((t) => {
      t.Fx = 0, t.Fy = 0;
    });
    for (const t in this.allNodes)
      for (const n in this.allNodes)
        t !== n && this.addGravityByNode(this.allNodes[t], this.allNodes[n]);
    for (const t in this.allNodes)
      this.allNodes[t].lot.parent && this.addElasticByLine(this.allNodes[t].lot.parent, this.allNodes[t]);
    for (const t in this.allNodes)
      this.applyToNodePosition(this.allNodes[t]);
    window.setTimeout(() => {
      this.autoLayout();
    }, 30);
  }
  stop() {
    this.layoutTimes = 1e3;
  }
  addElasticByLine(o, t) {
    const n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2), i = n < 30 ? 0 : (n - 30) * 0.01;
    this.addFtoNode(o, (o.x - t.x) * i * -1, (o.y - t.y) * i * -1), this.addFtoNode(t, (t.x - o.x) * i * -1, (t.y - o.y) * i * -1);
  }
  addGravityByNode(o, t) {
    const n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2), i = n > 300 ? 0 : (300 - n) * 0.02;
    let s = o.x - t.x, a = o.y - t.y;
    s === 0 && (s = 1), a === 0 && (a = 1), this.addFtoNode(o, s * i, a * i), this.addFtoNode(t, s * -1 * i, a * -1 * i);
  }
  addFtoNode(o, t, n) {
    o.Fx += t, o.Fy += n;
  }
  applyToNodePosition(o) {
    if (this.rootNode === o)
      return;
    o.Fx > 1e3 && (o.Fx = 3e3), o.Fy > 1e3 && (o.Fy = 3e3), o.Fx < -1e3 && (o.Fx = -3e3), o.Fy < -1e3 && (o.Fy = -3e3);
    const t = Math.round(o.Fx * 0.02), n = Math.round(o.Fy * 0.02);
    o.x = o.x + t, o.y = o.y + n, o.Fx = 0, o.Fy = 0;
  }
}
class ee {
  constructor(o, t) {
    p(this, "graphOptions");
    p(this, "config");
    p(this, "rootNode", null);
    p(this, "allNodes", []);
    p(this, "__origin_nodes", []);
    p(this, "layoutTimes", 0);
    p(this, "maxLayoutTimes", 300);
    p(this, "justLayoutSingleNode", !1);
    p(this, "byNode", !0);
    p(this, "byLine", !0);
    this.config = o, this.graphOptions = t;
  }
  refresh() {
    this.placeNodes(this.__origin_nodes, this.rootNode);
  }
  placeNodes(o, t) {
    if (t)
      u("layout by root:", t);
    else {
      u("root is null:", t);
      return;
    }
    this.__origin_nodes = o, this.rootNode = t;
    let n = 0;
    this.__origin_nodes.forEach((i) => {
      i.lot.placed && n++;
    }), this.analysisNodes(), n === 0 ? this.initNodesPosition() : this.__origin_nodes.forEach((i) => {
      i.fixed !== !0 && (i.lot.placed || (i.x || (i.x = Math.floor(Math.random() * 200) - 100), i.x || (i.y = Math.floor(Math.random() * 200) - 100), i.lot.placed = !0));
    }), u("Start Auto Layout....."), this.autoLayout(!0);
  }
  analysisNodes() {
    this.__origin_nodes.forEach((t) => {
      t.lot.eached = !1, t.lot.notLeafNode = !1, t.lot.childs = [], t.lot.index_of_parent = 0, t.lot.strength = 0, t.lot.prevNode = void 0, t.lot.nextNode = void 0, t.lot.placed = !1;
    }), this.allNodes = [];
    const o = {
      max_deep: 1,
      max_length: 1
    };
    x.analysisNodes4Didirectional(this.allNodes, [this.rootNode], 0, o, 0);
  }
  initNodesPosition() {
    this.rootNode.lot.x = -(this.rootNode.el.offsetWidth || this.rootNode.width) / 2, this.rootNode.lot.y = -(this.rootNode.el.offsetHeight || this.rootNode.height) / 2, u("root position:", this.rootNode.lot.x, this.rootNode.lot.y), u("[layout canvasOffset]", this.graphOptions.viewSize, this.graphOptions.canvasSize), this.placeRelativePosition(this.rootNode), this.__origin_nodes.forEach((o) => {
      o.fixed !== !0 && (!x.isAllowShowNode(o) || (o.x = o.lot.x, o.y = o.lot.y, o.lot.placed = !0));
    });
  }
  placeRelativePosition(o) {
    let t = 80;
    this.allNodes.forEach((n) => {
      if (n.lot.subling.level === 1) {
        t = n.lot.subling.all_size * 20 / Math.PI / 2, t < 80 && (t = 80);
        const i = x.getOvalPoint(o.lot.x, o.lot.y, n.lot.subling.level * t, n.lot.strength_plus - n.lot.strength / 2, n.lot.subling.all_strength);
        n.lot.x = i.x, n.lot.y = i.y;
      }
    }), this.allNodes.forEach((n) => {
      if (n.lot.subling.level > 1) {
        const i = n.lot.parent.lot.strength_plus - n.lot.parent.lot.strength, a = (n.lot.parent.lot.strength_plus - i) / (n.lot.parent.lot.childs_size + 1) * (n.lot.index_of_parent + 1), l = x.getOvalPoint(o.lot.x, o.lot.y, (n.lot.subling.level - 1) * 80 + t, i + a, n.lot.parent.lot.subling.all_strength);
        n.lot.x = l.x, n.lot.y = l.y;
      }
    });
  }
  autoLayout(o) {
    if (o && (this.layoutTimes = 0), u("this.layoutTimes:", this.layoutTimes), this.layoutTimes > this.maxLayoutTimes) {
      this.graphOptions.autoLayouting = !1;
      return;
    }
    if (this.graphOptions.autoLayouting = !0, this.layoutTimes++, this.__origin_nodes.forEach((t) => {
      t.Fx = 0, t.Fy = 0;
    }), this.byNode)
      for (const t in this.__origin_nodes) {
        const n = this.__origin_nodes[t];
        if (!(this.justLayoutSingleNode && !n.singleNode) && !n.fixed && n.lot.placed === !0)
          for (const i in this.__origin_nodes) {
            const s = this.__origin_nodes[i];
            s.lot.placed === !0 && t !== i && this.addGravityByNode(n, s);
          }
      }
    if (this.byLine)
      for (const t in this.__origin_nodes)
        this.__origin_nodes[t].fixed || this.__origin_nodes[t].lot.parent && this.addElasticByLine(this.__origin_nodes[t].lot.parent, this.__origin_nodes[t]);
    for (const t in this.__origin_nodes)
      this.applyToNodePosition(this.__origin_nodes[t]);
    window.setTimeout(() => {
      this.autoLayout();
    }, 30);
  }
  stop() {
    this.layoutTimes = 1e3;
  }
  addElasticByLine(o, t) {
    let n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2);
    n > 1e3 && (n = 1e3);
    const i = n < 30 ? 0 : (n - 30) * 0.05, s = i, a = i, l = (o.x - t.x) / n, r = (o.y - t.y) / n;
    this.addFtoNode(o, l * s * -1, r * s * -1, 1), this.addFtoNode(t, l * a, r * a, 1);
  }
  addGravityByNode(o, t) {
    const n = Math.sqrt((o.y - t.y) ** 2 + (o.x - t.x) ** 2), i = 300;
    let s = n > i ? 0 : (i - n) * 0.03;
    const a = (o.x - t.x) / n, l = (o.y - t.y) / n;
    this.addFtoNode(o, a * s, l * s, 0), this.addFtoNode(t, a * s * -1, l * s * -1, 0);
  }
  getNodeFWeight(o) {
    let t = o.lot.level;
    return t > 7 && (t = 7), t < 0 && (t = 0), (8 - t) / 8;
  }
  addFtoNode(o, t, n) {
    this.justLayoutSingleNode && !o.singleNode || Number.isNaN(t) || Number.isNaN(n) || (t = t / (o.lot.strength || 1), n = n / (o.lot.strength || 1), t > 50 && (t = 50), n > 50 && (n = 50), t < -50 && (t = -50), n < -50 && (n = -50), o.Fx += t, o.Fy += n);
  }
  applyToNodePosition(o) {
    if (o.fixed)
      return;
    const t = Math.round(o.Fx), n = Math.round(o.Fy);
    o.x = o.x + t, o.y = o.y + n, o.Fx = 0, o.Fy = 0;
  }
}
class Ce {
  constructor(o, t) {
    p(this, "setting");
    p(this, "config");
    p(this, "rootNode", null);
    p(this, "allNodes", []);
    p(this, "__origin_nodes", []);
    this.config = o, this.setting = t;
  }
  refresh() {
    this.placeNodes(this.__origin_nodes, this.rootNode);
  }
  placeNodes(o, t) {
    if (t)
      u("layout by root:", t);
    else {
      u("root is null:", t);
      return;
    }
    this.__origin_nodes = o, this.rootNode = t, o.forEach((i) => {
      i.lot.eached = !1, i.lot.notLeafNode = !1, i.lot.childs = [], i.lot.index_of_parent = 0, i.lot.strength = 0, i.lot.prevNode = void 0, i.lot.nextNode = void 0, i.lot.placed = !1;
    }), this.allNodes = [];
    const n = {
      max_deep: 1,
      max_length: 1
    };
    x.analysisNodes4Didirectional(this.allNodes, [this.rootNode], 0, n, 0), u("[layout canvasOffset]", this.setting.viewSize, this.setting.canvasSize);
  }
}
const ke = (e, o) => {
  o.layoutClassName = e.layoutClassName, o.layoutLabel = e.label, o.layoutName = e.layoutName, o.layoutDirection = e.layoutDirection, e.useLayoutStyleOptions === !0 && (o.defaultExpandHolderPosition = e.defaultExpandHolderPosition, o.defaultJunctionPoint = e.defaultJunctionPoint, o.defaultNodeColor = e.defaultNodeColor, o.defaultNodeFontColor = e.defaultNodeFontColor, o.defaultNodeBorderColor = e.defaultNodeBorderColor, o.defaultNodeBorderWidth = e.defaultNodeBorderWidth, o.defaultLineColor = e.defaultLineColor, o.defaultLineWidth = e.defaultLineWidth, o.defaultLineShape = e.defaultLineShape, o.defaultNodeShape = e.defaultNodeShape, o.defaultNodeWidth = e.defaultNodeWidth, o.defaultNodeHeight = e.defaultNodeHeight, o.defaultLineMarker = e.defaultLineMarker, o.defaultShowLineLabel = e.defaultShowLineLabel);
  let t = null;
  return e.layoutName === "SeeksBidirectionalTreeLayouter" || e.layoutName === "tree" ? t = new ve(e, o) : e.layoutName === "SeeksCenterLayouter" || e.layoutName === "center" ? t = new we(e, o) : e.layoutName === "SeeksCircleLayouter" || e.layoutName === "circle" ? t = new be(e, o) : e.layoutName === "SeeksForceLayouter" || e.layoutName === "force" ? t = new ee(e, o) : (e.layoutName === "SeeksFixedLayouter" || e.layoutName === "fixed") && (t = new Ce(e, o)), o.isNeedShowAutoLayoutButton = e.allowAutoLayoutIfSupport !== !1 && t.autoLayout !== void 0, t;
}, Ze = (e, o) => {
  const t = o.layouter ? o.layouter.__origin_nodes : [], n = o.layouter ? o.layouter.rootNode : null;
  if (typeof e == "string") {
    for (const i in o.layouts)
      if (i.label === e) {
        e = i;
        break;
      }
  }
  u("[change layout]switchLayout"), o.layouter = ke(e, o), o.layouter.__origin_nodes = t, o.layouter.rootNode = n;
};
class Je {
  constructor(o, t) {
    p(this, "instanceId", "");
    p(this, "options");
    p(this, "listeners");
    this.listeners = t, this.options = new q(o), this.instanceId = this.options.instanceId, u("new RelationGraph:", this);
  }
  enableDebugLog(o) {
    this.options.debug = o, window && (window.relationGraphDebug = o);
  }
}
let R = { x: 0, y: 0 };
const B = { x: 0, y: 0 }, O = { x: 0, y: 0 };
let Z, J;
const se = (e) => {
  const o = {
    clientX: 0,
    clientY: 0
  };
  if (H) {
    const t = e.touches || e.targetTouches;
    if (!t)
      throw new Error("error targetTouches");
    o.clientX = t[0].clientX, o.clientY = t[0].clientY;
  } else
    o.clientX = e.clientX, o.clientY = e.clientY;
  return o;
}, $ = {
  startDrag(e, o, t, n) {
    n ? Z = (i, s, a) => {
      const l = i - O.x, r = s - O.y;
      n(l, r, B, O, a);
    } : Z = (i, s) => {
      R.x = B.x + (i - O.x), R.y = B.y + (s - O.y);
    }, J = t, R = o, B.x = R.x, B.y = R.y, u("[canvas]onDragStart...", H, e);
    try {
      const i = se(e);
      O.x = i.clientX, O.y = i.clientY, H ? (e.preventDefault(), document.body.addEventListener("touchmove", $.onNodeMove), document.body.addEventListener("touchend", $.onNodeDragend)) : (document.body.addEventListener("mousemove", $.onNodeMove), document.body.addEventListener("mouseup", $.onNodeDragend));
    } catch (i) {
      console.error(i.message);
    }
  },
  onNodeMove(e) {
    const o = se(e);
    Z(o.clientX, o.clientY, e);
  },
  onNodeDragend(e) {
    H ? (document.body.removeEventListener("touchmove", $.onNodeMove), document.body.removeEventListener("touchend", $.onNodeDragend)) : (document.body.removeEventListener("mousemove", $.onNodeMove), document.body.removeEventListener("mouseup", $.onNodeDragend)), u("Node dragend"), J && J(
      R.x - B.x,
      R.y - B.y,
      e
    );
  },
  transName4Circle(e) {
    let o = 0, t = [];
    const n = [];
    for (const i of e)
      t.push(i), t.length === Ue[o] && (n.push(t.join("")), o++, t = []);
    return t.length > 0 && n.push(t.join("")), n.join("<br>");
  },
  getColorId(e) {
    return e = e.replace("#", ""), e = e.replace("(", ""), e = e.replace(")", ""), e = e.replace(/,/, "-"), e;
  }
}, Ue = [4, 5, 6, 4, 2, 100];
class Ye extends Je {
  constructor(t, n) {
    super(t, n);
    p(this, "graphData", {
      nodes: [],
      lines: []
    });
    p(this, "tmpData", {
      nodes: [],
      lines: []
    });
    p(this, "seeksNodeIdIndex", 0);
    p(this, "allLineColors", []);
    p(this, "userLayouerClass", null);
  }
  ready() {
    this.initLayouter(), this.resetViewSize(), this.refreshNVAnalysisInfo();
  }
  setOptions(t, n) {
    this.options = new q(t), this.initLayouter(), this.resetViewSize(), this.doLayout(), this.resetViewSize(), n && n(this);
  }
  setLayouter(t) {
    u("setLayouterClass::", t), this.userLayouerClass = t;
  }
  initLayouter() {
    if (this.userLayouerClass)
      u("Use user layouter:", this.userLayouerClass), this.options.layouter = this.userLayouerClass;
    else if (this.options.layouts && this.options.layouts.length > 0) {
      const t = this.options.layouts[0];
      u("[change layout]Create default layouter\uFF1A", this.options.layoutName), t.layouter ? this.options.layouter = t.layouter : this.options.layouter = ke(t, this.options);
    } else
      u("\u4F60\u9700\u8981\u8BBE\u7F6Elayouts\u6765\u6307\u5B9A\u5F53\u524D\u56FE\u8C31\u53EF\u4EE5\u4F7F\u7528\u7684\u5E03\u5C40\u5668\uFF01");
    u("Layouter instance:", this.options.layouter);
  }
  setJsonData(t, n, i) {
    arguments.length === 2 && typeof n == "function" && (i = n, n = !0), this.nodeViewList = [], this.lineViewList = [], this.graphData.nodes = [], this.graphData.links = [], this.tmpData.nodes_map = {}, this.tmpData.lines_map = {}, this.graphData.rootNode = null, u("set jsonData:", t);
    const s = t.rootId;
    this.loadGraphJsonData(t), s && (this.graphData.rootNode = this.tmpData.nodes_map[s]), !this.graphData.rootNode && this.graphData.nodes.length > 0 && (this.graphData.rootNode = this.graphData.nodes[0]), this.applyNewDataToCanvas(), n && (u("resetViewSize:", n), this.resetViewSize()), setTimeout(() => {
      this.doLayout(), i && i(this);
    }, 500);
  }
  applyNewDataToCanvas() {
    if (this.graphData.nodes.forEach((t) => {
      t.appended === !1 && (t.appended = !0, this.nodeViewList.push(t));
    }), this.graphData.links.forEach((t) => {
      t.appended === !1 && (t.appended = !0, this.lineViewList.push(t));
    }), this.graphData.rootNode)
      this.options.defaultFocusRootNode && this.setCheckedNode(this.graphData.rootNode.id);
    else
      throw new Error("\u6CA1\u6709\u8BBE\u7F6E\u6839\u8282\u70B9[rootId]\uFF01\u4E5F\u65E0\u6CD5\u83B7\u53D6\u6839\u8282\u70B9!");
  }
  appendJsonData(t, n, i) {
    arguments.length === 2 && typeof n == "function" && (i = n, n = !0), u("appendData:", t), this.loadGraphJsonData(t), this.applyNewDataToCanvas(), n && this.doLayout(), i && i(this);
  }
  loadNodes(t) {
    t.forEach((n) => {
      let i = K(n), s = !1;
      this.tmpData.nodes_map[i.id] ? i = this.tmpData.nodes_map[i.id] : s = !0, s && (this.tmpData.nodes_map[i.id] = i, this.graphData.nodes.push(i), i.seeks_id = this.seeksNodeIdIndex++, i.appended = !1);
    });
  }
  loadLines(t) {
    t.forEach((n) => {
      let i = !1, s, a;
      if (typeof n.from == "object" ? s = n.from : s = this.tmpData.nodes_map[n.from], typeof n.to == "object" ? a = n.to : a = this.tmpData.nodes_map[n.to], !s) {
        console.error("\u627E\u4E0D\u5230from:", n);
        return;
      }
      if (!a) {
        console.error("\u627E\u4E0D\u5230to:", n);
        return;
      }
      const l = `${s.seeks_id}-${a.seeks_id}`, r = `${a.seeks_id}-${s.seeks_id}`, c = Y(n);
      let d, f = !1;
      this.tmpData.lines_map[l] ? d = this.tmpData.lines_map[l] : this.tmpData.lines_map[r] ? (d = this.tmpData.lines_map[r], f = !0) : (i = !0, d = {
        seeks_id: l,
        fromNode: s,
        toNode: a,
        appended: !1,
        relations: []
      });
      let h = c.arrow;
      c.isHideArrow || (h = this.getLineArrow(c.color)), s.targetNodes || (s.targetNodes = []), a.targetNodes || (a.targetNodes = []), s.targetNodes.includes(a) || s.targetNodes.push(a), a.targetNodes.includes(s) || a.targetNodes.push(s), s.targetTo.includes(a) || s.targetTo.push(a), a.targetFrom.includes(s) || a.targetFrom.push(s);
      let g = !1;
      for (let _ = 0; _ < d.relations.length; _++)
        if (d.relations[_].id === c.id) {
          g = !0;
          break;
        }
      g === !1 && (c.id || (c.id = `${d.seeks_id}-${d.relations.length}`), c.isReverse = f, c.arrow = h, c.textPositon = { x: 0, y: 0 }, d.relations.push(c)), i && (this.graphData.links.push(d), this.tmpData.lines_map[l] = d, d.appended = !1);
    });
  }
  flatNodeData(t, n, i, s) {
    t.forEach((a) => {
      i.push(a), n && s.push({
        from: n.id,
        to: a.id
      });
      const l = a.childs || a.children;
      l && l.length > 0 && this.flatNodeData(l, a, i, s);
    });
  }
  loadGraphJsonData(t, n) {
    t.lines || (t.lines = t.relations, console.warn("[relation-graph] For compatibility with older versionsm, Use jsonData.relations as jsonData.lines, It is recommended that you define your data using")), t.lines || (t.lines = t.links, console.warn("[relation-graph] For compatibility with older versionsm, Use jsonData.links as jsonData.lines, It is recommended that you define your data using"));
    const i = t.nodes, s = [], a = [];
    this.flatNodeData(i, null, s, a), t.lines.forEach((l) => {
      a.push(l);
    }), this.loadNodes(s), u("Nodes is initialized"), this.loadLines(a);
  }
  getLineArrow(t, n, i) {
    const s = n ? "start-" : "";
    if (i)
      return `${this.options.instanceId}-${s}arrow-checked`;
    if (t) {
      const a = $.getColorId(t);
      return this.allLineColors.map((l) => l.id).includes(a) || this.allLineColors.push({ id: a, color: t }), `${this.options.instanceId}-${s}arrow-${a}`;
    } else
      return `${this.options.instanceId}-${s}arrow-default`;
  }
  getNodes() {
    return this.graphData.nodes;
  }
  getLinks() {
    return this.graphData.links;
  }
  getGraphJsonData() {
    const t = [], n = [];
    return this.graphData.nodes.forEach((i) => {
      const s = Q(i);
      s && t.push(s);
    }), this.graphData.links.forEach((i) => {
      X(i, n);
    }), {
      rootId: this.graphData.rootNode ? this.graphData.rootNode.id : "",
      nodes: t,
      lines: n
    };
  }
  getGraphJsonOptions() {
    const t = {}, n = [
      "layouter",
      "autoLayouting",
      "canvasNVInfo",
      "canvasOffset",
      "canvasZoom",
      "fullscreen",
      "instanceId",
      "layoutClassName",
      "layoutDirection",
      "layoutLabel",
      "layoutName",
      "resetViewSize",
      "viewELSize",
      "viewNVInfo",
      "viewSize",
      "canvasSize"
    ];
    return Object.keys(this.options).forEach((i) => {
      n.includes(i) || (t[i] = this.options[i]);
    }), t;
  }
  printGraphJsonData() {
    u("graph options:", JSON.stringify(this.getGraphJsonOptions())), u("graph json data:", JSON.stringify(this.getGraphJsonData()));
  }
  getNodeById(t) {
    for (let n = 0; n < this.graphData.nodes.length; n++)
      if (this.graphData.nodes[n].id === t)
        return this.graphData.nodes[n];
  }
  addNodes(t, n) {
    this.loadNodes(t), n && this.doLayout();
  }
  addLines(t, n) {
    this.loadLines(t), n && this.doLayout();
  }
  removeNodeById(t) {
    let n = 0;
    for (let s = 0; s < this.graphData.links.length; s++) {
      const a = this.graphData.links[s];
      (a.fromNode.id === t || a.toNode.id === t) && (a.hidden = !0, this.graphData.links.splice(s, 1), s--, n++);
    }
    u("\u5220\u9664\u5BF9\u5E94\u7684\u7EBF\u4E2A\u6570\uFF1A", t, n);
    let i = 0;
    for (let s = 0; s < this.graphData.nodes.length; s++)
      if (this.graphData.nodes[s].id === t) {
        const a = this.graphData.nodes[s];
        a.targetNodes.forEach((l) => {
          const r = l.targetNodes.indexOf(a);
          r !== -1 && l.targetNodes.splice(r, 1);
        }), this.graphData.nodes.splice(s, 1), delete this.tmpData.nodes_map[a.id], i++;
        break;
      }
    u("\u5220\u9664\u5BF9\u5E94\u7684\u8282\u70B9\u4E2A\u6570\uFF1A", t, i);
  }
  removeLinkById(t, n) {
    for (let i = 0; i < this.graphData.links.length; i++) {
      const s = this.graphData.links[i];
      (s.fromNode.id === t || s.toNode.id === n) && (this.graphData.links.splice(i, 1), i--);
    }
  }
  focusRootNode() {
    u("relation-graph:focusRootNode"), this.handleSelect(this.graphData.rootNode);
  }
  setNodePosition(t, n, i) {
    t.x = n, t.y = i;
  }
  focusNodeById(t) {
    this.graphData.nodes.forEach((n) => {
      n.id === t && this.handleSelect(n);
    });
  }
  querySearchAsync(t, n) {
    if (u("fetch-suggestions", t), t = t.trim(), t === "")
      return;
    const i = [];
    this.graphData.nodes.forEach((s) => {
      u("fetch:", s.text), s.text.includes(t) && i.push(s);
    }), u("fetched:", i.length), n(i);
  }
  handleSelect(t) {
    u("checked:", t), scrollTo({
      top: this.$dom.offsetTop
    }), this.animateToZoom(100, 300, () => {
      const n = t.width || 50, i = t.height || 50, s = t.x * -1 + this.options.viewSize.width / 2 - n / 2, a = t.y * -1 + this.options.viewSize.height / 2 - i / 2;
      this.animateGoto(s, a, 500, () => {
        this.options.checkedNodeId = t.id, this.refreshNVAnalysisInfo();
      });
    });
  }
}
class Xe extends Ye {
  constructor(t, n) {
    super(t, n);
    p(this, "$dom");
    p(this, "$canvasDom");
  }
  setDom(t) {
    this.$dom = t;
  }
  setCanvasDom(t) {
    this.$canvasDom = t;
  }
  fullscreen(t) {
    t === void 0 ? (this.options.fullscreen = !this.options.fullscreen, D.toggle(this.$dom).then(() => {
      setTimeout(() => {
        this.refreshNVAnalysisInfo();
      }, 1e3);
    })) : (this.options.fullscreen = t, setTimeout(() => {
      this.refreshNVAnalysisInfo();
    }, 1e3));
  }
}
class qe extends Xe {
  constructor(t, n) {
    super(t, n);
    p(this, "zoomCenter_of_newSize", { x: 0, y: 0 });
  }
  zoom(t, n) {
    if (this.options.canvasZoom + t < 10)
      return;
    const i = this.options.canvasZoom + t, s = this.showZoomCenter(n, t);
    this.options.canvasOffset.x += s.buff_x, this.options.canvasOffset.y += s.buff_y, this.options.canvasZoom = i, this.refreshNVAnalysisInfo();
  }
  setZoom(t, n) {
    const i = Math.floor(t - this.options.canvasZoom);
    this.zoom(i);
  }
  showZoomCenter(t, n) {
    if (!this.$dom)
      return;
    const i = this.options.canvasZoom / 100, s = (this.options.canvasZoom + n) / 100;
    this.currentZoomSet = this.analysisByZoom(i, t), this.newZoomSet = this.analysisByZoom(s, t);
    const a = s / i, l = 0, r = 0, c = s / i, d = 0, f = 0;
    this.zoomCenter_of_newSize.x = a * this.currentZoomSet.NMViewBuff.x + r * this.currentZoomSet.NMViewBuff.y + d, this.zoomCenter_of_newSize.y = l * this.currentZoomSet.NMViewBuff.x + c * this.currentZoomSet.NMViewBuff.y + f;
    const h = this.currentZoomSet.NMViewBuff.x - this.zoomCenter_of_newSize.x, g = this.currentZoomSet.NMViewBuff.y - this.zoomCenter_of_newSize.y;
    this.zoomCenter_of_newSize.x += this.currentZoomSet.NMCanvasCenter.x, this.zoomCenter_of_newSize.y += this.currentZoomSet.NMCanvasCenter.y;
    let _ = this.currentZoomSet.NMCanvasStart.x - this.currentZoomSet.NMCanvasCenter.x, w = this.currentZoomSet.NMCanvasStart.y - this.currentZoomSet.NMCanvasCenter.y, C = a * _ + r * w + d, G = l * _ + c * w + f;
    return this.newZoomSet.NMCanvasStart.x = h + this.currentZoomSet.NMCanvasCenter.x + C, this.newZoomSet.NMCanvasStart.y = h + this.currentZoomSet.NMCanvasCenter.y + G, _ = this.currentZoomSet.NMCanvasEnd.x - this.currentZoomSet.NMCanvasCenter.x, w = this.currentZoomSet.NMCanvasEnd.y - this.currentZoomSet.NMCanvasCenter.y, C = a * _ + r * w + d, G = l * _ + c * w + f, this.newZoomSet.NMCanvasEnd.x = h + this.currentZoomSet.NMCanvasCenter.x + C, this.newZoomSet.NMCanvasEnd.y = h + this.currentZoomSet.NMCanvasCenter.y + G, this.currentZoomSet.NMCanvasOffsetBuff.x = h, this.currentZoomSet.NMCanvasOffsetBuff.y = g, {
      buff_x: h,
      buff_y: g
    };
  }
  analysisByZoom(t, n) {
    const i = {
      NMViewPosition: { x: 0, y: 0 },
      NMViewCenter: { x: 0, y: 0 },
      NMCanvasCenter: { x: 0, y: 0 },
      NMCanvasStart: { x: 0, y: 0 },
      NMCanvasEnd: { x: 0, y: 0 },
      NMZoomCenter: { x: 0, y: 0 },
      NMViewBuff: { x: 0, y: 0 },
      NMCanvasOffsetBuff: { x: 0, y: 0 },
      NMCanvasSize: { width: 0, height: 0 }
    }, s = Ee(), a = Ae(), l = this.$dom.getBoundingClientRect();
    i.NMViewPosition.x = l.left, i.NMViewPosition.y = l.top, l.width + i.NMViewPosition.x > s ? i.NMViewCenter.x = (s - l.left) / 2 : i.NMViewCenter.x = l.width / 2, l.height + i.NMViewPosition.y > a ? i.NMViewCenter.y = (a - l.top) / 2 : i.NMViewCenter.y = l.height / 2;
    const r = this.options.canvasSize.width * t, c = this.options.canvasSize.height * t;
    i.NMCanvasCenter.x = this.options.canvasOffset.x + this.options.canvasSize.width / 2, i.NMCanvasCenter.y = this.options.canvasOffset.y + this.options.canvasSize.height / 2, i.NMCanvasStart.x = i.NMCanvasCenter.x - r / 2, i.NMCanvasStart.y = i.NMCanvasCenter.y - c / 2, i.NMCanvasEnd.x = i.NMCanvasCenter.x + r / 2, i.NMCanvasEnd.y = i.NMCanvasCenter.y + c / 2, i.NMZoomCenter.x = i.NMViewCenter.x, i.NMZoomCenter.y = i.NMViewCenter.y, n && (i.NMZoomCenter.x = n.x - i.NMViewPosition.x, i.NMZoomCenter.y = n.y - i.NMViewPosition.y);
    let d = i.NMViewCenter.x - i.NMCanvasCenter.x, f = i.NMViewCenter.y - i.NMCanvasCenter.y;
    return n && (d = i.NMZoomCenter.x - i.NMCanvasCenter.x, f = i.NMZoomCenter.y - i.NMCanvasCenter.y), i.NMViewBuff.x = d, i.NMViewBuff.y = f, i.NMCanvasSize.width = r, i.NMCanvasSize.height = c, i;
  }
}
class Ke extends qe {
  constructor(o, t) {
    super(o, t);
  }
  doLayout() {
    if (!this.options.layouter) {
      u("no layouter");
      return;
    }
    if (!this.graphData.rootNode) {
      u("Cant find rootNode!");
      return;
    }
    u("node size\uFF1A", this.graphData.nodes.length), this.options.layouter.placeNodes(this.graphData.nodes, this.graphData.rootNode, this.graphSetting);
  }
  refresh(o) {
    this.resetViewSize(), this.options.layouter.refresh(), this.playShowEffect(o);
  }
  resetViewSize() {
    !this.options || (u("resetViewSize"), this.options.viewSize.width = this.$dom.getBoundingClientRect().width, this.options.viewSize.height = this.$dom.getBoundingClientRect().height, this.options.canvasZoom = 100, this.options.canvasOffset.x = this.options.viewNVInfo.width / 2, this.options.canvasOffset.y = this.options.viewNVInfo.height / 2, this.refreshNVAnalysisInfo());
  }
  dataUpdated() {
    this.zoom(1), this.zoom(-1);
  }
  refreshNVAnalysisInfo() {
    if (!this.$dom) {
      console.error("cannot get view size !");
      return;
    }
    const o = {
      NMCanvasCenter: { x: 0, y: 0 }
    }, t = this.$dom.getBoundingClientRect();
    this.options.viewNVInfo.x = t.left, this.options.viewNVInfo.y = t.top, this.options.viewNVInfo.width = t.width, this.options.viewNVInfo.height = t.height;
    const n = this.options.canvasSize.width * (this.options.canvasZoom / 100), i = this.options.canvasSize.height * (this.options.canvasZoom / 100);
    o.NMCanvasCenter.x = this.options.canvasOffset.x + this.options.canvasSize.width / 2, o.NMCanvasCenter.y = this.options.canvasOffset.y + this.options.canvasSize.height / 2, this.options.canvasNVInfo.x = o.NMCanvasCenter.x - n / 2, this.options.canvasNVInfo.y = o.NMCanvasCenter.y - i / 2, this.options.canvasNVInfo.width = n, this.options.canvasNVInfo.height = i, this.options.viewELSize.width = t.width, this.options.viewELSize.height = t.height, this.options.viewELSize.left = t.left, this.options.viewELSize.top = t.top;
  }
  getStuffSize() {
    let o = 9999999, t = 9999999, n = 0, i = 0;
    this.graphData.nodes.forEach((r) => {
      r.x < o && (o = r.x), r.x > n && (n = r.x + r.el.offsetWidth), r.y < t && (t = r.y), r.y > i && (i = r.y + r.el.offsetHeight);
    });
    const s = 100, a = n - o + s, l = i - t + s;
    return {
      width: a,
      height: l,
      minX: o,
      maxX: n,
      minY: t,
      maxY: i
    };
  }
  getNodesCenter() {
    const o = this.getStuffSize();
    u("getStuffSize:", o);
    const t = o.minX + (o.width - 100) / 2, n = o.minY + (o.height - 100) / 2;
    return {
      x: t,
      y: n
    };
  }
  setCanvasCenter(o, t) {
    const n = this.options.viewSize.width / 2, i = this.options.viewSize.height / 2;
    this.setCanvasOffset(n - o, i - t);
  }
  setCanvasOffset(o, t) {
    this.options.canvasOffset.x = o, this.options.canvasOffset.y = t;
  }
  playShowEffect(o) {
    if (this.graphData.nodes.length === 0) {
      u("relation-graph:move to center: data not ready!");
      return;
    }
    if (u("playShowEffect:", this.options.moveToCenterWhenRefresh, this.options.zoomToFitWhenRefresh), this.options.moveToCenterWhenRefresh)
      if (this.options.useAnimationWhenRefresh) {
        const t = this.getNodesCenter();
        u("center:", t.x, t.y);
        const n = this.options.viewSize.width / 2 - t.x, i = this.options.viewSize.height / 2 - t.y;
        this.animateGoto(n, i, 500, () => {
          this.zoomToFitWhenRefresh(o);
        });
      } else {
        const t = this.getNodesCenter();
        this.setCanvasCenter(t.x, t.y), this.zoomToFitWhenRefresh(o);
      }
    else
      this.zoomToFitWhenRefresh(o);
    if (Number.isNaN(this.graphData.rootNode.x)) {
      u("rootNode.x is NaN, graph is currently hidden?");
      return;
    }
    this.options.placeSingleNode && this.options.layoutName !== "fixed" && this.placeSingleNode();
  }
  zoomToFitWhenRefresh(o) {
    this.options.zoomToFitWhenRefresh ? this.zoomToFit(o) : o && o();
  }
  findChilds(o, t) {
    t.push(o), o.targetNodes.forEach((n) => {
      t.includes(n) || this.findChilds(n, t);
    });
  }
  placeSingleNode() {
    const o = [];
    this.findChilds(this.graphData.rootNode, o);
    const t = [];
    if (this.graphData.nodes.forEach((n) => {
      o.includes(n) || n.targetNodes && n.targetNodes.length === 0 && n.fixed !== !0 && (n.x = Math.floor(Math.random() * 200) - 100, n.y = Math.floor(Math.random() * 200) - 100, n.lot || (n.lot = { childs: [] }), n.lot.placed = !0, t.push(n));
    }), t.length > 0) {
      u("sigle nodes:", t.length);
      const n = new ee({}, {});
      n.__origin_nodes = this.graphData.nodes, n.justLayoutSingleNode = !0, n.maxLayoutTimes = 100, n.byLine = !1, n.autoLayout();
    }
  }
  zoomToFit(o) {
    const t = this.getStuffSize(), n = this.options.viewSize.width / t.width, i = this.options.viewSize.height / t.height, s = Math.min(n, i, 1);
    u("animateToZoom:", { stuffSize: t, zoomPercent: s, zoomPercentX: n, zoomPercentY: i, viewSize: this.options.viewSize }), this.options.useAnimationWhenRefresh ? this.animateToZoom(s * 100, 300, o) : (this.setZoom(s * 100, 300), o && o());
  }
  animateGoto(o, t, n, i) {
    u("animateGoto:", o, t);
    const s = o - this.options.canvasOffset.x, a = t - this.options.canvasOffset.y, l = n, r = 5, c = Math.round(s / r), d = Math.round(a / r), f = l / r;
    this.animateStepAction(0, f, r, () => {
      this.options.canvasOffset.x += c, this.options.canvasOffset.y += d;
    }, () => {
      i && i();
    });
  }
  animateToZoom(o, t, n) {
    const i = o - this.options.canvasZoom, s = t, a = 5, l = Math.round(i / a), r = s / a;
    u("animateToZoom:", i, l), this.animateStepAction(0, r, a, () => {
      this.zoom(l);
    }, () => {
      this.setZoom(o), n && n();
    });
  }
  animateStepAction(o, t, n, i, s) {
    o < n ? (i(o, n), setTimeout(() => {
      this.animateStepAction(o + 1, t, n, i, s);
    }, t)) : s();
  }
  startAutoLayout() {
    this.options.autoLayouting = !this.options.autoLayouting, this.options.autoLayouting ? this.options.layouter.autoLayout ? this.options.layouter.autoLayout(!0) : console.log("\u5F53\u524D\u5E03\u5C40\u4E0D\u652F\u6301\u81EA\u52A8\u5E03\u5C40\uFF01") : this.options.layouter.stop ? this.options.layouter.stop() : console.log("\u5F53\u524D\u5E03\u5C40\u4E0D\u652F\u6301\u81EA\u52A8\u5E03\u5C40stop\uFF01");
  }
  stopAutoLayout() {
    this.options.autoLayouting = !1, this.options.layouter.stop ? this.options.layouter.stop() : console.log("\u5F53\u524D\u5E03\u5C40\u4E0D\u652F\u6301\u81EA\u52A8\u5E03\u5C40stop\uFF01");
  }
}
class Qe extends Ke {
  constructor(o, t) {
    super(o, t);
  }
  setDefaultLineShape(o) {
    this.options.defaultLineShape = o;
  }
  setDefaultJunctionPoint(o) {
    this.options.defaultJunctionPoint = o;
  }
  setCheckedNode(o) {
    this.options.checkedNodeId = o;
  }
  setCheckedLine(o) {
    this.options.checkedLineId = o;
  }
  selectNode(o, t) {
    o.selected = t;
  }
  updateNodeOffsetSize(o, t, n) {
    o.el.offsetWidth = t, o.el.offsetHeight = n;
  }
  onNodeClick(o, t) {
    u("onNodeClick:", o), this.options.disableNodeClickEffect !== !0 && o.disableDefaultClickEffect !== !0 && this.setCheckedNode(o.id), this.listeners.onNodeClick && this.listeners.onNodeClick(o, t);
  }
  onLineClick(o, t, n) {
    u("onLineClick:", "line:", o, "link:", t), this.options.disableLineClickEffect !== !0 && o.disableDefaultClickEffect !== !0 && (this.setCheckedLine(t.seeks_id), this.selectNode(t.fromNode, !0), this.selectNode(t.toNode, !0), setTimeout(() => {
      this.selectNode(t.fromNode, !1), this.selectNode(t.toNode, !1);
    }, 2e3)), this.listeners.onLineClick && this.listeners.onLineClick(o, t, n);
  }
  expandOrCollapseNode(o, t) {
    o.expanded === !1 ? this.expandNode(o, t) : this.collapseNode(o, t);
  }
  expandNode(o, t) {
    u("onNodeExpand:", o), o.expanded = !0, o.lot.childs.forEach((n) => {
      n.isShow = !0;
    }), this.listeners.onNodeExpand && this.listeners.onNodeExpand(o, t);
  }
  collapseNode(o, t) {
    u("onNodeCollapse:", o), o.expanded = !1, o.lot.childs.forEach((n) => {
      n.isShow = !1;
    }), this.listeners.onNodeCollapse && this.listeners.onNodeCollapse(o, t);
  }
}
class et extends Qe {
  constructor(o, t) {
    super(o, t);
  }
  dataURLToBlob(o) {
    const t = o.split(","), n = t[0].match(/:(.*?);/)[1], i = atob(t[1]);
    let s = i.length;
    const a = new Uint8Array(s);
    for (; s--; )
      a[s] = i.charCodeAt(s);
    return new Blob([a], { type: n });
  }
  downloadAsImage(o, t) {
    if (this.listeners.onImageDownload && this.listeners.onImageDownload(this.$canvasDom) === !1)
      return;
    if (this.graphData.nodes.length === 0)
      throw new Error("\u6CA1\u6709\u8282\u70B9\uFF0C\u6CA1\u6709\u5185\u5BB9\u9700\u8981\u5BFC\u51FA\uFF01");
    o || (o = "png"), t || (t = this.options.downloadImageFileName), t || (t = `SeeksRelationGraph-${(Math.random() * 1e5).toFixed(0)}`), this.options.checkedNodeId = "";
    const n = this.options.canvasZoom;
    this.options.canvasZoom = 100;
    const i = this.$canvasDom, s = i.clientWidth, a = i.clientHeight;
    let l = 999999, r = 999999, c = 0, d = 0;
    const f = 100;
    this.graphData.nodes.forEach((m) => {
      m.x < l && (l = m.x), m.x > c && (c = m.x + m.el.offsetWidth), m.y < r && (r = m.y), m.y > d && (d = m.y + m.el.offsetHeight);
    });
    const h = l - f, g = r - f;
    this.graphData.nodes.forEach((m) => {
      m.x = m.x - h, m.y = m.y - g;
    });
    const _ = this.options.canvasOffset.x, w = this.options.canvasOffset.y;
    this.options.canvasOffset.x = f * -1, this.options.canvasOffset.y = f * -1, u("offset:", { _origin_offset_x: _, _origin_offset_y: w, _min_x: l, _min_y: r, _max_x: c, _max_y: d });
    const C = c - l + 200 + f * 2, G = d - r + 100 + f * 2, N = window.devicePixelRatio;
    this.options.canvasSize.width = C * N, this.options.canvasSize.height = G * N;
    const M = {
      left: this.$dom.offsetLeft - i.getBoundingClientRect().left,
      top: this.$dom.offsetTop - i.getBoundingClientRect().top,
      canvas_offsetLeft: i.offsetLeft,
      canvas_offsetTop: i.offsetTop,
      canvas_left: i.getBoundingClientRect().left,
      canvas_top: i.getBoundingClientRect().top
    };
    window.scrollTo(0, 0), u("export image:", { relationGraphPosition: M, orign_width: s, orign_height: a, _image_width: C, _image_height: G, _min_x: l, _min_y: r, _max_x: c, _max_y: d, devicePixelRatio: window.devicePixelRatio });
    const y = document.createElement("canvas");
    y.width = C * N, y.height = G * N, y.style.backgroundColor = getComputedStyle(i.parentElement, null).backgroundColor, u("canvas.style.backgroundColor:", y.style.backgroundColor), y.style.width = `${C * N}px`, y.style.height = `${G * N}px`, y.getContext("2d").scale(1, 1);
    const L = {
      backgroundColor: y.style.backgroundColor,
      scale: N,
      canvas: y,
      logging: !0,
      width: C,
      height: G,
      useCORS: !0
    };
    setTimeout(() => {
      this.createImage(i, L, o, t, (m) => {
        u("downloadImageAsFile:", L, o, t), this.listeners.onImageSaveAsFile ? this.listeners.onImageSaveAsFile(
          m,
          o,
          t
        ) : this.downloadImageAsFile(m, o, t), this.options.canvasSize.width = s, this.options.canvasSize.height = a, this.options.canvasOffset.x = _, this.options.canvasOffset.y = w, this.options.canvasZoom = n, this.graphData.nodes.forEach((k) => {
          k.x = k.x + h, k.y = k.y + g;
        });
      });
    }, 1e3);
  }
  createImage(o, t, n, i, s) {
    u("createImage:", t), me(o, t).then((a) => {
      s && s(a);
    });
  }
  downloadImageAsFile(o, t, n) {
    const i = document.body.appendChild(o);
    i.style.display = "none";
    const s = this.dataURLToBlob(i.toDataURL(`image/${t}`));
    document.body.removeChild(i);
    const a = document.createElement("a");
    a.style.display = "none";
    try {
      window.navigator.msSaveOrOpenBlob ? window.navigator.msSaveOrOpenBlob(s, `${n}.${t}`) : (a.setAttribute("href", URL.createObjectURL(s)), a.setAttribute("download", `${n}.${t}`), document.body.appendChild(a), a.click(), u("click ok!"), URL.revokeObjectURL(s), u("revokeObjectURL ok!"), document.body.removeChild(a), u("removeChild ok!"));
    } catch (l) {
      u("[SEEKS Graph]Create and download image error:", l);
    }
  }
}
class tt extends et {
  constructor(o, t) {
    super(o, t);
  }
  createReturnValue(o, t) {
    return { path: o, textPosition: t };
  }
  createLinePath(o, t, n) {
    const i = o.fromNode, s = o.toNode;
    n || (n = 0);
    const a = t.lineShape || this.options.defaultLineShape || 1, l = t.lineDirection || this.options.layoutDirection || "h";
    let r = i.x, c = i.y, d = s.x, f = s.y;
    const h = { x: 0, y: 0, rotate: 0 };
    if (Number.isNaN(r) || Number.isNaN(c))
      return u("error start node:", i), h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    if (Number.isNaN(d) || Number.isNaN(f))
      return u("error start point:", i), h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    let g = i.el.offsetWidth || i.width || 60, _ = i.el.offsetHeight || i.height || 60;
    if (Number.isNaN(g) || Number.isNaN(_))
      return h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    let w = s.el.offsetWidth || s.width || 60, C = s.el.offsetHeight || s.height || 60;
    if (Number.isNaN(w) || Number.isNaN(C))
      return h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    t.isReverse && ([r, c, d, f, g, _, w, C] = [
      d,
      f,
      r,
      c,
      w,
      C,
      g,
      _
    ]);
    const G = [
      r,
      c,
      d,
      f,
      g,
      _,
      w,
      C,
      this.options.defaultNodeShape,
      t.isReverse,
      o.relations.length,
      n
    ], N = [
      d,
      f,
      r,
      c,
      w,
      C,
      g,
      _,
      this.options.defaultNodeShape,
      !t.isReverse,
      o.relations.length,
      n
    ];
    let M, y, L = this.options.defaultJunctionPoint;
    if (L || (L = F.border), L === F.border ? (M = x.getBorderPoint4MultiLine(...G), y = x.getBorderPoint4MultiLine(...N)) : L === F.ltrb ? (M = x.getRectJoinPoint(...G), y = x.getRectJoinPoint(...N)) : L === F.tb ? (M = x.getRectVJoinPoint(...G), y = x.getRectVJoinPoint(...N)) : L === F.lr && (M = x.getRectHJoinPoint(...G), y = x.getRectHJoinPoint(...N)), !M || !y)
      return this.createReturnValue(
        "Can not create start and end!",
        h
      );
    const m = M.x, k = M.y, W = y.x, T = y.y;
    if (Number.isNaN(m) || Number.isNaN(k))
      return console.error("error start point:", i), h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    if (Number.isNaN(W) || Number.isNaN(T))
      return console.error("error end point:", s), h.x = 50, h.y = 50, h.rotate = 0, this.createReturnValue("M 0 0 L 100 100", h);
    let b = y.x - M.x, v = y.y - M.y, S = y.x > M.x ? 1 : -1;
    l === "v" && (S = y.y > M.y ? 1 : -1);
    let z = "";
    if (a === 4) {
      const P = 60 / (o.relations.length + 1) * (n + 1) - 30;
      l === "v" ? (v = v - (S * 33 + P), h.x = m + b + 5, h.y = k + S * 40 + P, h.rotate = 90, z = `M ${m} ${k} v${S * 33 + P} h${b + P} v${v}`) : t.reverseText === !0 ? (h.x = m + S * 10 - (S < 0 ? 30 : 0), h.y = k - 5, b = b - S * 120, z = `M ${m} ${k} h${S * 120} v${v} h${b}`) : (h.x = m + S * 50 - (S < 0 ? 30 : 0), h.y = k + v - 5 + P, b = b - (S * 33 + P), v = v + S * P, z = `M ${m} ${k} h${S * 33 + P} v${v} h${b}`);
    } else if (a === 2) {
      const P = y.y > M.y ? 1 : -1, A = Math.abs(b) + Math.abs(v);
      h.x = Math.round(y.x - b / A * 60 - 20), h.y = Math.round(
        y.y - v / A * 60 - 20 * P
      );
      const V = 1 / (o.relations.length + 1) * (n + 1) - 0.5 + 0.5;
      l === "v" ? z = `M${m},${k} c${0},${S * 30} ${b * V},${S * -10} ${b},${v}` : z = `M${m},${k} c${S * 30},${0} ${S * -10},${v * V} ${b},${v}`;
    } else if (a === 6) {
      const P = y.y > M.y ? 1 : -1, A = Math.abs(b) + Math.abs(v);
      h.x = Math.round(y.x - b / A * 60 - 20), h.y = Math.round(
        y.y - v / A * 60 - 20 * P
      ), l === "v" ? z = `M${m},${k} c${0},${v / 2} ${b},${v / 2} ${b},${v}` : z = `M${m},${k} c${b / 2},${0} ${b / 2},${v} ${b},${v}`;
    } else if (a === 3) {
      h.x = y.x - S * 63, h.y = y.y + 3;
      const P = 1 / (o.relations.length + 1) * (n + 1) - 0.5 + 0.5;
      l === "v" ? z = `M${m},${k} c${0},${v * P} ${0},${0} ${b},${v}` : z = `M${m},${k} c${S * 30},${0} ${S * -10},${v * P} ${b},${v}`;
    } else if (a === 5) {
      h.x = y.x - S * 63, h.y = y.y + 3;
      const P = 1 / (o.relations.length + 1) * (n + 1) - 0.5 + 0.5;
      l === "v" ? z = `M${m},${k} c${0},${0} ${0},${v * P} ${b},${v}` : z = `M${m},${k} c${0},${0} ${b * P},${0} ${b},${v}`;
    } else {
      const P = x.getAngleType(b, v);
      h.rotate = x.getTextAngle(m, k, W, T);
      const A = P === 2 || P === 4 ? -1 : 1, V = (v === 0 ? -50 : Math.sin(Math.atan(b / v)) * 10 / Math.sin(90)) * A, Se = b === 0 ? -50 : Math.sin(Math.atan(v / b)) * 10 / Math.sin(90);
      h.x = Math.round(M.x + b / 2 - V), h.y = Math.round(M.y + v / 2 - Se), Number.isNaN(h.rotate) && (h.rotate = 0), z = `M ${m} ${k} L ${W} ${T}`;
    }
    return this.createReturnValue(z, h);
  }
  getTextTransform(o, t, n, i) {
    if (Number.isNaN(t) || Number.isNaN(n))
      return "translate(0,0)";
    const s = o.lineShape === void 0 ? this.options.defaultLineShape : o.lineShape;
    return s === 1 || s === 4 ? `translate(${t},${n})rotate(${i || 0})` : `translate(${t},${n})`;
  }
  getArrow(o, t, n) {
    const i = t.seeks_id === this.options.checkedLineId;
    return o.isHideArrow ? "none" : `url('#${this.getLineArrow(
      o.color,
      n,
      i
    )}')`;
  }
}
class Ge extends tt {
  constructor(o, t) {
    super(o, t);
  }
}
var ot = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isAllowShowNode(e.nodeProps), expression: "isAllowShowNode(nodeProps)" }], ref: "seeksRGNode", staticClass: "rel-node-peel", style: { left: e.nodeProps.x + "px", top: e.nodeProps.y + "px", opacity: e.nodeProps.opacity > 1 ? e.nodeProps.opacity / 100 : e.nodeProps.opacity } }, [e.nodeProps.expandHolderPosition && e.nodeProps.expandHolderPosition !== "hide" || e.relationGraph.options.defaultExpandHolderPosition && e.relationGraph.options.defaultExpandHolderPosition !== "hide" && e.nodeProps.lot.childs && e.nodeProps.lot.childs.length > 0 ? t("div", { staticClass: "c-btn-open-close", class: ["c-expand-positon-" + (e.nodeProps.expandHolderPosition || e.relationGraph.options.defaultExpandHolderPosition)] }, [t("span", { class: e.expandButtonClass, style: { "background-color": e.nodeProps.color || e.relationGraph.options.defaultNodeColor }, on: { click: function(n) {
    return n.stopPropagation(), e.expandOrCollapseNode.apply(null, arguments);
  } } })]) : e._e(), e.nodeProps.html ? t("div", { domProps: { innerHTML: e._s(e.nodeProps.html) }, on: { click: function(n) {
    return n.stopPropagation(), e.onclick(n);
  }, mousedown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "left", 37, n.key, ["Left", "ArrowLeft"]) || "button" in n && n.button !== 0 ? null : (n.stopPropagation(), e.onDragStart(n));
  }, touchstart: function(n) {
    return n.stopPropagation(), e.onDragStart(n);
  }, mouseover: function(n) {
    return n.stopPropagation(), e.onMouseHover(n);
  }, mouseout: function(n) {
    return n.stopPropagation(), e.onMouseOut(n);
  } } }) : t("div", { staticClass: "rel-node", class: ["rel-node-shape-" + (e.nodeProps.nodeShape === void 0 ? e.relationGraph.options.defaultNodeShape : e.nodeProps.nodeShape), "rel-node-type-" + e.nodeProps.type, e.nodeProps.id === e.relationGraph.options.checkedNodeId ? "rel-node-checked" : "", e.nodeProps.selected ? "rel-node-selected" : "", e.nodeProps.styleClass, e.hovering ? "rel-node-hover" : "", e.nodeProps.innerHTML ? "rel-diy-node" : ""], style: { "background-color": e.nodeProps.color === void 0 ? e.relationGraph.options.defaultNodeColor : e.nodeProps.color, color: e.nodeProps.fontColor === void 0 ? e.relationGraph.options.defaultNodeFontColor : e.nodeProps.fontColor, border: (e.nodeProps.borderColor || e.relationGraph.options.defaultNodeBorderColor) + " solid " + (e.nodeProps.borderWidth || e.relationGraph.options.defaultNodeBorderWidth) + "px", width: (e.nodeProps.width || e.relationGraph.options.defaultNodeWidth) + "px", height: (e.nodeProps.height || e.relationGraph.options.defaultNodeHeight) + "px" }, on: { click: function(n) {
    return n.stopPropagation(), e.onclick(n);
  }, mousedown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "left", 37, n.key, ["Left", "ArrowLeft"]) || "button" in n && n.button !== 0 ? null : (n.stopPropagation(), e.onDragStart(n));
  }, touchstart: function(n) {
    return n.stopPropagation(), e.onDragStart(n);
  }, mouseover: function(n) {
    return n.stopPropagation(), e.onMouseHover(n);
  }, mouseout: function(n) {
    return n.stopPropagation(), e.onMouseOut(n);
  } } }, [e.relationGraph.options.hideNodeContentByZoom === !0 && e.relationGraph.options.canvasZoom < 40 ? e._e() : [e._t("node", function() {
    return [e.nodeProps.innerHTML ? t("div", { domProps: { innerHTML: e._s(e.nodeProps.innerHTML) } }) : t("div", { staticClass: "c-node-text", style: { color: e.nodeProps.fontColor || e.relationGraph.options.defaultNodeFontColor } }, [t("span", { domProps: { innerHTML: e._s(e.nodeProps.text) } })])];
  }, { node: e.nodeProps })]], 2)]);
}, nt = [];
function E(e, o, t, n, i, s, a, l) {
  var r = typeof e == "function" ? e.options : e;
  o && (r.render = o, r.staticRenderFns = t, r._compiled = !0), n && (r.functional = !0), s && (r._scopeId = "data-v-" + s);
  var c;
  if (a ? (c = function(h) {
    h = h || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !h && typeof __VUE_SSR_CONTEXT__ != "undefined" && (h = __VUE_SSR_CONTEXT__), i && i.call(this, h), h && h._registeredComponents && h._registeredComponents.add(a);
  }, r._ssrRegister = c) : i && (c = l ? function() {
    i.call(
      this,
      (r.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), c)
    if (r.functional) {
      r._injectStyles = c;
      var d = r.render;
      r.render = function(g, _) {
        return c.call(_), d(g, _);
      };
    } else {
      var f = r.beforeCreate;
      r.beforeCreate = f ? [].concat(f, c) : [c];
    }
  return {
    exports: e,
    options: r
  };
}
const it = {
  name: "SeeksRGNode",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    nodeProps: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      hovering: !1,
      borderColor: "",
      dragging: !1
    };
  },
  computed: {
    expandButtonClass() {
      return this.nodeProps.expanded === !1 ? "c-expanded" : "c-collapsed";
    }
  },
  created() {
  },
  mounted() {
    this.refreshNodeProperties();
  },
  updated() {
    this.refreshNodeProperties();
  },
  beforeDestroy() {
    this.$refs.seeksRGNode.remove();
  },
  methods: {
    refreshNodeProperties() {
      (this.nodeProps.el.offsetWidth !== this.$refs.seeksRGNode.offsetWidth || this.nodeProps.el.offsetHeight !== this.$refs.seeksRGNode.offsetHeight) && this.relationGraph.updateNodeOffsetSize(this.nodeProps, this.$refs.seeksRGNode.offsetWidth, this.$refs.seeksRGNode.offsetHeight);
    },
    expandOrCollapseNode(e) {
      this.relationGraph.expandOrCollapseNode(this.nodeProps, e);
    },
    onDragStart(e) {
      this.relationGraph.options.disableDragNode || this.nodeProps.disableDrag || (this.dragging = !0, this.hovering = !1, $.startDrag(e, this.nodeProps, this.onNodeDraged, (o, t, n) => {
        const i = o / (this.relationGraph.options.canvasZoom / 100) + n.x, s = t / (this.relationGraph.options.canvasZoom / 100) + n.y;
        this.relationGraph.setNodePosition(this.nodeProps, i, s);
      }));
    },
    onNodeDraged(e, o, t) {
      if (e === 0 && o === 0) {
        this.relationGraph.onNodeClick(this.nodeProps, t);
        return;
      }
      this.relationGraph.options.isMoveByParentNode && this.nodeProps.lot.childs.forEach((n) => {
        n.x += e, n.y += o;
      }), Math.abs(e) + Math.abs(o) > 6 ? setTimeout(() => {
        u("delay end dragging", this.dragging), this.dragging = !1;
      }, 100) : this.dragging = !1;
    },
    onMouseHover() {
      this.dragging || this.relationGraph.options.disableNodeClickEffect !== !0 && this.nodeProps.disableDefaultClickEffect !== !0 && (this.hovering = !0);
    },
    onMouseOut() {
      this.relationGraph.options.disableNodeClickEffect !== !0 && this.nodeProps.disableDefaultClickEffect !== !0 && (this.hovering = !1);
    },
    onclick(e) {
      this.dragging || this.relationGraph.onNodeClick(this.nodeProps, e);
    },
    isAllowShowNode(e) {
      return e.isShow !== !1 && e.isHide !== !0 && (!e.lot.parent || this.isAllowShowNode(e.lot.parent) === !0);
    }
  }
}, ae = {};
var st = /* @__PURE__ */ E(
  it,
  ot,
  nt,
  !1,
  at,
  null,
  null,
  null
);
function at(e) {
  for (let o in ae)
    this[o] = ae[o];
}
const rt = /* @__PURE__ */ function() {
  return st.exports;
}();
var lt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("g", [t("path", { class: ["c-rg-line", e.relation.styleClass, e.checked ? "c-rg-line-checked" : ""], style: {
    opacity: e.relation.opacity,
    "stroke-width": (e.relation.lineWidth ? e.relation.lineWidth : e.relationGraph.options.defaultLineWidth) + "px"
  }, attrs: { d: e.pathData, stroke: e.checked ? e.relationGraph.options.checkedLineColor : e.relation.color ? e.relation.color : e.relationGraph.options.defaultLineColor, "marker-start": e.relation.showStartArrow && e.relationGraph.getArrow(e.relation, e.link, !0), "marker-end": e.relation.showEndArrow && e.relationGraph.getArrow(e.relation, e.link, !1), fill: "none" }, on: { click: function(n) {
    return e.onClick(e.relation, n);
  } } }), e.relationGraph.options.defaultShowLineLabel && e.relationGraph.options.canvasZoom > 40 ? t("g", { attrs: { transform: e.textTransform } }, [t("text", { key: "t-" + e.relation.seeks_id, staticClass: "c-rg-line-text", style: {
    opacity: e.relation.opacity,
    fill: e.checked ? e.relationGraph.options.checkedLineColor : e.relation.fontColor ? e.relation.fontColor : e.relation.color ? e.relation.color : void 0
  }, attrs: { x: 0, y: 0 }, on: { click: function(n) {
    return e.onClick(e.relation, n);
  } } }, [e._v(" " + e._s(e.relation.text) + " ")])]) : e._e()]);
}, ct = [];
const ht = {
  name: "SeeksRGLine",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    link: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relation: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relationIndex: {
      mustUseProp: !0,
      default: () => 0,
      type: Number
    }
  },
  data() {
    return {
      is_flashing: !1
    };
  },
  computed: {
    checked() {
      return this.link.seeks_id === this.relationGraph.options.checkedLineId;
    },
    pathData() {
      const { path: e, textPosition: o } = this.relationGraph.createLinePath(
        this.link,
        this.relation,
        this.relationIndex
      );
      return e;
    },
    textTransform() {
      const { path: e, textPosition: o } = this.relationGraph.createLinePath(
        this.link,
        this.relation,
        this.relationIndex
      );
      return this.relationGraph.getTextTransform(
        this.relation,
        o.x,
        o.y,
        o.rotate
      );
    }
  },
  show() {
    this.isShow = !0;
  },
  watch: {},
  methods: {
    onClick(e, o) {
      this.relationGraph.onLineClick(e, this.link, o);
    },
    isAllowShowNode(e) {
      return e.isShow !== !1 && e.isHide !== !0 && (!e.lot.parent || this.isAllowShowNode(e.lot.parent, !1) === !0);
    }
  }
}, re = {};
var dt = /* @__PURE__ */ E(
  ht,
  lt,
  ct,
  !1,
  ft,
  "502a344c",
  null,
  null
);
function ft(e) {
  for (let o in re)
    this[o] = re[o];
}
const ut = /* @__PURE__ */ function() {
  return dt.exports;
}();
var pt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("g", [t("use", { class: ["c-rg-line", e.checked ? "c-rg-line-checked" : ""], attrs: { "xlink:href": "#" + e.relationGraph.options.instanceId + "-" + e.link.seeks_id + "-" + e.relationIndex }, on: { click: function(n) {
    return e.onClick(e.relation, n);
  } } }), t("text", { staticClass: "c-rg-line-text", style: {
    opacity: e.relation.opacity,
    fill: e.checked ? e.relationGraph.options.checkedLineColor : e.relation.fontColor ? e.relation.fontColor : e.relation.color ? e.relation.color : void 0
  }, attrs: { x: e.textOffset, y: "0" }, on: { click: function(n) {
    return e.onClick(e.relation, n);
  } } }, [t("textPath", { attrs: { "xlink:href": "#" + e.relationGraph.options.instanceId + "-" + e.link.seeks_id + "-" + e.relationIndex, startOffset: "0", "text-anchor": "start", method: "align", spacing: "auto" } }, [e._v(" " + e._s(e.relation.text) + " ")])])]);
}, _t = [];
const mt = {
  name: "SeeksRGLine",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    link: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relation: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relationIndex: {
      mustUseProp: !0,
      default: () => 0,
      type: Number
    }
  },
  computed: {
    checked() {
      return this.link.seeks_id === this.relationGraph.options.checkedLineId;
    },
    textOffset() {
      const e = Ie(this.relation.text) * 10;
      return (Be(this.link.fromNode.x, this.link.fromNode.y, this.link.toNode.x, this.link.toNode.y) - e) / 2;
    }
  },
  data() {
    return {
      is_flashing: !1
    };
  },
  show() {
    this.isShow = !0;
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClick(e, o) {
      this.relationGraph.onLineClick(e, this.link, o);
    },
    isAllowShowNode(e) {
      return e.isShow !== !1 && e.isHide !== !0 && (!e.lot.parent || this.isAllowShowNode(e.lot.parent, !1) === !0);
    },
    flash() {
    }
  }
}, le = {};
var gt = /* @__PURE__ */ E(
  mt,
  pt,
  _t,
  !1,
  yt,
  "5924ca84",
  null,
  null
);
function yt(e) {
  for (let o in le)
    this[o] = le[o];
}
const xt = /* @__PURE__ */ function() {
  return gt.exports;
}();
var vt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return e.linkProps.isHide !== !0 && e.isAllowShowNode(e.linkProps.fromNode) && e.isAllowShowNode(e.linkProps.toNode) ? t("g", { ref: "seeksRGLink", class: [e.relationGraph.options.checkedLineId == e.linkProps.seeks_id ? "c-rg-link-checked" : ""], attrs: { transform: "translate(0,0)" } }, [e._l(e.linkProps.relations, function(n, i) {
    return [e._t("line", function() {
      return [(e.relationGraph.options.lineUseTextPath || n.useTextPath) && n.isHide === !1 ? t("RGLineTextByPath", { key: "l-" + n.id, attrs: { "relation-graph": e.relationGraph, link: e.linkProps, relation: n, "relation-index": i } }) : n.isHide === !1 ? t("RGLineSmart", { key: "l-" + n.id, attrs: { "relation-graph": e.relationGraph, link: e.linkProps, relation: n, "relation-index": i } }) : e._e()];
    }, { line: n, relationIndex: i })];
  })], 2) : e._e();
}, wt = [];
const bt = {
  name: "SeeksRGLink",
  components: { RGLineSmart: ut, RGLineTextByPath: xt },
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    linkProps: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      is_flashing: !1
    };
  },
  show() {
    this.isShow = !0;
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClick(e, o) {
      this.relationGraph.onLineClick(e, this.linkProps, o);
    },
    isAllowShowNode(e) {
      return e.isShow !== !1 && e.isHide !== !0 && (!e.lot.parent || this.isAllowShowNode(e.lot.parent) === !0);
    },
    flash() {
    }
  }
}, ce = {};
var Ct = /* @__PURE__ */ E(
  bt,
  vt,
  wt,
  !1,
  kt,
  "420b4e08",
  null,
  null
);
function kt(e) {
  for (let o in ce)
    this[o] = ce[o];
}
const Gt = /* @__PURE__ */ function() {
  return Ct.exports;
}();
var Mt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("path", { class: [e.relation.styleClass, e.checked ? "c-rg-line-checked" : ""], style: { opacity: e.relation.opacity, "stroke-width": (e.relation.lineWidth ? e.relation.lineWidth : e.relationGraph.options.defaultLineWidth) + "px" }, attrs: { id: e.relationGraph.options.instanceId + "-" + e.link.seeks_id + "-" + e.relationIndex, d: e.pathData, stroke: e.checked ? e.relationGraph.options.checkedLineColor : e.relation.color ? e.relation.color : e.relationGraph.options.defaultLineColor, "marker-start": e.relation.showStartArrow && e.relationGraph.getArrow(e.relation, e.link, !0), "marker-end": e.relation.showEndArrow && e.relationGraph.getArrow(e.relation, e.link, !1), fill: "none" } });
}, St = [];
const Pt = {
  name: "SeeksRGLink",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    link: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relation: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    },
    relationIndex: {
      mustUseProp: !0,
      default: () => 0,
      type: Number
    }
  },
  computed: {
    checked() {
      return this.link.seeks_id === this.relationGraph.options.checkedLineId;
    },
    pathData() {
      const { path: e, textPosition: o } = this.relationGraph.createLinePath(
        this.link,
        this.relation,
        this.relationIndex
      );
      return e;
    }
  },
  data() {
    return {
      is_flashing: !1
    };
  },
  show() {
    this.isShow = !0;
  },
  methods: {}
}, he = {};
var Nt = /* @__PURE__ */ E(
  Pt,
  Mt,
  St,
  !1,
  Lt,
  null,
  null,
  null
);
function Lt(e) {
  for (let o in he)
    this[o] = he[o];
}
const zt = /* @__PURE__ */ function() {
  return Nt.exports;
}();
var $t = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", { staticClass: "rel-map", class: [e.relationGraph.options.layoutClassName, e.relationGraph.options.backgrounImageNoRepeat ? "rel-map-background-norepeat" : ""], style: { width: "100%", height: "100%", "background-image": "url(" + e.relationGraph.options.backgrounImage + ")" }, on: { mousedown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "left", 37, n.key, ["Left", "ArrowLeft"]) || "button" in n && n.button !== 0 ? null : (n.stopPropagation(), e.onDragStart(n));
  }, touchstart: function(n) {
    return n.stopPropagation(), e.onDragStart(n);
  }, wheel: e.mouseListener } }, [t("div", { ref: "seeksRGCanvas", staticClass: "rel-map-canvas", style: e.canvasSizeAndPosition }, [e._t("canvas-plug"), t("div", { ref: "rgCanvas", staticClass: "rel-linediv", staticStyle: { overflow: "visible" } }, [t("svg", { staticStyle: { overflow: "visible" }, style: { width: e.relationGraph.options.canvasSize.width + "px", height: e.relationGraph.options.canvasSize.height + "px" }, attrs: { xmlns: "http://www.w3.org/2000/svg", version: "2.0" } }, [t("defs", [t("linearGradient", { attrs: { id: e.relationGraph.options.instanceId + "-lineStyle", x1: "1", y1: "0", x2: "0", y2: "0" } }, [t("stop", { attrs: { offset: "0%", "stop-color": "#e52c5c" } }), t("stop", { attrs: { offset: "100%", "stop-color": "#FD8B37" } })], 1), t("marker", { attrs: { id: e.relationGraph.options.instanceId + "-arrow-default", markerWidth: e.relationGraph.options.defaultLineMarker.markerWidth, markerHeight: e.relationGraph.options.defaultLineMarker.markerHeight, refX: e.relationGraph.options.defaultLineMarker.refX, refY: e.relationGraph.options.defaultLineMarker.refY, "marker-units": "strokeWidth", orient: "auto", viewBox: "0 0 12 12" } }, [t("path", { style: { fill: e.relationGraph.options.defaultLineColor }, attrs: { d: e.relationGraph.options.defaultLineMarker.data } })]), t("marker", { attrs: { id: e.relationGraph.options.instanceId + "-start-arrow-default", markerWidth: e.relationGraph.options.defaultLineMarker.markerWidth, markerHeight: e.relationGraph.options.defaultLineMarker.markerHeight, refX: e.relationGraph.options.defaultLineMarker.refX, refY: e.relationGraph.options.defaultLineMarker.refY, "marker-units": "strokeWidth", orient: "auto", viewBox: "0 0 12 12" } }, [t("path", { style: { fill: e.relationGraph.options.defaultLineColor }, attrs: { d: e.relationGraph.options.defaultLineMarker.data, transform: "translate(12,12)rotate(180)" } })]), t("marker", { attrs: { id: e.relationGraph.options.instanceId + "-arrow-checked", markerUnits: "strokeWidth", markerWidth: "12", markerHeight: "12", viewBox: "0 0 12 12", refX: "6", refY: "6", orient: "auto" } }, [t("path", { style: { fill: e.relationGraph.options.checkedLineColor }, attrs: { d: "M2,2 L10,6 L2,10 L6,6 L2,2" } })]), t("marker", { attrs: { id: e.relationGraph.options.instanceId + "-start-arrow-checked", markerUnits: "strokeWidth", markerWidth: "12", markerHeight: "12", viewBox: "0 0 12 12", refX: "6", refY: "6", orient: "auto" } }, [t("path", { style: { fill: e.relationGraph.options.checkedLineColor }, attrs: { d: "M2,2 L10,6 L2,10 L6,6 L2,2", transform: "translate(12,12)rotate(180)" } })]), e._l(e.relationGraph.allLineColors, function(n) {
    return t("marker", { key: n.id, attrs: { id: e.relationGraph.options.instanceId + "-arrow-" + n.id, markerWidth: e.relationGraph.options.defaultLineMarker.markerWidth, markerHeight: e.relationGraph.options.defaultLineMarker.markerHeight, refX: e.relationGraph.options.defaultLineMarker.refX, refY: e.relationGraph.options.defaultLineMarker.refY, "marker-units": "strokeWidth", orient: "auto" } }, [t("path", { attrs: { fill: e.relationGraph.options.defaultLineMarker.color || n.color, d: e.relationGraph.options.defaultLineMarker.data } })]);
  }), e._l(e.relationGraph.allLineColors, function(n) {
    return t("marker", { key: "start-" + n.id, attrs: { id: e.relationGraph.options.instanceId + "-start-arrow-" + n.id, markerWidth: e.relationGraph.options.defaultLineMarker.markerWidth, markerHeight: e.relationGraph.options.defaultLineMarker.markerHeight, refX: e.relationGraph.options.defaultLineMarker.refX, refY: e.relationGraph.options.defaultLineMarker.refY, "marker-units": "strokeWidth", orient: "auto" } }, [t("path", { attrs: { fill: e.relationGraph.options.defaultLineMarker.color || n.color, d: e.relationGraph.options.defaultLineMarker.data, transform: "translate(12,12)rotate(180)" } })]);
  }), e._l(e.relationGraph.graphData.links, function(n) {
    return [e._l(n.relations, function(i, s) {
      return [e.relationGraph.options.lineUseTextPath || i.useTextPath ? t("SeeksRGLinePath", { key: i.id, attrs: { "relation-graph": e.relationGraph, link: n, relation: i, "relation-index": s } }) : e._e()];
    })];
  })], 2), e._l(e.relationGraph.graphData.links, function(n) {
    return t("SeeksRGLink", { key: n.seeks_id, attrs: { "link-props": n, "relation-graph": e.relationGraph }, scopedSlots: e._u([{ key: "line", fn: function(i) {
      var s = i.line;
      return [e._t("line", null, { line: s, link: n })];
    } }], null, !0) });
  })], 2)]), t("div", { staticClass: "rel-nodediv rel-nodediv-for-webkit" }, e._l(e.relationGraph.graphData.nodes, function(n) {
    return t("SeeksRGNode", { key: n.seeks_id, attrs: { "node-props": n, "relation-graph": e.relationGraph }, scopedSlots: e._u([{ key: "node", fn: function(i) {
      var s = i.node;
      return [e._t("node", null, { node: s })];
    } }], null, !0) });
  }), 1)], 2)]);
}, Et = [];
const At = {
  name: "RelationGraphCanvas",
  components: { SeeksRGNode: rt, SeeksRGLink: Gt, SeeksRGLinePath: zt },
  props: {
    relationGraph: {
      mustUseProp: !1,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    canvasSizeAndPosition() {
      return {
        width: `${this.relationGraph.options.canvasSize.width}px`,
        height: `${this.relationGraph.options.canvasSize.height}px`,
        "margin-left": `${this.relationGraph.options.canvasOffset.x}px`,
        "margin-top": `${this.relationGraph.options.canvasOffset.y}px`,
        "background-color": "transparent",
        transform: `scale(${this.relationGraph.options.canvasZoom / 100},${this.relationGraph.options.canvasZoom / 100})`
      };
    }
  },
  watch: {},
  created() {
    u("[RGCanvas created]");
  },
  mounted() {
    u("[RGCanvas mounted]"), this.init(), this.relationGraph.setCanvasDom(this.$refs.seeksRGCanvas);
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.$refs.rgCanvas.style.setProperty("--stroke", `url('#${this.relationGraph.options.instanceId}-lineStyle')`), this.$refs.rgCanvas.style.setProperty("--markerEnd", `url('#${this.relationGraph.options.instanceId}-start-arrow-default')`), this.$refs.rgCanvas.style.setProperty("--markerStart", `url('#${this.relationGraph.options.instanceId}-arrow-default')`), this.$refs.rgCanvas.style.setProperty("--markerEndChecked", `url('#${this.relationGraph.options.instanceId}-arrow-checked')`), this.$refs.rgCanvas.style.setProperty("--markerStartChecked", `url('#${this.relationGraph.options.instanceId}-start-arrow-checked')`);
    },
    mouseListener(e) {
      if (this.relationGraph.options.disableZoom)
        return e.cancelBubble = !1, !0;
      try {
        e.cancelBubble = !0, e.preventDefault(), e.stopPropagation();
      } catch (i) {
      }
      const o = {
        x: e.clientX,
        y: e.clientY
      };
      let t = e.deltaY;
      t === void 0 && (t = e.wheelDelta);
      const n = -1;
      t > 0 ? this.relationGraph.zoom(5 * n, o) : this.relationGraph.zoom(-5 * n, o);
    },
    onDragStart(e) {
      if (this.relationGraph.options.disableDragCanvas)
        return;
      let o;
      if (H) {
        let t = null, n = null;
        o = (i, s, a, l, r) => {
          const c = r.touches || r.targetTouches, d = c[0];
          if (c && c.length > 1) {
            r.preventDefault();
            const f = c[1];
            t || (t = { x: f.clientX, y: f.clientY }, n = this.relationGraph.options.canvasZoom);
            const h = { x: d.clientX, y: d.clientY }, g = { x: f.clientX, y: f.clientY }, _ = Math.hypot(t.x - l.x, t.y - l.y), C = Math.hypot(g.x - h.x, g.y - h.y) / _, G = n * C;
            this.relationGraph.setZoom(G);
          } else {
            const f = d.clientX, h = d.clientY, g = a.x + (f - l.x), _ = a.y + (h - l.y);
            this.relationGraph.setCanvasOffset(g, _);
          }
        };
      }
      $.startDrag(e, this.relationGraph.options.canvasOffset, this.onDragEnd, o);
    },
    onDragEnd() {
    }
  }
}, de = {};
var It = /* @__PURE__ */ E(
  At,
  $t,
  Et,
  !1,
  Rt,
  "6e119aea",
  null,
  null
);
function Rt(e) {
  for (let o in de)
    this[o] = de[o];
}
const Bt = /* @__PURE__ */ function() {
  return It.exports;
}();
var Ot = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", [t("div", { staticClass: "c-setting-panel-button", class: [], on: { click: e.toggleSettingPanel } }, [e._v(" Debug ")]), e.showSettingPanel ? t("div", { staticClass: "c-setting-panel", class: [] }, [t("div", { staticClass: "c-debug-tools-row" }, [t("button", { on: { click: e.printOptions } }, [e._v("print options in console")])]), t("div", { staticClass: "c-debug-tools-row" }, [t("button", { on: { click: e.printData } }, [e._v("print json data in console")])]), t("div", { staticClass: "c-debug-tools-row" }, [e._v("debug log status: " + e._s(e.relationGraph.options.debug)), t("button", { on: { click: e.enableDevlog } }, [e._v(e._s(e.relationGraph.options.debug ? "disable" : "enable") + " debug log")])])]) : e._e()]);
}, Ft = [];
const Ht = {
  name: "GraphSettingPanel",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      search_text: "",
      showSettingPanel: !1,
      currentLayoutName: ""
    };
  },
  methods: {
    toggleSettingPanel() {
      this.showSettingPanel = !this.showSettingPanel;
    },
    printOptions() {
      console.log("options:", this.relationGraph.getGraphJsonOptions());
    },
    printData() {
      console.log("data:", this.relationGraph.getGraphJsonData());
    },
    enableDevlog() {
      this.relationGraph.enableDebugLog(!this.relationGraph.options.debug), u("debugLog:", this.relationGraph.options.debug);
    }
  }
}, fe = {};
var Wt = /* @__PURE__ */ E(
  Ht,
  Ot,
  Ft,
  !1,
  Dt,
  "f2fe86d4",
  null,
  null
);
function Dt(e) {
  for (let o in fe)
    this[o] = fe[o];
}
const Vt = /* @__PURE__ */ function() {
  return Wt.exports;
}();
var Tt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", { ref: "miniView", staticClass: "c-mini-graph" }, [t("div", { staticClass: "c-mini-canvas", style: {
    width: e.viewWidth + "px",
    height: e.miniViewHeight() + "px"
  } }, [e._l(e.relationGraph.graphData.nodes, function(n) {
    return [e.isAllowShowNode(n) ? t("div", { key: n.id, staticClass: "c-mini-node", style: {
      left: (n.x - e.minX) * e.viewWidth / (e.maxX - e.minX) + "px",
      top: (n.y - e.minY) * e.viewHeight / (e.maxY - e.minY) + "px"
    } }) : e._e()];
  })], 2)]);
}, jt = [];
const Zt = {
  name: "GraphMiniView",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      viewWidth: 100,
      viewHeight: 0,
      minX: 0,
      maxX: 0,
      minY: 0,
      maxY: 0,
      zoom: 1
    };
  },
  mounted() {
  },
  methods: {
    miniViewHeight() {
      let e = 9999, o = -9999, t = 9999, n = -9999;
      for (let i = 0; i < this.relationGraph.graphData.nodes.length; i++) {
        const s = this.relationGraph.graphData.nodes[i];
        s.x < e && (e = s.x), s.x > o && (o = s.x), s.y < t && (t = s.y), s.y > n && (n = s.y);
      }
      return this.viewHeight = (n - t) * this.viewWidth / (o - e), this.minX = e, this.minY = t, this.maxX = o, this.maxY = n, this.viewHeight;
    },
    getPositionData() {
      const e = this.viewWidth / this.relationGraph.options.canvasNVInfo.width, o = this.relationGraph.options.viewNVInfo.width * e, t = this.relationGraph.options.viewNVInfo.height * e;
      let n = (this.relationGraph.options.viewNVInfo.x - this.relationGraph.options.canvasNVInfo.x) * e * (this.relationGraph.options.canvasZoom / 100), i = (this.relationGraph.options.viewNVInfo.y - this.relationGraph.options.canvasNVInfo.y) * e * (this.relationGraph.options.canvasZoom / 100);
      return n = n * 100 / o, i = i * 100 / o, {
        width: o + "px",
        height: t + "px",
        left: n + "px",
        top: i + "px"
      };
    },
    isAllowShowNode(e) {
      return x.isAllowShowNode(e);
    }
  }
}, ue = {};
var Jt = /* @__PURE__ */ E(
  Zt,
  Tt,
  jt,
  !1,
  Ut,
  "4c48557a",
  null,
  null
);
function Ut(e) {
  for (let o in ue)
    this[o] = ue[o];
}
const Yt = /* @__PURE__ */ function() {
  return Jt.exports;
}();
var Xt = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", { staticClass: "c-mini-toolbar", style: { "margin-left": e.relationGraph.options.viewELSize.width - 50 + "px", "margin-top": (e.relationGraph.options.viewELSize.height - 260) / 2 + "px" } }, [t("div", { staticClass: "c-mb-button", staticStyle: { "margin-top": "0px" }, on: { click: function(n) {
    return e.relationGraph.fullscreen();
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-resize-" } })]), t("span", { staticClass: "c-mb-text" }, [e._v(e._s(e.relationGraph.options.fullscreen ? "\u9000\u51FA" : "\u5168\u5C4F"))])]), e.relationGraph.options.allowShowZoomMenu ? t("div", { staticClass: "c-mb-button", on: { click: function(n) {
    return e.relationGraph.zoom(20);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-fangda" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u653E\u5927")])]) : e._e(), e.relationGraph.options.allowShowZoomMenu ? t("div", { staticStyle: { float: "left", "margin-top": "0px", height: "20px", width: "40px", "border-top": "0px", "border-bottom": "0px", "background-color": "#efefef", color: "#262626", "font-size": "10px", "text-align": "center", "line-height": "20px" }, on: { click: e.printGraphJsonData } }, [e._v(e._s(e.relationGraph.options.canvasZoom) + "%")]) : e._e(), e.relationGraph.options.allowShowZoomMenu ? t("div", { staticClass: "c-mb-button", staticStyle: { "margin-top": "0px" }, on: { click: function(n) {
    return e.relationGraph.zoom(-20);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-suoxiao" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u7F29\u5C0F")])]) : e._e(), e.relationGraph.options.layouts.length > 1 ? t("div", { staticClass: "c-mb-button" }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-yuanquanfenxiang" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u5E03\u5C40")]), t("div", { staticClass: "c-mb-child-panel", style: { width: e.relationGraph.options.layouts.length * 70 + 6 + "px", "margin-left": e.relationGraph.options.layouts.length * -70 - 5 + "px" } }, e._l(e.relationGraph.options.layouts, function(n) {
    return t("div", { key: n.label, staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.layoutLabel === n.label }, staticStyle: { width: "70px" }, on: { click: function(i) {
      return e.switchLayout(n);
    } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-yuanquanfenxiang" } })]), t("span", { staticClass: "c-mb-text" }, [e._v(e._s(n.label))])]);
  }), 0)]) : e._e(), e.relationGraph.options.allowSwitchLineShape ? t("div", { staticClass: "c-mb-button" }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-hj2" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u7EBF\u6761")]), t("div", { staticClass: "c-mb-child-panel", staticStyle: { width: "256px", "margin-left": "-255px" } }, [t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultLineShape === 1 }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultLineShape(1);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-hj2" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u76F4\u7EBF")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultLineShape === 2 }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultLineShape(2);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjieliu" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u7B80\u6D01")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultLineShape === 6 }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultLineShape(6);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjieliu" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u751F\u52A8")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultLineShape === 5 }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultLineShape(5);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjieliu" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u9C7C\u5C3E")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultLineShape === 4 }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultLineShape(4);
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-hj2" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u6298\u7EBF")])])])]) : e._e(), e.relationGraph.options.allowSwitchJunctionPoint ? t("div", { staticClass: "c-mb-button" }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjie_connecting5" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u8FDE\u63A5\u70B9")]), t("div", { staticClass: "c-mb-child-panel", staticStyle: { width: "206px", "margin-left": "-205px" } }, [t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultJunctionPoint === "border" }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultJunctionPoint("border");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjie_connecting5" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u8FB9\u7F18")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultJunctionPoint === "ltrb" }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultJunctionPoint("ltrb");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjie_connecting5" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u56DB\u70B9")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultJunctionPoint === "tb" }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultJunctionPoint("tb");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjie_connecting5" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u4E0A\u4E0B")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", class: { "c-mb-button-on": e.relationGraph.options.defaultJunctionPoint === "lr" }, staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.setDefaultJunctionPoint("lr");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjie_connecting5" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u5DE6\u53F3")])])])]) : e._e(), e.relationGraph.options.allowAutoLayoutIfSupport && e.relationGraph.options.isNeedShowAutoLayoutButton ? t("div", { staticClass: "c-mb-button", class: { "c-mb-button-on": e.relationGraph.options.autoLayouting }, attrs: { title: e.relationGraph.options.autoLayouting ? "\u70B9\u51FB\u505C\u6B62\u81EA\u52A8\u5E03\u5C40" : "\u70B9\u51FB\u5F00\u59CB\u81EA\u52A8\u8C03\u6574\u5E03\u5C40" }, on: { click: e.toggleAutoLayout } }, [e.relationGraph.options.autoLayouting ? t("svg", { staticClass: "c-loading-icon rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-lianjiezhong" } })]) : t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-zidong" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u81EA\u52A8")])]) : e._e(), e.relationGraph.options.allowShowRefreshButton ? t("div", { staticClass: "c-mb-button", on: { click: e.refresh } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-ico_reset" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u5237\u65B0")])]) : e._e(), e.relationGraph.options.allowShowDownloadButton ? t("div", { staticClass: "c-mb-button" }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-ziyuan" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("\u4E0B\u8F7D")]), t("div", { staticClass: "c-mb-child-panel", style: { width: e.downloadPanelWidth + "px", "margin-left": e.downloadPanelWidth * -1 + "px" } }, [t("div", { staticClass: "c-mb-button c-mb-button-c", staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.downloadAsImage("png");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-tupian" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("PNG")])]), t("div", { staticClass: "c-mb-button c-mb-button-c", staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.relationGraph.downloadAsImage("jpg");
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-tupian" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("JPG")])]), e.relationGraph.listeners.onDownloadExcel ? t("div", { staticClass: "c-mb-button c-mb-button-c", staticStyle: { width: "50px" }, on: { click: function(n) {
    return e.onDownloadExcel();
  } } }, [t("svg", { staticClass: "rg-icon", attrs: { "aria-hidden": "true" } }, [t("use", { attrs: { "xlink:href": "#icon-ziyuan" } })]), t("span", { staticClass: "c-mb-text" }, [e._v("Excel")])]) : e._e()])]) : e._e()]);
}, qt = [];
const Kt = {
  name: "GraphMiniToolBar",
  props: {
    relationGraph: {
      mustUseProp: !0,
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      height: 275,
      hits: 0,
      downloadPanelWidth: 106
    };
  },
  mounted() {
    this.relationGraph.listeners.onDownloadExcel !== null && (this.downloadPanelWidth += 50), this.relationGraph.options.layouts.length > 1 && (this.height -= 40);
  },
  methods: {
    refresh() {
      this.relationGraph.refresh();
    },
    switchLayout(e) {
      u("change layout:", e), Ze(e, this.relationGraph.options), this.refresh();
    },
    toggleAutoLayout() {
      this.relationGraph.startAutoLayout();
    },
    onDownloadExcel() {
      this.relationGraph.listeners.onDownloadExcel();
    },
    printGraphJsonData() {
      this.hits++, setTimeout(() => {
        this.hits > 0 && this.hits--;
      }, 2e3), this.hits > 5 && (this.hits = 0, this.relationGraph.printGraphJsonData());
    }
  }
}, pe = {};
var Qt = /* @__PURE__ */ E(
  Kt,
  Xt,
  qt,
  !1,
  eo,
  "0e337616",
  null,
  null
);
function eo(e) {
  for (let o in pe)
    this[o] = pe[o];
}
const to = /* @__PURE__ */ function() {
  return Qt.exports;
}();
var oo = function() {
  var e = this, o = e.$createElement, t = e._self._c || o;
  return t("div", { ref: "seeksRelationGraph", staticStyle: { "box-sizing": "border-box" }, style: { width: "100%", height: "100%" } }, [e.relationGraph && e.relationGraph.options ? [e.relationGraph.options.showDebugPanel ? t("GraphDebugPanel", { attrs: { "relation-graph": e.relationGraph } }) : e._e(), e.relationGraph.options.allowShowMiniToolBar === !0 ? e._t("miniToolBar", function() {
    return [t("GraphMiniToolBar", { attrs: { "relation-graph": e.relationGraph } })];
  }, { relationGraph: e.relationGraph }) : e._e(), e.relationGraph.options.allowShowMiniView === !0 ? e._t("miniViewPanel", function() {
    return [t("GraphMiniView", { attrs: { "relation-graph": e.relationGraph } })];
  }, { relationGraph: e.relationGraph }) : e._e(), e._t("graph-plug", null, { relationGraph: e.relationGraph }), t("RGCanvas", { attrs: { "relation-graph": e.relationGraph }, scopedSlots: e._u([{ key: "node", fn: function(n) {
    var i = n.node;
    return [e._t("node", null, { node: i, relationGraph: e.relationGraph })];
  } }, { key: "line", fn: function(n) {
    var i = n.line, s = n.link;
    return [e._t("line", null, { line: i, link: s, relationGraph: e.relationGraph })];
  } }, { key: "canvas-plug", fn: function() {
    return [e._t("canvas-plug", null, { relationGraph: e.relationGraph })];
  }, proxy: !0 }], null, !0) })] : e._e()], 2);
}, no = [];
const io = {
  name: "SeeksRelationGraph",
  components: { GraphMiniToolBar: to, GraphMiniView: Yt, RGCanvas: Bt, GraphDebugPanel: Vt },
  props: {
    options: {
      mustUseProp: !1,
      default: () => ({}),
      type: Object
    },
    relationGraphCore: {
      mustUseProp: !1,
      default: null,
      type: Function
    },
    onNodeClick: {
      mustUseProp: !1,
      default: () => () => {
      },
      type: Function
    },
    onNodeExpand: {
      mustUseProp: !1,
      default: () => () => {
      },
      type: Function
    },
    onNodeCollapse: {
      mustUseProp: !1,
      default: () => () => {
      },
      type: Function
    },
    onLineClick: {
      mustUseProp: !1,
      default: () => () => {
      },
      type: Function
    },
    onDownloadExcel: {
      mustUseProp: !1,
      default: null,
      type: Function
    },
    onImageDownload: {
      mustUseProp: !1,
      default: null,
      type: Function
    },
    onImageSaveAsFile: {
      mustUseProp: !1,
      default: null,
      type: Function
    }
  },
  data() {
    return {
      relationGraph: null,
      graphSetting: null
    };
  },
  created() {
    window && (window.relationGraphDebug = this.options.debug), u("---------------------------graph created---------------------------", this), console.log(
      `%c relation-graph %c Version v${ge} %c More info: https://github.com/seeksdream/relation-graph %c`,
      "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
      "background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
      "background:#fff ; padding: 1px; border-radius: 0 3px 3px 0;  color: #41b883",
      "background:transparent"
    );
    let e = !1;
    if (!I || !I.version || I.version.startsWith("3")) {
      console.error("\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662Fvue3\u6216react\uFF0C\u4F60\u9700\u8981\u6CE8\u610Fimport\u65F6\u4F7F\u7528\u7684\u540D\u79F0\uFF1A"), console.error("vue2:import RelationGraph from 'relation-graph'"), console.error("vue3:import RelationGraph from 'relation-graph/vue3'"), console.error("react:import RelationGraph from 'relation-graph/react'");
      return;
    }
    I.version.slice(0, 4) === "2.5." && (e = !0), I.version.slice(0, 4) === "2.6." && Number.parseInt(I.version.split(".")[2]) <= 12 && (e = !0), e && console.error(`\u60A8\u7684Vue\u7248\u672C\uFF1A${I.version}\u6CE8\u610F\uFF1A\u5F53\u4F60\u4F7F\u7528\u7684vue\u7248\u672C\u7B49\u4E8E\u4F4E\u4E8E2.6.12\u65F6\uFF0C\u56FE\u8C31\u4F1A\u663E\u793A\u4E0D\u6B63\u5E38\uFF0C\u53C2\u8003\u8FD9\u4E2A\u8FDE\u63A5\u89E3\u51B3\u8FD9\u4E2A\u95EE\u9898\uFF1Ahttps://github.com/seeksdream/relation-graph/issues/113`), D || console.error("[relation-graph]Please introduce component screenfull, for example:https://cdnjs.cloudflare.com/ajax/libs/screenfull.js/5.1.0/screenfull.min.js"), me || console.error("[relation-graph]Please introduce component html2canvas, for example:https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js");
  },
  mounted() {
    u("---------------------------graph mounted---------------------------");
    const e = {
      onNodeClick: this.onNodeClick,
      onNodeExpand: this.onNodeExpand,
      onNodeCollapse: this.onNodeCollapse,
      onLineClick: this.onLineClick,
      onDownloadExcel: this.onDownloadExcel,
      onImageDownload: this.onImageDownload,
      onImageSaveAsFile: this.onImageSaveAsFile
    }, o = this.relationGraphCore || new Ge(this.options, e);
    o.setDom(this.$refs.seeksRelationGraph), o.ready(), this.relationGraph = o, this.graphSetting = this.relationGraph.options, D.on("change", this.onFullscreen);
  },
  beforeUnmount() {
    u("---------------------------graph beforeDestroy---------------------------"), D.off("change", this.onFullscreen), this.$refs.seeksRelationGraph.remove();
  },
  updated() {
    u("---------------------------graph updated---------------------------");
  },
  methods: {
    onFullscreen() {
      this.relationGraph.fullscreen(D.isFullscreen);
    },
    getInstance() {
      return this.relationGraph;
    },
    setOptions(e, o) {
      this.relationGraph.setOptions(e, o);
    },
    setJsonData(e, o, t) {
      arguments.length === 2 && typeof o == "function" && (t = o, o = !0), this.relationGraph.setJsonData(e, o, (n) => {
        this.$nextTick(() => {
          this.relationGraph.playShowEffect(() => {
            t && t(n);
          });
        });
      });
    },
    appendJsonData(e, o, t) {
      arguments.length === 2 && typeof o == "function" && (t = o, o = !0), this.relationGraph.appendJsonData(e, o, t);
    },
    setLayouter(e) {
      this.relationGraph.setLayouter(e);
    },
    onGraphResize(e, o) {
      this.relationGraph.refreshNVAnalysisInfo();
    },
    refresh() {
      this.relationGraph.refresh();
    },
    focusRootNode() {
      this.relationGraph.focusRootNode();
    },
    focusNodeById(e) {
      return this.relationGraph.focusNodeById(e);
    },
    getNodeById(e) {
      return this.relationGraph.getNodeById(e);
    },
    removeNodeById(e) {
      return this.relationGraph.removeNodeById(e);
    },
    getNodes() {
      return this.relationGraph.getNodes();
    },
    getLinks() {
      return this.relationGraph.getLinks();
    },
    getGraphJsonData() {
      return this.relationGraph.getGraphJsonData();
    },
    getGraphJsonOptions() {
      return this.relationGraph.getGraphJsonOptions();
    }
  }
}, _e = {};
var so = /* @__PURE__ */ E(
  io,
  oo,
  no,
  !1,
  ao,
  "5a08b328",
  null,
  null
);
function ao(e) {
  for (let o in _e)
    this[o] = _e[o];
}
const U = /* @__PURE__ */ function() {
  return so.exports;
}(), ro = Ge, lo = {
  BidirectionalTreeLayouter: ve,
  CenterLayouter: we,
  CircleLayouter: be,
  FixedLayouter: Ce,
  ForceLayouter: ee
}, co = De, ho = He, fo = je, Me = (e, o) => {
  e.component("RelationGraph", U), e.component("SeeksRelationGraph", U);
};
typeof window != "undefined" && window.Vue && Me(window.Vue);
const go = ne(oe({}, U), {
  RelationGraphCore: ro,
  Layout: lo,
  RGOptions: co,
  RGLink: ho,
  RGNode: fo,
  version: ge,
  install: Me
});
export {
  lo as Layout,
  ho as RGLink,
  fo as RGNode,
  co as RGOptions,
  ro as RelationGraphCore,
  go as default
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/relation-graph/vue2/relation-graph.mjs
// module id = null
// module chunks = 